import { ROOM_INFO_TRANSLATIONS } from './roomsInfo';

const FIN = {
  'messenger_v2.call.share_screen': "Jaa näyttö",
  'messenger_v2.call.ongoing': "Ryhmäpuhelu käynnissä",
  'messenger_v2.call.ongoing_video': "Videopuhelu käynnissä",
  'messenger_v2.call.ongoing_voice': "Äänipuhelu käynnissä",
  'messenger_v2.call.more_members': "{count} muuta osallistujaa",
  'messenger_v2.call.mute_sound': "Poista ääni käytöstä",
  'messenger_v2.call.unmute_sound': "Ota ääni käyttöön",
  'messenger_v2.call.sound_off': "Ääni pois",
  'messenger_v2.call.live_members': "{count} osallistujaa puhelussa",
  'messenger_v2.call.waiting_members': "Odotetaan osallistujia",
  'messenger_v2.call.joining': "Liitytään…",
  'messenger_v2.call.return_to_call': "Palaa puheluun",
  'messenger_v2.call.rejoin_failed': "Puheluun liittyminen epäonnistui. Yritä uudelleen.",
  'messenger_v2.call.stop_sharing': "Lopeta jakaminen",
  'messenger_v2.call.share_pending': "Päivitetään näytön jakamista",
  'messenger_v2.call.share_unsupported': "Tämä selain ei voi jakaa näyttöä. Voit silti katsella jaettuja näyttöjä.",
  'messenger_v2.call.share_denied': "Näytön jakaminen peruutettiin tai lupa evättiin. Puhelu on edelleen yhdistetty.",
  'messenger_v2.call.share_failed': "Näytön jakamista ei voitu aloittaa tai lopettaa oikein. Yritä uudelleen.",
  'messenger_v2.call.view_screen': "Näytä käyttäjän {name} näyttö",
  'messenger_v2.call.expand_screen': "Suurenna jaettu näyttö",
  'messenger_v2.call.exit_expand_screen': "Poistu suurennetusta näkymästä",
  'messenger_v2.pin.pin': 'Kiinnitä keskustelu',
  'messenger_v2.pin.unpin': 'Irrota keskustelu',
  'messenger_v2.pin.pinned': 'Kiinnitetty keskustelu',
  'messenger_v2.pin.failed': 'Keskustelun kiinnitystä ei voitu päivittää. Yritä uudelleen.',
  'messenger_v2.self.name': '{name} (Sinä)',
  'messenger_v2.self.subtitle': 'Lähetä viesti itsellesi',
  ...ROOM_INFO_TRANSLATIONS.FIN,
  'tabs.more': 'Lisää',
  'header.footer.short.find_grave': 'Etsi hauta',
  'header.footer.short.how': 'Miten',
  'header.footer.short.about': 'Tietoa',
  'notifications.general.title': 'Ilmoitus',
  'notifications.auth.title': 'Tunnistautuminen',
  'notifications.requests.title': 'Pyynnöt',
  'notifications.gravesHub.title': 'Hautakeskus',
  'notifications.graves.title': 'Haudat',
  'notifications.memoryWall.title': 'Muistoseinä',
  'notifications.payments.title': 'Maksut',
  'notifications.settings.title': 'Asetukset',
  'notifications.groups.title': 'Ryhmät',
  'notifications.sparks.title': 'Sparks',
  'notifications.store.title': 'Kauppa',
  'notifications.purchase.title': 'Osto',
  'notifications.userProfile.title': 'Minun Valoni',
  'notifications.messaging.title': 'Viestit',
  'messenger.header.unseen_messages': 'Viestit, {count} uutta',
  'notifications.messages.title': 'Viestit',
  'notifications.connectRequests.title': 'Yhteyspyynnöt',
  'notifications.designSystem.title': 'Design-järjestelmä',
  'notifications.subscription.title': 'Tilaus',
  'notifications.comments.title': 'Kommentit',
  'notifications.familyTree.title': 'Sukupuu',
  notifications_page_title: 'Ilmoitukset',
  notifications_see_all: 'Katso kaikki',
  worthy_calendar_precision_year: 'Vuosi',
  worthy_calendar_precision_month: 'Kuukausi',
  worthy_calendar_precision_date: 'Päivä',
  worthy_calendar_precision_heading: 'Valitse päivämäärän tarkkuus',
  worthy_calendar_unset: 'Päivämäärää ei ole valittu',
  worthy_calendar_unset_time: 'Ei aikaa valittuna',
  worthy_calendar_selection_value: '{iso} ({precision})',
  worthy_calendar_select_month: 'Valitse kuukausi',
  worthy_calendar_select_year: 'Valitse vuosi',
  worthy_calendar_select_day: 'Valitse päivä',
  worthy_calendar_previous: 'Edellinen',
  worthy_calendar_next: 'Seuraava',
  worthy_calendar_selected_label: 'Valittu:',
  worthy_calendar_valid_years: 'Sallitut vuodet: {min}–{max}',
  worthy_calendar_choose_date: 'Valitse päivämäärä',
  worthy_calendar_choose_time: 'Valitse aika',
  worthy_calendar_choose_datetime: 'Valitse päivämäärä ja aika',
  worthy_calendar_close: 'Sulje',
  worthy_calendar_cancel: 'Peruuta',
  worthy_calendar_apply: 'Käytä',
  worthy_calendar_default_label: 'Tapahtuman päivämäärä',
  worthy_calendar_default_time_label: 'Tapahtuman aika',
  worthy_calendar_default_datetime_label: 'Tapahtuman päivämäärä ja aika',
  worthy_calendar_required: 'Valitse päivämäärä',
  worthy_calendar_required_time: 'Valitse aika',
  worthy_calendar_required_datetime: 'Valitse päivämäärä ja aika',
  worthy_calendar_time_heading: 'Valitse aika',
  error_boundary_title: 'Päivitimme Verkkohaudan',
  error_boundary_subtitle:
    'Lataa sivu uudelleen jatkaaksesi. Jos se jatkuu, yritä uudelleen hetken kuluttua.',
  error_boundary_reload: 'Lataa nyt',
  error_boundary_show_details: 'Näytä lisätiedot',
  error_boundary_hide_details: 'Piilota lisätiedot',
  auth_mobileNumber: 'Matkapuhelinnumero',
  auth_password: 'Salasana',
  auth_passwordPlaceholder: 'Anna salasana',
  auth_show_password: 'Näytä salasana',
  auth_hide_password: 'Piilota salasana',
  auth_rememberMe: 'Muista minut tällä laitteella',
  sign_in: 'Kirjaudu sisään',
  auth_login: 'Kirjaudu sisään',
  auth_get_newsletr: 'Vastaanota uutisia ja päivityksiä Verkkohautailta',
  auth_notRegistered: 'Eikö sinulla ole tiliä? ',
  auth_alreadyRegistered: 'Onko sinulla jo tili? ',
  auth_login_here: 'Kirjaudu sisään',
  register: 'Luo tili',
  auth_register: 'Luo tili',
  'family_tree_guest.eyebrow': 'Sukupuu',
  'family_tree_guest.title': 'Näe, miten perhe liittyy yhteen',
  'family_tree_guest.intro':
    'Sukupuu antaa yhteisen paikan koota ihmiset, haudat ja suhteet yhteen. Näin on helpompi ymmärtää yhteyksiä, säilyttää tarinoita ja viedä niitä eteenpäin.',
  'family_tree_guest.primary_cta': 'Kirjaudu jatkaaksesi',
  'family_tree_guest.secondary_cta': 'Luo tili',
  'family_tree_guest.note': 'Kirjaudu sisään aloittaaksesi sukupuun rakentamisen.',
  'family_tree_guest.panel_label': 'Mitä voit tehdä',
  'family_tree_guest.feature_1':
    'Yhdistä ihmisiä ja näe, miten suhteita syntyy myös matkan varrella.',
  'family_tree_guest.feature_2': 'Löydä lahjoja ja aisteja, jotka toistuvat sukupolvien läpi.',
  'family_tree_guest.feature_3':
    'Perhe voi vahvistaa sen, minkä se tunnistaa, jolloin ymmärrys selkiytyy ja vahvistuu ajan myötä.',
  'family_tree_guest.feature_1_title': 'Rakenna ja anna puun kasvaa',
  'family_tree_guest.feature_2_title': 'Lahjat ja aistit perheessä',
  'family_tree_guest.feature_3_title': 'Perheen vahvistama',
  'family_tree_guest.preview_person_name': 'Elias Johansen',
  'family_tree_guest.preview_person_meta': 'Syntynyt 1984 • osa samaa sukulinjaa',
  'family_tree_guest.preview_relation_1': 'Veli',
  'family_tree_guest.preview_relation_2': 'Vanhempi',
  'family_tree_guest.preview_grave_name': 'Lorense Johansen',
  'family_tree_guest.preview_grave_meta': 'Hautasivu liitetty samaan perheeseen',
  'family_tree_guest.preview_grave_body':
    'Näe, miten ihmiset ja haudat liittyvät toisiinsa perheessä ajan myötä.',
  'family_tree_guest.preview_tree_root': 'Elias Johansen',
  'family_tree_guest.preview_tree_root_meta':
    'Voit aloittaa yhdestä ihmisestä ja rakentaa ulospäin',
  'family_tree_guest.preview_tree_left': 'Liv Johansen',
  'family_tree_guest.preview_tree_left_meta': 'Äiti',
  'family_tree_guest.preview_tree_right': 'Oskar Johansen',
  'family_tree_guest.preview_tree_right_meta': 'Isä',
  'family_tree_guest.detail_title': 'Mitä voit tehdä sukupuussa',
  'family_tree_guest.detail_intro': 'Sukupuu yhdistää ihmiset, haudat ja sukulinjat.',
  'family_tree_guest.preview_status': 'Lahja tunnistettu',
  'family_tree_guest.preview_hint': 'Maren tunnisti Delegation henkilössä Elias Johansen.',
  auth_forgotPassword: 'Tarvitsetko apua salasanan kanssa?',
  login_phone_verification_message:
    'Puhelimella kirjautuminen edellyttää, että tilin sähköpostiosoite on vahvistettu.',
  login_phone_email_verification_message:
    'Vahvista tilin sähköpostiosoite ennen kirjautumista puhelinnumerolla. Jatka kirjautumalla sähköpostiosoitteellasi.',
  login_send_verification_code: 'Lähetä vahvistussähköposti',
  login_phone_code_sent: 'Vahvistussähköposti on lähetetty.',
  login_phone_code_verified: 'Sähköpostiosoite on vahvistettu. Kirjaudutaan sisään...',
  auth_too_many_attempts:
    'Liian monta kirjautumisyritystä. Odota hetki ennen kuin yrität uudelleen.',
  phone_verification_uses_email: 'Puhelimen vahvistaminen tapahtuu sähköpostitse.',
  auth_welcome: 'Tervetuloa takaisin',
  auth_toNettgrav: 'osoitteeseen verkkohauta.fi',
  auth_enterPhoneNumber: 'Anna puhelinnumerosi',
  auth_emailOrPhone_label: 'Sähköposti tai puhelinnumero',
  auth_emailOrPhone_placeholder: 'Syötä sähköposti tai puhelinnumero',
  auth_emailOrPhone_required: 'Sähköposti tai puhelinnumero on pakollinen',
  auth_phone_hint:
    'Kirjoita paikallinen numero tai käytä kansainvälistä muotoa, esim. +47 45007009.',
  auth_man: 'Mies',
  auth_woman: 'Nainen',
  auth_other: 'Muu',
  auth_acceptConditions: 'Hyväksyn vastaanottavani SMS-viestejä Verkkohautailta ja hyväksyn',
  auth_termsAndCondition: 'käyttöehdot',
  auth_next: 'Seuraava',
  auth_receivedSMS: 'Saat nyt viestin',
  auth_otpCode: 'Anna kertakäyttökoodi',
  auth_received: 'Etkö ole saanut kertakäyttökoodia?',
  auth_newOtp: 'Voit lähettää uuden kertakäyttökoodin 00:',
  auth_sendNew: 'Lähetä uusi',
  auth_confirm: 'Vahvista',
  confirm: 'Vahvista',
  auth_passwordSentTo: 'Salasana lähetettiin osoitteeseen:',
  auth_yourName: 'Nimesi',
  auth_enterFullName: 'Anna nimesi',
  auth_enterPasswordAgain: 'Anna salasana uudelleen',
  auth_passwordMessage: 'Käytä vähintään 7 merkkiä ja 3 neljästä kategoriasta:',
  auth_capitalLetter: '⚙︎ Suuri kirjain',
  auth_smallLetters: '⚙︎ Pienet kirjaimet',
  auth_digits: '⚙︎ Numerot',
  auth_characters: '⚙︎ Erikoismerkit',
  auth_signupInvitation: 'Sinut kutsuttiin Conscious-tilaukseen kohteesta',
  auth_resetPassword: 'Nollaa salasana',
  auth_resetPasswordSMS: 'Kertakäyttökoodi on lähetetty matkapuhelimeesi',
  auth_back: 'Takaisin',
  auth_send: 'Lähetä',
  auth_restOtp: 'Anna kertakäyttökoodi, joka lähetettiin numeroon {code}{phoneNumber}',
  auth_code: 'Anna koodi',
  auth_confirmPassword: 'Vahvista uusi salasana',
  auth_newPassword: 'Uusi salasana',
  auth_notSame: 'Salasanat eivät täsmää',
  auth_save: 'Tallenna',
  'gravesHub.inviteFamily.title': 'Kutsu perhe mukaan huolehtimaan haudasta',
  'gravesHub.inviteFamily.submit': 'Lähetä kutsu',
  'gravesHub.inviteFamily.success':
    'Kutsu lähetetty osoitteeseen {email}. He voivat nyt auttaa huolehtimaan haudasta.',
  'gravesHub.inviteFamily.error': 'Kutsun lähettäminen epäonnistui. Yritä uudelleen.',
  'gravesHub.inviteFamily.loading': 'Odota, kun lataamme sivun.',
  settings_profile: 'Profiili',
  settings_personalInformation: 'Nimi ja tiedot',
  settings_payments: 'Maksut',
  settings_paymentDate: 'Päivämäärä',
  settings_paymentStatus: 'Tila',
  settings_paymentMethod: 'Maksutapa',
  settings_paymentAmount: 'Summa',
  settings_emptyPayments: 'Maksuja ei ole saatavilla tällä hetkellä',
  settings_subscription: 'Tilaus',
  settings_members: 'Perhe ja ystävät',
  settings_giftInvitations: 'Kutsu lahjalla',
  settings_notifications: 'Ilmoitukset',
  settings_security: 'Tietoturva',
  settings_title: 'Asetukset',
  settings_back_to_menu: 'Takaisin asetuksiin',
  settings_load_error_title: 'Asetuksia ei voitu ladata',
  settings_load_error_body: 'Tarkista yhteys ja yritä uudelleen.',
  settings_notifications_load_error_title: 'Ilmoituksia ei voitu ladata',
  settings_notifications_load_error_body: 'Ilmoitusvalintojasi ei muutettu. Yritä uudelleen.',
  settings_password_updated_success: 'Uusi salasanasi on tallennettu.',
  settings_password_invalid_error: 'Salasanaa ei voitu vaihtaa. Tarkista tiedot.',
  account_deletion_requested_success: 'Tilin poistopyyntösi on rekisteröity.',
  account_deletion_cancelled_success: 'Tilisi poistaminen on peruutettu.',
  account_deletion_update_error: 'Tilin poistamista ei voitu päivittää. Yritä uudelleen.',
  settings_enter_verification_code: 'Syötä vahvistuskoodi',
  settings_verification_code_invalid: 'Koodi ei ole oikein',
  settings_account_information: 'Tiliasetukset',
  settings_inventory: 'Kokoelmani',
  inventory_section_subtitle: 'End of Time Care käytännössä',
  inventory_empty_title: 'Lisää tuotteita kaupasta.',
  inventory_empty_description: 'Varastoasi voi käyttää kaikilla haudoilla.',
  inventory_purchase_item: 'Osta tuote',
  inventory_purchase_button: 'Siirry kauppaan',
  settings_contact: 'Ota yhteyttä Verkkohautaiin',
  settings_password: 'Salasana',
  settings_edit: 'Muokkaa',
  my_light_remove_relation: 'Poista suhde',
  settings_fullName: 'Nimi',
  settings_gender: 'Sukupuoli',
  settings_occupation: 'Ammatti',
  settings_birthday: 'Syntymäpäivä',
  settings_email: 'Sähköpostiosoite',
  settings_telephoneNumber: 'Puhelinnumero',
  settings_address: 'Osoite',
  settings_language: 'Kieli',
  settings_currency: 'Valuutta',
  settings_timeZone: 'Aikavyöhyke',
  settings_invalidEmail: 'Virheellinen sähköpostiosoite',
  settings_cancel: 'Peruuta',
  settings_currentPassword: 'Nykyinen salasana',
  settings_newPassword: 'Anna uusi salasana',
  settings_retype: 'Kirjoita salasana uudelleen',
  confirm_password: 'Vahvista salasana',
  settings_billingMethod: 'Maksutapa',
  settings_cancelSubscription: 'Peru tilaaminen',
  settings_cancel_mySubscription: 'Kyllä, peru tilaukseni',
  settings_month: 'kuukausi',
  cancelSubscription_message:
    'Olet päättämässä Verkkohauta {name} -suunnitelman. Voit silti olla täällä ilmaisella suunnitelmalla ja aloittaa uudelleen milloin tahansa.',
  reactivateSubscription_message:
    'Olet aktivoimassa Verkkohauta {name} -suunnitelman tilaustasi uudelleen. Tämä palauttaa täydet käyttöoikeudet kaikkiin suunnitelman ominaisuuksiin.',
  not_now: 'ei nyt',
  reactivate: 'Kyllä, aktivoi tilaukseni uudelleen',
  settings_nextDue: 'Seuraava maksu erääntyy',
  settings_paymentMethods: 'Maksutavat',
  settings_nextBilling: 'Seuraava automaattinen laskutus on',
  settings_mangeMethods: 'Tarkastele ja hallinnoi maksutapaasi',
  settings_emptyMethods: 'Maksutapoja ei ole vielä lisätty',
  settings_vippsHeading: 'Vippsin maksut ja sopimukset tulevat pian tänne',
  settings_manageVipps: 'Nähdäksesi ja hallinnoidaksesi sopimuksiasi',
  settings_cardEnd: 'päättyen numeroon',
  settings_remove: 'Poista',
  settings_stop: 'Lopeta',
  relation_title_for_connection: 'Mikä on suhde välillä {firstGrave} ja {secondGrave}?',
  relation_direction_title_for_connection: 'Mikä on suhde välillä {secondGrave} ja {firstGrave}?',
  settings_vippsAgreement: 'Vipps-sopimus',
  view_manage_agreements: 'Näytä ja hallinnoi sopimustasi',
  empty_agreements: 'Vipps-sopimuksia ei löytynyt',
  settings_amount: '{amount}',
  settings_subscriptionHeading: 'Tilausten hallinta',
  settings_subscriptionStatus: 'Tila',
  settings_length: 'Kesto',
  settings_nextBillingDate: 'Seuraava laskutuspäivä',
  settings_endDate: 'Päättymispäivä',
  settings_reactivateSubscription: 'Aktivoi tilaus uudelleen',
  settings_freeSubscriptionHeading: 'Aloita ilmaiseksi.',
  months: 'kuukautta',
  year: 'vuosi',
  month: 'kuukausi',
  years: 'vuosia',
  saved: 'Tallennettu',
  saved_message: '{name} on tallennettu.',
  settings_upgrade: 'Päivitä suunnitelma',
  settings_subDescription: 'Merkityksellinen elämä',
  settings_for: '– varten',
  settings_paymentInfo: 'Maksutiedot',
  settings_cardNumber: 'Kortin numero',
  settings_billingInfo: 'Laskutustiedot',
  settings_name: 'Nimi',
  settings_billingEmail: 'Sähköposti',
  settings_billingCountry: 'Maa',
  settings_postCode: 'Postinumero',
  settings_changePlan: 'Vaihda suunnitelma',
  change_plan: 'vaihda suunnitelma',
  change: 'muuta',
  change_members: 'muuta jäseniä',
  settings_noSubscription: 'Sinulla ei ole aktiivista tilausta vielä.',
  settings_clickHere: 'klikkaa tästä',
  settings_getSubscription: 'Hanki tilaus',
  settings_subscriptionPrice: 'Hinta per vuosi',
  settings_subscriptionLengths: 'Sallitut kestot',
  settings_subscriptionYears: 'Ostetut vuodet',
  settings_subscriptionFrameId: 'Kehys-ID',
  open_menu: 'Avaa valikko',
  settings_memberHeading: 'Kutsut',
  settings_receivedMembership: '(Kutsut, jotka olet saanut)',
  settings_emptyMembership: 'Ei kutsuja juuri nyt.',
  settings_subscribedPlan: 'Tilauksesi on aktivoitu. Voit tarkastella tai hallita ',
  settings_updatePlan: 'Tilauksesi on päivitetty. Voit tarkastella tai hallita ',
  settings_downgradePlan: 'Tilauksesi on alennettu. Voit tarkastella tai hallita ',
  settings_addedMember: 'Uudet jäsenet on lisätty. Voit tarkastella tai hallita ',
  payment_progress: 'Maksu käynnissä – odota hetki',
  something_wrong: 'Jokin meni pieleen. Yritä myöhemmin uudelleen',
  add_validNumber: 'Anna kelvollinen puhelinnumero',
  select_planMessage:
    'Jatkaaksesi valitse suunnitelma, joka sopii tarpeisiisi. Suunnitelmamme tarjoavat joustavuutta ja hyviä ominaisuuksia.',
  settings_memberPage: 'jäsen­sivu',
  settings_your: 'sinun.',
  settings_enable: 'suunnitelma aktivoitu',
  free: 'Ilmainen',
  conscious: 'Conscious',
  consciousPlus: 'Conscious plus',
  settings_membershipOn: '– tilaus aktiivinen',
  settings_modalSubheading: 'Suurin kaikesta on rakkaus',
  settings_modalLink: 'Kiitos, että olet täällä',
  settings_memberSubheading: 'Perhe-suunnitelmasi.',
  settings_emptyMembers: 'Sinulla ei ole tilaajajäseniä',
  settings_memberName: '{name}n perhe',
  settings_memberLength: '{length} jäsentä',
  settings_administrator: 'Ylläpitäjä',
  settings_showMembers: 'Näytä jäsenet',
  settings_familyMembers: 'Perhe',
  settings_you: 'Sinä',
  settings_connect: 'yhdistä',
  settings_setRelation: 'Aseta suhde',
  settings_selectedRelation: 'Valitse suhde',
  settings_giftHeading: 'Anna tilaus henkilölle, josta välität.',
  settings_giftFreeSubscription:
    'Sinulla on ilmainen tili. Päivitä saadaksesi kaiken ja kutsuaksesi lisää.',
  settings_seeSubscriptions: 'Päivitä',
  settings_youHave: 'Sinulla on {count} ',
  settings_inviteAgain: 'kutsua jäljellä.',
  settings_addMore: 'lisätäksesi lisää suunnitelmaasi',
  error_trigger_title: 'Virherajan testi',
  error_trigger_subtitle:
    'Napsauta painiketta laukaistaksesi renderöintivirheen ja varmistaaksesi globaalin virherajan toiminnan.',
  error_trigger_button: 'Laukaise virhe',
  settings_addMember: 'Lisää jäsen',
  settings_invitedMember: 'Kutsutut jäsenet',
  settings_emptyGiftMembers: 'Ei vastaamattomia kutsuja',
  settings_inviteTo: 'Klikkaa kutsuaksesi perhetilaukseen',
  settings_pendingSubscription: 'Tilauksesi on {status}.',
  settings_notificationsSubheading: 'Valitse, mitä haluat meiltä saada.',
  settings_notificationsTitle: 'Ilmoitusasetukset',
  settings_preferenceText: 'Ilmoituksia keskusteluista ja suorista viesteistä.',
  settings_reminders: 'Muistutukset',
  settings_remindersText: 'Merkkipäivät ja hiljaiset muistutukset.',
  settings_anniversary_marking: 'Haluan merkintöjä merkkipäiville',
  settings_anniversary_in_app: 'Näytä merkintä Verkkohaudassa',
  settings_anniversary_email: 'Lähetä minulle myös sähköpostia',
  settings_genealText: 'Uutisia ja tietoa Verkkohaudasta.',
  settings_textMessage: 'Tekstiviestit',
  settings_general: 'Yleiset päivitykset',
  delete: 'Poista',
  settings_goToAgreements: 'klikkaa tästä',
  settings_shareLink: 'Kopioi ja jaa Verkkohauta-kutsusi',
  grave_invitation_shareLink: 'Kopioi ja jaa hautauskutsu',
  settings_copyToClipboard: 'linkki kopioitu',
  discard_subheading: 'Voit jatkaa muokkaamista tai lopettaa nyt.',
  no: 'Ei',
  yes: 'Kyllä',
  invitation: 'Kutsu',
  information: 'Tiedot',
  interests: 'Kiinnostuksen kohteet',
  note: 'Muistiinpano',
  relative: 'Perhe',
  uploadingImages: 'ladataan kuvia',
  uploading: 'Ladataan',
  lifeEvent: 'Elämän tapahtuma',
  Workplace: 'Työpaikka',
  delete_modalHeading: 'Vahvista, että haluat poistaa',
  picture: 'kuva',
  paymentMethod: 'Maksutapa',
  vippsAgreement: 'Vipps-sopimus',
  settings_complete_subscription: 'Viimeistele tilaus',
  pending_message:
    'Tilaustasi ei ole valmis. Viimeistele tilaus jatkaaksesi Conscious-ominaisuuksien käyttöä.',
  pending_title: 'Maksusopimuksesi odottaa',
  stopped_title: 'Maksusopimuksesi on keskeytetty',
  stopped_message:
    'Tilaus on puutteellinen, koska maksusopimus peruttiin. Viimeistele tilaus jatkaaksesi Conscious-ominaisuuksien käyttöä.',
  expired_title: 'Maksusopimuksesi on vanhentunut',
  expired_message:
    'Tilaus on puutteellinen, koska maksusopimus vanhentui. Viimeistele tilaus jatkaaksesi Conscious-ominaisuuksien käyttöä.',
  complete_setup: 'viimeistele asennus',
  cancelled_title: 'Tilaus on peruutettu',
  cancelled_message:
    'Tilaus on peruutettu. Voit aktivoida uudelleen ennen {period_end_date} jatkaaksesi Conscious-ominaisuuksien käyttöä. Tämän jälkeen siirryt ilmaisplanille.',
  activeStopped_title: 'Maksusopimuksesi on päättynyt',
  activeStopped_message:
    'Tilausmenetelmäsi on vanhentunut. Uudista jatkaaksesi Conscious-ominaisuuksien käyttöä. Ongelmien jatkuessa tilaus siirretään ilmaisplanille laskutusjakson lopussa.',
  renew_Agreement: 'Uudista maksusopimus',
  add_card: 'Lisää maksutapa',
  Reactivate: 'Aktivoi tilaus uudelleen',
  active_title: 'Tilaus aktivoidaan pian',
  active_message:
    'Tilaustasi käsitellään ja aktivoidaan muutaman minuutin kuluessa. Kiitos kärsivällisyydestä – saat pian pääsyn Conscious-palveluihin.',
  activeExpired_title: 'Maksusopimuksesi on vanhentunut',
  activeExpired_message:
    'Tilausmenetelmäsi on vanhentunut. Uudista tai luo uusi maksusopimus jatkaaksesi Conscious-ominaisuuksien käyttöä.',
  notValid_title: 'Maksutapa vaaditaan',
  notValid_message:
    'Näyttää siltä, että maksutapasi puuttuu tai se ei ole kelvollinen. Päivitä maksutietosi keskeytyksettä varten.',
  consciousness: 'Tietoa meistä',
  about_us: 'Tietoa Verkkohautaista',
  team: 'Tarinaamme',
  careers: 'Liity tiimiin',
  features: 'Tietoa haudasta',
  available_sustainable: 'Aina saatavilla',
  maintenance_free_grave: 'Helppokäyttöinen',
  memory_album: 'Kuvat ja elämäntarinat',
  value_archive: 'Ominaisuudet ja tarinat',
  memorial_wall: 'Kestäviä hautakäyntejä',
  life_archive: 'Elämäntarinat',
  anniversary_calendar: 'Tärkeitä päivämääriä kalenteri',
  Family_values: 'Sukupuu (tulossa pian)',
  resources: 'Apua ja resursseja',
  find_grave: 'Hae',
  blog: 'Blogi',
  help_center: 'Usein kysytyt kysymykset',
  contact: 'Ota yhteyttä',
  contact_us: 'Ota yhteyttä meihin',
  business_inquiries: 'Yrityspalvelut',
  feedback: 'Jaa ajatuksesi',
  basic_information: 'Perustiedot',
  interest: 'Kiinnostus',
  notes: 'Muistiinpanot',
  passion: 'Intohimo',
  relation: 'Suhde',
  life_event: 'Elämän tapahtuma',
  subscription_invitation: 'Tilauskutsu',
  cookies_banner_text:
    'Käytämme välttämätöntä tallennusta ja omaa liikennemittaustamme Verkkohaudan toimintaan ja kehittämiseen.',
  cookies_more: 'Lue lisää',
  cookies_accept: 'Hyväksy',
  cookies_reject: 'Hylkää',
  cookies_manage: 'Muuta evästevalintaa',
  cookies_page_title: 'Evästeet ja mittaus',
  cookies_page_subtitle: 'Välttämätön tallennus ja Verkkohaudan oma liikennemittaus.',
  cookies_necessary_title: '1. Välttämätön tallennus',
  cookies_necessary_body:
    'Verkkohauta käyttää välttämätöntä paikallista tallennusta ja istuntotekniikkaa kirjautumiseen, turvallisuuteen, kieleen ja perustoimintoihin. Näitä ei voi poistaa käytöstä palvelussa, kun niitä tarvitaan käyttämääsi toimintoon.',
  cookies_first_party_title: '2. Verkkohaudan oma mittaus',
  cookies_first_party_body:
    'Laskemme sivunäyttöjä ja istuntoja omassa järjestelmässämme ymmärtääksemme palvelun kokonaiskäyttöä, havaitaksemme teknisiä ongelmia ja suodattaaksemme robotteja. Mittaus käyttää pseudonyymejä istunto- ja kävijäavaimia, sivuluokkaa, selaintyyppiä, likimääräistä maata ja IP-osoitteen määräaikaista tiivistettä. Raportteja käytetään koontitasolla eikä niitä jaeta kumppaneille käyttäjäprofiileina.',
  cookies_list_title: '3. Yhteenveto',
  cookies_list_body:
    'Välttämättömiin osiin kuuluvat Verkkohaudan istunto sekä kieli- ja näyttöasetukset. Verkkohauta ei käytä Google Analyticsia, Google Tag Manageria tai kolmansien osapuolten analytiikkaevästeitä.',
  rooms_landing_eyebrow: 'Huoneet',
  rooms_landing_title: 'Paikka kokoontua sen ympärille, mikä merkitsee.',
  rooms_landing_lead:
    'Huone kokoaa ihmiset yhteen sen ympärille, mikä merkitsee. Ei ryhmä. Ei viestiketju. Vaan huone, jossa sinä määrität sävyn, kutsut haluamasi ihmiset ja luot yhteisön jonkin aidosti tärkeän ympärille.',
  rooms_landing_coming_soon: 'Tulossa pian Verkkohautaan.',
  rooms_landing_preview_label: 'Esikatselu',
  rooms_landing_panel_quote: 'Mikään algoritmi ei päätä, kuka näkee mitä. Sinä päätät.',
  rooms_landing_open_rooms: 'Avoimet huoneet',
  rooms_landing_closed_rooms: 'Suljetut huoneet',
  rooms_landing_private_rooms: 'Yksityiset huoneet',
  rooms_landing_what_title: 'Mikä on huone?',
  rooms_landing_what_body_1:
    'Huone on yhteisö, jonka luot ajatuksen, kokemuksen, surun tai ilon ympärille. Sinä päätät, kuka on tervetullut, mistä huoneessa on kyse ja miten se pidetään turvallisena.',
  rooms_landing_what_body_2:
    'Jotkut huoneet ovat avoimia. Kaikki voivat lukea, mutta osallistuminen vaatii liittymisen. Toiset ovat suljettuja, jolloin sinä hyväksyt tulijat. Ja osa on yksityisiä, vain niille jotka kutsut itse.',
  rooms_landing_who_title: 'Kuka voi luoda huoneen?',
  rooms_landing_who_body: 'Jokainen Verkkohauta-tilin omistaja voi luoda huoneen.',
  rooms_landing_use_case_1:
    'Sinä, joka olet menettänyt jonkun ja haluat koota yhteen hänet tunteneet ihmiset.',
  rooms_landing_use_case_2: 'Sairaanhoitaja, joka haluaa tarjota läheisille turvallisen paikan.',
  rooms_landing_use_case_3: 'Psykologi tai ohjaaja, joka vetää sururyhmää.',
  rooms_landing_use_case_4: 'Ystävä, joka haluaa pitää muistohuoneen elävänä ajan yli.',
  rooms_landing_who_question: 'Kysymme vain yhtä asiaa: miten pidät huoneen turvallisena?',
  rooms_landing_support_title: 'Tue huonetta, josta välität',
  rooms_landing_support_body_1:
    'Jotkut huoneet ansaitsevat elää pitkään. Jos pidät yllä huonetta, joka merkitsee muille, voit avata sen tuelle. Arvoa löytävät voivat osallistua esimerkiksi 99 kruunulla kuukaudessa.',
  rooms_landing_support_body_2:
    'Tuki on kuukausitilaus. Verkkohauta pidättää 15 %, ja maksupalvelun kulut vähennetään ennen loppuosan maksamista sinulle.',
  rooms_landing_directions_title: 'Suunnat',
  rooms_landing_directions_body:
    'Jokainen huone kuuluu johonkin suuntaan, kategoriaan joka auttaa ihmisiä löytämään heille olennaisen. Valitset suunnan huonetta luodessa, ja huoneesi voi tulla näkyväksi niille, jotka etsivät juuri sitä mitä tarjoat.',
  rooms_landing_direction_grief: 'Suru ja menetys',
  rooms_landing_direction_relationships: 'Suhteet',
  rooms_landing_direction_life_choices: 'Elämänvalinnat',
  rooms_landing_direction_health: 'Terveys',
  rooms_landing_direction_eot: 'End of Time Consciousness',
  rooms_landing_cta_eyebrow: 'Varhainen pääsy',
  rooms_landing_cta_title: 'Huoneet ovat tulossa Verkkohautaan.',
  rooms_landing_cta_body:
    'Toimintoa ei ole vielä julkaistu kokonaan. Olemassa olevat huoneet ovat edelleen niiden käytettävissä, jotka jo käyttävät niitä.',
  rooms_landing_cta_primary: 'Luo huone',
  rooms_landing_cta_secondary: 'Lue ehdot',
  find_grave_norway: 'Etsi hauta',
  find_grave_value_statement: 'Löydä, minne joku on haudattu, ja vieraile haudalla verkossa.',
  search_grave: 'Hae nimeä',
  search_recent_title: 'Viimeisimmät haut',
  search_recent_clear: 'Tyhjennä',
  search_recent_remove: 'Poista',
  search_suggestions_title: 'Ehdotukset',
  search_searching: 'Haetaan…',
  search_no_results: 'Ei tuloksia',
  or: 'tai',
  find_grave_create_cta: 'lisää hauta',
  create_netgrave: 'luo Verkkohauta',
  netgrave: 'Verkkohauta',
  visit: 'Vieraile',
  relation_summary_self: 'Olen {relationLower}',
  relation_summary_target: '{name} on minun {relationLower}',
  relation_summary_fallback_person: 'tämä henkilö',
  visit_grave: 'Löydä se, jota ajattelet',
  wish: '',
  find_grave_practical_reason:
    'Täältä löydät hautoja kunnassa {municipalityName} ja voit olla lähellä heitä, joista välität.',
  find_grave_cemetery_practical_reason:
    '{cemeteryName} sijaitsee alueella {municipalityName}. Täällä voit etsiä hautoja ja nähdä, ketkä on haudattu hautausmaalle. Hae nimellä löytääksesi oikean hautapaikan ja vieraillaksesi haudalla verkossa.',
  find_grave_support_statement: 'Pienet teot luovat tilaa läheisyydelle ajan myötä.',
  find_grave_guest_cta_title: 'Kun löydät oikean haudan',
  find_grave_guest_cta_body: 'voit liittyä siihen, jättää merkin ja seurata ajan mittaan.',
  find_grave_guest_cta_button: 'Pidä haudasta huolta',
  find_grave_search_heading: 'Hae nimellä',
  find_grave_search_description: 'Aloita nimellä löytääksesi oikean haudan.',
  find_grave_name_placeholder: 'Kirjoita nimi, esim. Maija Meikäläinen',
  second_section_description: 'Aloita nimellä tai tutustu kuntaan ja hautausmaahan.',
  find_grave_start_hint: 'Kirjoita nimi',
  find_grave_faq_title: 'Usein kysytyt kysymykset',
  find_grave_faq_question_1: 'Miten löydän haudan?',
  find_grave_faq_answer_1:
    'Hae nimellä. Voit myös käyttää kuntaa tai hautausmaata rajataksesi tuloksia.',
  find_grave_faq_question_2: 'Voinko hakea kunnalla tai hautausmaalla?',
  find_grave_faq_answer_2:
    'Kyllä. Kirjoita kunta tai hautausmaa hakuun, tai etene valitsemalla listauksesta.',
  find_grave_faq_question_3: 'Mitä teen, jos en löydä henkilöä?',
  find_grave_faq_answer_3:
    'Kokeile toista kirjoitusasua tai hae vähemmillä sanoilla. Voit myös luoda Verkkohaudan, jos sitä ei vielä ole.',
  memorial_plaque: 'Kunnat',
  memorial_plaque_description: 'Tutustu kuntiin ja hautausmaihin.',
  archive: 'Hautausmaat',
  archive_description: 'Katso kunnan hautausmaat.',
  memory_album_description: 'Löydä sinne haudattuja henkilöitä.',
  find_municipality: 'Haudat näissä kunnissa',
  search_municipality: 'Hae kuntaa',
  find_grave_municipality_cta: 'Katso hautausmaat',
  it_is: 'Niitä on',
  find_grave_count: '{count}',
  municipality_description: 'Hae {count} kunnan joukosta ja löydä hauta, jota etsit.',
  no_results: 'Ei tuloksia haulle',
  find_cemetery: 'Valitse hautausmaa kunnassa {municipalityName}',
  find_cemetery_generic: 'Etsi hauta näiltä hautausmailta',
  search_cemetery: 'Hae hautausmaata',
  cemetery_description:
    'hautausmaata kunnassa {municipalityName}. Tutustu hautausmaihin löytääksesi sinne haudatut.',
  grave_description:
    'henkilöä on haudattu tänne. Hae nimellä löytääksesi oikean hautapaikan ja vieraillaksesi haudalla verkossa.',
  goto_grave: 'katso hauta',
  payment_due_message: 'Tilaus on aktiivinen. Maksu käsitellään. Vipps huolehtii veloituksesta.',
  payment_due_title: 'Tilaus on aktiivinen',
  find_grave_image_title: 'Hauta tarjoaa uuden näkökulman elämäämme. Omallasi',
  find_grave_text: 'on oma sivu, jossa yhteystietosi voivat esittää kysymyksiä.',
  life_page: 'Elämäsivu',
  the_life_page: 'Minun Valoni',
  first_description: 'Seuraa Kipinäsi. Täällä voit jakaa oman kipinäsi ja vastata muiden.',
  your_graves: 'Ne, joita kannat mukanasi',
  second_description: 'Henkilöt, joihin olet luonut yhteyden, liitetään Valoosi.',
  update: 'Suhteesi',
  third_description: 'Läheisesi tulevat osaksi Valoasi.',
  find_grave_last_text:
    'Tervetuloa Verkkohautaan Sosiaalinen verkosto elämän todellisille haasteille – aloitamme merkityksellisillä, saavutettavilla ja huoltovapailla haudoilla meille, jotka jatkamme elämää. Toivomme myös näkevämme sisäisen kipinäsi – elämänkokemuksesi, jotka uskallat jakaa muiden kanssa. Maailman täytyy kuulla sanasi ja ajatuksesi.',
  plans_page_heading: 'Tietoinen valinta merkitykselliseen elämään',
  plans_page_subheading:
    'Päästä irti menneestä, omaksu matka eteenpäin arvokkaimman haudan kanssa läheisillesi.',
  per_user: 'jäseneltä',
  current_members: 'Nykyiset jäsenet',
  added_members: 'Lisättävien jäsenten määrä',
  removed_members: 'Poistettavien jäsenten määrä',
  view_current_members: 'Näytä nykyiset jäsenet',
  total_members: 'Jäseniä muutoksen jälkeen',
  plan_price: 'Suunnitelman hinta',
  increment_text: 'Valitse, kuinka monta tilausta haluat itsellesi ja perheellesi',
  free_description: 'Niille, jotka haluavat hakea ja vierailla haudoilla ilmaiseksi.',
  conscious_description:
    'Conscious-jäsenyydellä tulet viralliseksi End Of Time -nikoppimateria-näkemyksen tukijaksi.',
  consciousPlus_description:
    'Conscious-tasolle, jossa korostetaan haudan etiikkaa. Hinta: 500 NOK/vuosi',
  total_user_count: '{subscriptionTotalCount} perheenjäsenen yhteissumma:',
  per_month: 'kuukaudessa',
  current_plan: 'Nykyinen suunnitelma',
  got_started: 'Aloitettu',
  free_feature_heading: 'Kaikki ominaisuudet ilmaissopimuksessa',
  conscious_feature_heading: 'Kaikki ominaisuudet ilmaissopimuksessa + lisäominaisuuksia',
  conscious_plus_feature_heading: 'Kaikki ominaisuudet Conscious-sopimuksessa + lisäominaisuuksia',
  feature_memory_album: 'Muistoalbumi',
  feature_purposes: 'Tarkoitukset',
  feature_end_of_time: 'End Of Time -kolikko',
  feature_family_tree: 'Sukupuu',
  feature_testament: 'Testamentti',
  feature_groups: 'Ryhmät (yhteisöt)',
  feature_Shop: 'Läsnäolo',
  feature_Sparks: 'Sparks',
  feature_life_page: 'Valoni',
  feature_search_grave: 'Etsi hautaa',
  feature_create_grave: 'Luo Spark',
  question_answer: 'Kysymykset ja vastaukset',
  feature_life_archive: 'Elämäarkisto',
  feature_anniversary_calendar: 'Juhlavuuskalenteri',
  feature_memory_wall: 'Muistoseinä',
  feature_value_archive: 'Ominaisuudet',
  benefits_1_title: 'Rakkaus jatkuu',
  benefits_1_description:
    'Jokainen conscious-hauta on paikka, jossa rakkaus elää – arvokkaasti, lämpimästi ja merkityksellisesti.',
  benefits_2_title: 'Tukee elämää pelastavaa työtä',
  benefits_2_description:
    'Panoksesi menee suoraan tutkimukseen ja kehitykseen, jotta ymmärrämme ja voimme voittaa kuolemaa aiheuttavat tekijät.',
  benefits_3_title: 'Merkityksellinen hauta',
  benefits_3_description:
    'Kukista ja kynttilöistä todelliseen toimintaan. Conscious-haudat muovaavat parempaa tulevaisuutta.',
  benefits_4_title: 'Kohti maailmaa ilman ei-toivottua kuolemaa',
  benefits_4_description:
    'Yhdessä luomme toivoa. Jokainen hauta vie meidät askeleen lähemmäs turvallisempaa ja ehompaa maailmaa.',
  benefits_title: 'Hyitä syitä valita Conscious Verkkohautailla',
  faqs_1_question: 'Mitä maksutapoja hyväksytte?',
  faqs_1_answer: 'Hyväksymme luotto- ja pankkikortit (Visa, Mastercard) sekä Vipps.',
  faqs_2_question: 'Onko muita maksuja, joista minun pitäisi tietää?',
  faqs_2_answer: 'Piilokuluja ei ole. Voit hallita kaikkia hautoja ilman lisäkuluja.',
  faqs_3_question: 'Kuinka päivitän maksutietoni?',
  faqs_3_answer: 'Päivitäksesi maksutietosi, mene tilisi asetuksiin ja valitse Tilaus-välilehti.',
  faqs_4_question: 'Mitä tapahtuu maksun jälkeen?',
  faqs_4_answer:
    'Maksun jälkeen saat vahvistusilmoituksen Verkkohautailta, joka kertoo tilauksesi olevan aktiivinen.',
  faqs_5_question: 'Mikä on Free- ja Conscious-sopimuksen ero?',
  faqs_5_answer:
    'Ilmaisversio tarjoaa viisi hakua ja viisi muistoa. Conscious tarjoaa rajattoman pääsyn kaikkiin ominaisuuksiin sekä uusiin, lisättyihin ominaisuuksiin.',
  faqs_6_question: 'Kenelle Conscious-suunnitelma sopii?',
  faqs_6_answer:
    'Conscious on niille, jotka haluavat elämänsä merkityksellisimmäksi. Se vapauttaa vanhoista oletuksista ja rutiineista, ja tukee matkaasi kaikkialla, missä rakkaus on.',
  update_modal_change_plan: 'Vaihda {name}-suunnitelma',
  waite_for_validation: 'Odota, kun vahvistamme tilaustasi',
  add_members: 'Lisää jäseniä',
  remove_members: 'Poista jäseniä',
  allowed_members: 'Sallittu jäsenten määrä',
  how_many_add: 'Kuinka monta jäsentä haluat lisätä?',
  how_many_remove: 'Kuinka monta jäsentä haluat poistaa?',
  not_remove_all: 'Jätä vähintään yksi jäsen.',
  updated_price: 'Päivitetty hinta muutosten jälkeen',
  remaining_members: 'Jäljellä olevien jäsenten määrä',
  total_price: 'Kokonaishinta',
  extra_user: 'Lisäksi {subscriptionTotalCount} perheenjäsenelle lisämaksu',
  process_payment: 'Siirry maksamaan',
  continue: 'Jatka',
  subscription_members: 'Tilausjäsenet',
  remove_subscription_members: 'Poista tilausjäsenet valitsemalla Poista',
  subscription_invitation_members: 'Tilauskutsut',
  remove_invitation_members: 'Poista tilauskutsu valitsemalla Poista',
  downgrade_plan: 'Alenna suunnitelmaa',
  upgrade_plan: 'Nosta suunnitelmaa',
  downgrade_message: 'Poista kaikki tilausjäsenet ja kutsut jatkaaksesi alennusta',
  upgrade_message: 'Poista kaikki tilausjäsenet ja kutsut jatkaaksesi nostoa',
  close_message: 'Voit nyt sulkea ja jatkaa',
  close: 'Sulje',
  active_members: 'Aktiiviset tilausjäsenet',
  active_members_message: 'Jatkaaksesi deaktivoih yksi tai useampi jäsen.',
  active_members_empty_message: 'Ei aktiivisia jäseniä',
  active_invitations: 'Odotavat kutsut tilaukseen',
  active_invitations_message: 'Peru kutsut jatkaaksesi.',
  active_invitations_empty_message: 'Ei odottavia kutsuja',
  check_out: 'Siirry kassalle',
  select_payment_method: 'Valitse maksutapa',
  order_details: 'Tilaustiedot',
  subscription_number: 'Tilauksen määrä',
  taxes: 'Verot',
  total: 'Maksettava määrä:',
  sub_total: 'Vakiomaksu:',
  discount_title: 'Laskutusväli:',
  subscription_length: 'Suunnitelman kesto',
  discount: 'Alennus useille jäsenille:',
  renewal: 'Tilaus uusitaan automaattisesti.',
  renewal_details: 'Uusinta tapahtuu valitun laskutusvälin mukaan. Voit peruuttaa milloin tahansa.',
  payment_page_terms: 'Valitsemalla ”Seuraava” tai ”Tilaa” hyväksyt',
  terms_conditions: 'Käyttöehdot.',
  terms_conditions_page_title: 'Ehdot ja edellytykset',
  terms_conditions_page_subtitle: 'Yleiset käyttöehdot ja tietosuoja verkkohauta.fi-sivustolle',
  terms_conditions_section1_title: '1. Yleistä',
  terms_conditions_section1_body:
    'Verkkohauta.fi on digitaalinen kohtaamispaikka, jossa perhe ja ystävät voivat olla lähellä vainajaa. Palvelu tarjoaa pilvipohjaisen haudansivun, jossa läheiset voivat sytyttää kynttilöitä, jakaa kuvia, tarinoita ja muita sisältöjä silloin kun tarve syntyy. Verkkohauta tarjoaa mahdollisuuden luoda ja vierailla Verkkohaudassa sekä käyttää Gravalbumia, Muistotaulua, Arvoarkistoa ja Elämäarkistoa. Joihinkin palvelun osiin voidaan soveltaa erillisiä ehtoja – esimerkiksi hintoja, maksutapoja tai sopimuskausia – jotka on kuvattu verkkosivustolla. Jos erilliset ehdot poikkeavat näistä yleisistä ehdoista, erilliset ehdot ovat etusijalla.',
  terms_conditions_section2_title: '2. Rekisteröityminen, käyttäjätunnus ja salasana',
  terms_conditions_section2_body:
    'Palvelun käyttö riippuu siitä, hallinnoitko fyysistä hautaa vai vierailetko siellä digitaalisesti. Voit luoda tilin verkkohauta.fi-sivustolla tai muissa palveluissa ja sosiaalisessa mediassa siltä osin kuin Verkkohauta sen mahdollistaa. Rekisteröityessäsi kolmannen osapuolen kautta annat suostumuksen siihen, että Verkkohauta kerää tarvittavat tiedot tilin luomista varten. Vastaat itse siitä, että antamasi tiedot ovat oikeita. Salasana on henkilökohtainen eikä sitä saa jakaa. Jos epäilet tilisi luvattoman käyttöä, ota välittömästi yhteyttä Nettgrav AS:ään ja vaihda salasanasi. Palvelun suojaamiseksi Nettgrav AS voi pyytää sinua vaihtamaan salasanan milloin tahansa.',
  terms_conditions_section3_title: '3. Palvelun käyttö',
  terms_conditions_section3_body:
    'Olet vastuussa siitä, miten käytät palvelua, ja sitä saa käyttää vain tarkoitukseensa. Sitoudut pitämään Nettgrav AS:n korvausvastuusta vapaana kaikista oikeudellisista vaatimuksista tai vahingoista, jotka johtuvat palvelun ja tarjottujen toimintojen käytöstäsi.',
  terms_conditions_section4_title: '4. Hinnat ja maksut',
  terms_conditions_section4_body:
    'Ajantasaiset hinnat ilmoitetaan verkkohauta.fi-sivustolla ja niitä voidaan päivittää tarpeen mukaan. Hinnat sisältävät soveltuvat verot silloin kun laki niin edellyttää.',
  terms_conditions_section5_title: '5. Vastuunrajoitus',
  terms_conditions_section5_body:
    'Ellei toisin nimenomaisesti todeta, Nettgrav AS ei vastaa palvelussa julkaistusta tai sen kautta lähetetystä sisällöstä. Verkkohauta ei hallinnoi ulkoisia verkkosivustoja, joihin linkitämme, eikä vastaa niiden sisällöstä. Sovellettavan lain sallimissa rajoissa Nettgrav AS ei vastaa vahingoista tai menetyksistä, jotka johtuvat toimistasi tai laiminlyönneistäsi palvelun yhteydessä.',
  terms_conditions_section6_title: '6. Muutokset',
  terms_conditions_section6_body:
    'Nettgrav AS voi muuttaa palvelun sisältöä ja laajuutta sekä tarkistaa hintoja ja muita ehtoja. Jos muutokset ovat olennaisia ja sinulle haitallisia, Nettgrav AS ilmoittaa niistä kirjeellä, tekstiviestillä tai sähköpostilla rekisteröimääsi osoitteeseen viimeistään 30 päivää ennen muutosten voimaantuloa. Jos et hyväksy uusia ehtoja, voit lopettaa jäsenyytesi milloin tahansa.',
  terms_conditions_section7_title: '7. Sopimuksen kesto ja päättäminen',
  terms_conditions_section7_body:
    'Voit milloin tahansa poistaa käyttäjätilisi ja mahdolliset tilauksesi. Jos tarvitset apua, lähetä sähköpostia osoitteeseen kontakt@nettgrav.no.',
  terms_conditions_section8_title: '8. Reklamaatio',
  terms_conditions_section8_body:
    'Jos haluat tehdä reklamaation, ilmoita siitä Nettgrav AS:lle sähköpostitse, puhelimitse, kirjeitse tai verkkosivuston kautta viiden päivän kuluessa toimituksesta. Kukat ja kasvit katsotaan tuoretavaraksi eikä niihin sovelleta peruutusoikeutta.',
  terms_conditions_section9_title: '9. Tietosuoja',
  terms_conditions_section9_1_title: '9.1 Yleistä',
  terms_conditions_section9_1_paragraph1:
    'Henkilötietojesi suoja on meille tärkeää, ja siksi kerromme seuraavista seikoista:',
  terms_conditions_section9_1_paragraph2:
    'Nettgrav AS, Damstredet 3, 0177 Oslo (y-tunnus 912 857 336) on rekisterinpitäjä niille henkilötiedoille, joita käsitellään palvelun ja tuotteiden toimittamisen yhteydessä. Nettgrav AS käsittelee tietoja Norjan lainsäädännön mukaisesti.',
  terms_conditions_section9_1_paragraph3:
    'Rekisteröimällä käyttäjätilin hyväksyt, että Nettgrav AS käsittelee henkilötietoja näiden ehtojen ja yksityisyydensuojakäytännön mukaisesti.',
  terms_conditions_section9_2_title: '9.2 Käsittelyn tarkoitus',
  terms_conditions_section9_2_body:
    'Nettgrav AS käsittelee henkilötietoja toimittaakseen palvelut, analysoidakseen niiden käyttöä, hallinnoidakseen asiakassuhteita, kommunikoidakseen käyttäjien kanssa ja täyttääkseen lakisääteiset velvoitteensa.',
  terms_conditions_section9_3_title: '9.3 Mitä tietoja käsitellään?',
  terms_conditions_section9_3_body:
    'Käsittelemme rekisteröinnin yhteydessä antamiasi tietoja sekä palvelun käytön aikana syntyvää dataa. Näitä voivat olla esimerkiksi nimi, osoite, puhelinnumero, sähköpostiosoite, maksutiedot sekä vainajaan ja haudalle lisättyihin sisältöihin liittyvät tiedot.',
  terms_conditions_section9_4_title: '9.4 Tietojen luovuttaminen',
  terms_conditions_section9_4_body:
    'Nettgrav AS voi luovuttaa henkilötietoja alihankkijoille, jotka tuottavat palveluita puolestamme, kuten infrastruktuuri-, IT- tai asiakaspalveluita. Emme luovuta tietoja muille kolmansille osapuolille emmekä käytä dataasi tekoälyn kouluttamiseen.',
  terms_conditions_section9_5_title: '9.5 Tarkastus-, oikaisu- ja poistooikeus',
  terms_conditions_section9_5_body:
    'Sinulla on oikeus pyytää tietoja siitä, mitä henkilötietoja Nettgrav AS käsittelee sinusta. Voit myös pyytää tietojen oikaisua, täydentämistä tai poistamista, mikäli siihen on laillinen peruste.',
  terms_conditions_section9_6_title: '9.6 Evästeiden käyttö',
  terms_conditions_section9_6_body:
    'Käytämme verkkosivustolla evästeitä. Evästeet ovat pieniä tekstitiedostoja, jotka tallentuvat laitteellesi ja auttavat muistamaan valintasi sekä sen, miten palvelua käytetään. Tietoja hyödynnetään sivuston kehittämisessä, käytettävyyden parantamisessa ja liikenteen mittaamisessa.',
  terms_conditions_section9_6_paragraph2:
    'Useimmat nykyaikaiset selaimet hyväksyvät evästeet automaattisesti, mutta voit halutessasi estää ne. Emme käytä evästeitä henkilökohtaiseen räätälöintiin – kaikki näkevät saman sisällön.',
  terms_conditions_section9_6_paragraph3:
    'Liikennettä mitataan Verkkohaudan omassa järjestelmässä pseudonyymeillä kävijä- ja istuntoavaimilla. Emme käytä Google Analyticsia tai muita ulkoisia analytiikkatyökaluja tähän mittaukseen, eikä mittaustietoja jaeta kaupallisille kumppaneille käyttäjäprofiileina.',
  terms_conditions_section9_6_paragraph4: '',
  terms_conditions_section10_title: '10. Riidat',
  terms_conditions_section10_body:
    'Näihin ehtoihin sovelletaan Norjan lakia ja mahdolliset riidat ratkaistaan Norjan tuomioistuimissa. Oslo tingrett on sovittu toimivaltainen tuomioistuin.',
  terms_conditions_section11_title: '11. Yhteystiedot',
  terms_conditions_section11_body:
    'Jos sinulla on kysyttävää palvelusta, ota yhteyttä Nettgrav AS:ään sähköpostitse kontakt@nettgrav.no, puhelimitse +47 450 07 009 tai postitse osoitteeseen Damstredet 3, 0151 Oslo.',
  terms_conditions_accept_button: 'Hyväksy',
  terms_conditions_reject_button: 'Hylkää',
  change_free_plan: 'Ilmaisversio on maksuton',
  free_plan_message:
    'Ilmaisella voit tutkia, vierailla ja luoda Verkkohautain. Ilmainen on keskeinen arvo.',
  ending_with: 'päättyen',
  add_payment_method: 'Lisää maksutapa',
  name_on_card: 'Kortinhaltijan nimi',
  expiry_date: 'Voimassaoloaika',
  secure_payment_message: 'Turvallinen maksu SSL-salauksella',
  billing_address: 'Laskutusosoite',
  enter_address: 'Syötä osoite',
  billing_info_message:
    'Tätä tietoa käytetään ensimmäisen laskun luomiseen. Voit päivittää tulevien laskujen tiedot tiliprofiilissasi.',
  subscribe: 'Tilaa',
  select_language: 'Valitse kieli',
  payment_error: 'Maksuvirhe',
  subscription_waiting_message: 'Maksu käsitellään. Odota, tilauksesi on käynnissä',
  success_message: 'Tilaus peruutettu onnistuneesti',
  reactivate_success_message: 'Tilaus on aktivoitu uudelleen',
  choose_plan: 'Valitse suunnitelma ennen tilaamista',
  canceling_waite_message: 'Tilauksen peruutus käynnissä, odota…',
  subscription_overview: 'Tilausylläpito',
  users: 'Jäsenet',
  for_members: '– {user} jäsentä',
  for_member: '– {user} jäsen',
  for_6_members: '– {user} tai enemmän',
  billing_cycle: 'Laskutusjakso',
  amount: 'Määrä',
  cancelSubscriptionInfo:
    'Tilauksesi päättyy päättymispäivänä ja siirtyy ilmaiseen suunnitelmaan. Voit aloittaa uudelleen milloin tahansa.',
  confirm_billing_cycle: 'Tallenna muutokset',
  different_cycle: 'Valitse toinen laskutusjakso',
  update_billing: 'Laskutusjakso päivitetty',
  waiting_update_billing_cycle: 'Hetkinen, päivitetään laskutusjaksoa…',
  add_members_message: 'Jäsenet lisätty',
  remove_members_message: 'Jäsenet poistettu',
  your_current_plan: 'Nykyinen suunnitelmasi',
  upgrade_to: 'Päivitä {planName}',
  downgrade_to: 'Alenna {planName}',
  members_removed: 'Tilausjäsen poistettu',
  invitation_removed: 'Kutsujäsen poistettu',
  mann: 'Mies',
  kvinne: 'Nainen',
  annen: 'Muu',
  life_page_description: 'Täältä löydät hautasi ja Minun Valoni.',
  settings: 'Asetukset',
  settings_description: 'Tilitietosi kuten salasana, jäsenyys ja henkilö.',
  logout: 'Kirjaudu ulos',
  logout_description: 'Tee jotain ystävällistä. Katse. Hymy. Sana. Valosi merkitsee.',
  logout_success: 'Olet nyt kirjautunut ulos.',
  create_new_grave: 'Luo uusi hauta',
  create_grave_description: 'Luo uusi hauta merkinnäksi rekisteriin.',
  new: 'Uusi',
  read: 'Lue',
  empty_notification_message: 'Uudet ilmoitukset näytetään täällä',
  public_anniversaries: 'Julkiset merkkipäivät',
  grave_anniversaries: 'Merkkipäivät',
  public_anniversary: 'Julkinen merkkipäivä',
  grave_anniversary: 'Henkilökohtainen merkkipäivä',
  anniversary: 'Merkkipäivä',
  birthday_event: 'Syntymäpäivä',
  death_anniversary_event: 'Kuolinpäivä',
  memorial_days: 'Merkkipäivät',
  anniversary_delete: 'Merkkipäivä on poistettu.',
  anniversary_created: 'Merkkipäivä on luotu.',
  anniversary_updated: 'Merkkipäivä on päivitetty.',
  empty_anniversaries: 'Ei luotuja merkkipäiviä.',
  anniversaries_today: 'Tänään',
  anniversaries_upcoming: 'Tulevat',
  anniversaries_past: 'Aiemmat',
  anniversaries_past_empty: 'Ei aiempia merkkipäiviä vielä.',
  anniversaries_personal: 'Omat merkkipäivät',
  anniversaries_personal_empty: 'Et ole lisännyt merkkipäiviä vielä.',
  anniversaries_personal_login: 'Kirjaudu sisään lisätäksesi omia päiviä.',
  anniversaries_care_title: 'Hoiva ajan myötä',
  anniversaries_care_body:
    'Kynttilät ja haudan hoito voidaan hoitaa merkkipäivinä, vaikka kukaan ei olisi lähellä.',
  anniversaries_care_soon: 'Tulossa pian',
  anniversaries_focus_title: 'Tämä päivä',
  anniversaries_focus_today: 'Sytytä kynttilä tänään ollaksesi läsnä.',
  anniversaries_focus_future: 'Kynttilän voi tilata tälle päivälle.',
  anniversaries_focus_future_scheduled:
    '{count, plural, one {# kynttilä on tilattu tälle päivälle.} other {# kynttilää on tilattu tälle päivälle.}}',
  anniversaries_focus_future_scheduled_self: 'Olet tilannut kynttilän tälle päivälle.',
  anniversaries_focus_future_cta: 'Tilaa kynttilä',
  anniversaries_focus_past: 'Tämä päivä on takana. Muisto säilyy.',
  anniversaries_focus_empty: 'Valitse merkkipäivä nähdäksesi yksityiskohdat.',
  anniversaries_recurring_note: 'Vuosittain · {year}',
  anniversaries_show_all: 'Näytä kaikki',
  anniversaries_show_less: 'Näytä vähemmän',
  candles_now: 'Kynttilät nyt',
  candles_on_selected_day: 'Kynttilät tänä päivänä',
  candles_on_selected_day_empty: 'Ei kynttilöitä tälle päivälle.',
  schedule_candle: 'Tilaa kynttilä',
  schedule_candle_cta: 'Tilaa',
  scheduled_gift_context_label: 'Ajastetaan',
  scheduled_gift_created: 'Kynttilä on tilattu.',
  scheduled_gift_error: 'Kynttilän tilaaminen epäonnistui.',
  scheduled_gift_load_error: 'Tilattuja kynttilöitä ei voitu hakea juuri nyt.',
  quiet_presence_count: 'Hiljaiset käynnit · {count}',
  quiet_presence_zero: 'Ei hiljaisia käyntejä vielä',
  quiet_presence_return: 'Olet ollut täällä ennen',
  calendar_today_with_date: 'Tänään, {date}',
  calendar_today: 'Tänään',
  calendar_tomorrow: 'Huomenna',
  calendar_upcoming: 'Tulevat',
  calendar_month: 'Kuukausi',
  calendar_week: 'Viikko',
  calendar_day: 'Päivä',
  weekday_short_0: 'Su',
  weekday_short_1: 'Ma',
  weekday_short_2: 'Ti',
  weekday_short_3: 'Ke',
  weekday_short_4: 'To',
  weekday_short_5: 'Pe',
  weekday_short_6: 'La',
  create: 'Luo',
  add_dates: 'Lisää päivämäärät',
  date: 'Päivämäärä',
  time: 'Aika',
  title: 'Otsikko',
  reset_time: 'Nollaa aika',
  home: 'Koti',
  about: 'Tietoa',
  howTo: 'Ohjeet',
  plans: 'Suunnitelmat',
  find_a_grave: 'Etsi hauta',
  create_a_grave: 'Luo hauta',
  take_control: 'Hallinnoi hautaa',
  pricing: 'Hinnasto',
  get_started: 'Aloita',
  create_new_account: 'Luo oma tili.',
  did_you_know: 'Tiesitkö että',
  registration_description_one:
    'Täällä ei ole hautapaikan vuokraa tai haudanhoitoa. Sinun ei tarvitse huolehtia ylläpidosta. Verkkohauta huolehtii ulkoisesta – sinä huolehdit sisäisestä.',
  registration_description_two:
    'Hauta, jonka voi ottaa mukaan elämään. Jonkun muistaminen on myös tapa rakastaa.',
  registration_description_three: 'Täällä ei tarvitse suorittaa. Riittää, että olet läsnä.',
  enter_your_password: 'Anna salasanasi',
  confirm_your_password: 'Vahvista salasanasi',
  type_your_email: 'Anna sähköpostiosoitteesi',
  type_email: 'Anna sähköposti',
  hi: 'Hei {name}',
  dream_world_question: 'Miltä unelmamaailmasi näyttää?',
  decline: 'Hylkää',
  read_only: '(vain luku)',
  accept: 'Hyväksy',
  accepted_message: 'Kutsu hyväksytty',
  invited_title: 'Olet kutsuttu tilaajaan',
  open: 'Avaa',
  subscription_invitation_message: 'Sinut kutsuttiin {subscription}-tilaajaan: {name}',
  email_error: 'Anna kelvollinen sähköposti',
  password_length: 'Käytä vähintään 8 merkkiä sekä isoja ja pieniä kirjaimia ja numeroita.',
  filled_out: 'Täytä kaikki kentät jatkaaksesi.',
  must_agree: 'Hyväksy ehdot jatkaaksesi.',
  inactive: 'Epäaktiivinen',
  delete_payment_method: 'Poistetaan maksutapaa…',
  payment_method_deleted: 'Maksutapa poistettu',
  payment_method_inactive: 'Nykyinen maksutapasi on poistettu tai ei-aktiivinen.',
  subscription_changes_title: 'Pyysit näitä tilausmuutoksia.',
  period: 'Pyysit muuttaa laskutusjaksoa {month} {previous} → {newMonth} {new}',
  user_count: 'Pyysit jäsenten määrän pienentämistä {previous} → {new}',
  product_id: 'Pyysit suunnitelman muuttamista {previous} → {new}',
  remove_subscription_change: 'Muutospyyntö peruutettu',
  remove_subscription_loading: 'Odota… käsitellään pyyntöä',
  revert: 'Palauta',
  subscription_changes_subTitle: 'Muutokset otetaan käyttöön nykyisen kauden päättyessä {date}',
  add_new_paymentMethod: 'Lisää maksutapa',
  filled_out_info: 'Varmista, että kaikki kentät on täytetty ennen jatkoa',
  continue_new_card: 'Valitse maksutapa tai lisää uusi kortti jatkaaksesi',
  create_payment_method_waiting: 'Luodaan maksutapaa…',
  login_description: 'Läheisyys vainajiin ja elämään verkkohauta.fi-sivustolla. Seuraa Gnistaasi.',
  login_with_email: 'Kirjaudu sähköpostilla',
  login_with_phone: 'Kirjaudu puhelinnumerolla',
  account_created: 'Tervetuloa! Tilisi on luotu',
  verify_account: 'Sähköpostia ei ole vahvistettu',
  verification_message:
    'Kirjautuaksesi sisään, vahvista sähköpostisi. Tarkista saapuneet tai roskaposti, tai pyydä uusi viesti:',
  resend_email: 'Lähetä vahvistussähköposti uudelleen',
  sending_verification_email: 'Vahvistussähköposti lähetetty',
  sending_verification_code: 'Vahvistuskoodi lähetetty puhelimeesi',
  sending_verification_waiting: 'Lähetetään koodia…',
  email_verification: 'Vahvistussähköposti lähetetty. Klikkaa linkkiä postissa.',
  signup_step_title: 'Vahvista sähköpostisi',
  signup_relation_ready:
    'Yhteys on valmis — yhdistämme sinut {name} heti, kun sähköposti on vahvistettu.',
  signup_message_heading: 'Vahvista sähköpostisi',
  signup_message_subheading: 'Viimeistelläksesi pyydämme sinua vahvistamaan sähköpostisi.',
  signup_primary_cta: 'Lähetimme vahvistuslinkin osoitteeseen {email}',
  signup_secondary_cta: 'Kun avaat linkin, kirjaudut sisään automaattisesti.',
  signup_secondary_cta_relation:
    'Kun avaat linkin, kirjaudut sisään automaattisesti ja yhteys liitetään.',
  signup_help_text: 'Etkö löydä viestiä? Tarkista roskaposti tai lähetä linkki uudelleen.',
  signup_verification_reason: 'Näin varmistamme oikean pääsyn.',
  signup_primary_action: '🕊 Odotetaan sähköpostivahvistusta …',
  signup_resend_action: 'Lähetä linkki uudelleen',
  signup_save_email: 'Tallenna sähköposti',
  signup_cancel_email: 'Peruuta',
  signup_email_updated: 'Sähköposti päivitetty. Uusi linkki on lähetetty.',
  signup_verification_refresh_hint: 'Vahvistettu – päivitetään…',
  signup_change_email: 'Vaihda sähköposti',
  signup_login_action: 'Siirry kirjautumiseen',
  signup_resend_toast: 'Vahvistusviesti lähetetty uudelleen.',
  signup_waiting_cta: 'Odottaa vahvistusta',
  signup_delivery_status_label: 'Sähköpostin tila:',
  grave_guest_visit_title: 'Vieraile haudalla',
  grave_guest_visit_body:
    'Täällä voit lukea, nähdä ketkä kuuluvat mukaan ja olla läsnä {name} ympärillä.',
  grave_guest_visit_support: 'Kirjaudu sisään liittyäksesi hautaan ja seurataksesi mukana.',
  grave_guest_visit_primary: 'Kytkeydy hautaan',
  signup_delivery_status_sending: 'Lähetetään sähköpostia …',
  signup_delivery_status_sent: 'Sähköposti on lähetetty meiltä. Odottaa toimitusvahvistusta.',
  signup_delivery_status_delivered: 'Sähköposti on toimitettu.',
  signup_delivery_status_temporary_failure:
    'Sähköpostia ei voitu toimittaa juuri nyt. Yritä hetken kuluttua uudelleen.',
  signup_delivery_status_temp_over_quota:
    'Sähköpostia ei voitu toimittaa, koska postilaatikko on täynnä. Yritä hetken kuluttua uudelleen.',
  signup_delivery_status_permanent_failure:
    'Sähköpostia ei voitu toimittaa. Tarkista osoite tai käytä toista sähköpostia.',
  signup_login_inline: 'Onko sinulla jo tili? Kirjaudu sisään',
  waiting_for_account: 'Luodaan tiliä…',
  account_verification_waiting: 'Vahvistus käynnissä…',
  account_verification_heading: 'Tili vahvistettu!',
  account_verification_heading_error: 'Vahvistus epäonnistui',
  account_verification_description: 'Tili vahvistettu onnistuneesti.',
  account_verification_description_error:
    'Vahvistuksessa ilmeni ongelma. Yritä uudelleen tai ota yhteyttä.',
  update_payment_method_waiting: 'Päivitetään maksutapaa…',
  update_payment_method_success: 'Maksutapa päivitetty!',
  warning_payment_method: 'Valitse uusi maksutapa',
  complete_pending_payment: 'Viimeistele maksu.',
  plans_card_payment_method: 'Näet maksuvaihtoehdot täältä:',
  forgot_password_heading: 'Tarvitsetko apua salasanan kanssa?',
  forgot_password_description: 'Kirjoita sähköpostiosoitteesi, niin lähetämme linkin.',
  forgot_password_button: 'Lähetä linkki',
  forgot_password_message: 'Lähetimme linkin sähköpostiisi. Tarkista roskaposti.',
  forgot_password_title: 'Linkki lähetetty',
  forgot_password_waiting: 'Lähetetään linkkiä…',
  set_new_password: 'Aseta uusi salasana',
  set_new_password_description: 'Anna uusi salasana ja vahvista. Sitten voit kirjautua.',
  set_new_password_error: 'Anna salasana',
  set_new_password_success: 'Salasana päivitetty!',
  set_new_password_waiting: 'Päivitetään salasanaa…',
  action_required: 'Toiminta vaaditaan:',
  email_verification_alert: 'Lisää ja vahvista sähköpostisi jatkaaksesi kirjautumista.',
  goTo_settings_page: 'Siirry asetuksiin',
  go_to_home_page: 'Siirry kotisivulle',
  verify_now: 'Vahvista nyt',
  authCode_verified: 'Puhelinnumero vahvistettu!',
  personal_information_updated: 'Henkilötiedot päivitetty',
  change_phone_number: 'Vaihda puhelinnumero',
  verify_phone_button: 'Verify phone number',
  change_email: 'Vaihda sähköposti',
  current_email: 'Nykyinen sähköposti',
  new_email: 'Uusi sähköposti',
  verify_email_button: 'Verify email',
  change_email_btn: 'Vaihda sähköposti',
  change_password: 'Vaihda salasana',
  change_password_btn: 'Vaihda salasana',
  reset_date: 'Palauta päivä',
  date_picker_day_label: 'Päivä',
  date_picker_month_label: 'Kuukausi',
  date_picker_year_label: 'Vuosi',
  date_picker_day_placeholder: 'Valitse päivä',
  date_picker_month_placeholder: 'Valitse kuukausi',
  date_picker_year_placeholder: 'Valitse vuosi',
  date_picker_search_placeholder: 'Hae…',
  date_picker_no_results: 'Ei tuloksia',
  date_picker_clear: 'Tyhjennä valinta',
  sending_verification_email_waiting: 'Vahvistuslinkki lähetetty…',
  local_name: 'Paikallinen nimi',
  create_anniversary_waiting: 'Merkkipäivän luonti käynnissä… odota…',
  anniversary_time_end: 'Tapahtuma on päättynyt',
  hello: 'Hei',
  coins: 'Kolikot',
  store: 'Läsnäolo',
  purchase: 'Osta',
  checkout_title: 'Viimeistele valintasi',
  checkout_billing_address: 'Laskutusosoite',
  checkout_billing_name_label: 'Koko nimi',
  checkout_billing_name_placeholder: 'Koko nimi',
  checkout_billing_email_label: 'Sähköposti',
  checkout_billing_email_placeholder: 'Sähköposti',
  checkout_billing_phone_label: 'Puhelinnumero',
  checkout_billing_phone_placeholder: 'Puhelinnumero',
  checkout_billing_street_label: 'Katuosoite',
  checkout_billing_street_placeholder: 'Katuosoite',
  checkout_billing_city_label: 'Kaupunki',
  checkout_billing_city_placeholder: 'Kaupunki',
  checkout_billing_state_label: 'Osavaltio/maakunta',
  checkout_billing_state_placeholder: 'Osavaltio/maakunta',
  checkout_billing_postal_label: 'Postinumero',
  checkout_billing_postal_placeholder: 'Postinumero',
  checkout_billing_country_label: 'Maa',
  checkout_billing_country_placeholder: 'Valitse maa',
  checkout_card_details: 'Korttitiedot',
  checkout_card_number_label: 'Kortin numero',
  checkout_card_number_placeholder: '1234 1234 1234 1234',
  checkout_card_expiration_label: 'Viimeinen voimassaolopäivä',
  checkout_card_expiration_placeholder: 'KK / VV',
  partner_card_expiration: 'Viimeinen voimassaolopäivä',
  checkout_card_cvc_label: 'Turvakoodi',
  checkout_card_cvc_placeholder: 'CVC',
  checkout_payment_unavailable: 'Maksupalvelu ei ole valmiina. Yritä uudelleen.',
  checkout_missing_card_details: 'Syötä kortin numero jatkaaksesi.',
  checkout_missing_card_expiry: 'Syötä kortin voimassaoloaika.',
  checkout_missing_card_cvc: 'Syötä CVC-koodi.',
  checkout_saved_payment_methods: 'Maksutapa',
  checkout_add_new_payment: 'Lisää maksutapa',
  checkout_notice_banner_title: 'Lahja perheelle',
  checkout_notice_banner_body:
    'Tämä tilaus liitetään ilmoitukseen{hasName, select, true { henkilöstä {name}} false {}}.',
  checkout_cart_title: 'Ostoskorisi',
  checkout_subtotal: 'Välisumma',
  checkout_total: 'Yhteensä',
  checkout_checkout: 'Vahvista valintasi',
  checkout_complete_purchase: 'Vahvista valintasi',
  checkout_pay_amount: 'Maksa {amount}',
  bonus_tc: 'Bonus TC',
  set_color: 'Mikä on värisi tänään?',
  set_color_button: 'Aseta värisi',
  sparks: 'Kipinät',
  community: 'Yhteisö',
  purpose: 'Tarkoitus',
  talents: 'Lahjakkuudet',
  profile_image_changed: 'Kuva päivitetty',
  cover_photo_updated: 'Kansikuva päivitetty.',
  cover_photo_removed: 'Kansikuva poistettu.',
  edit_cover_photo: 'Muokkaa kansikuvaa',
  waiting_profile_upload: 'Päivitetään profiilikuvaa… odota…',
  graves: 'Ne, joita kannan mukanani',
  'cemeteryLanding.title': 'Löydä hauta kohteesta {cemetery}',
  wisdom: 'Viisaus',
  sparks_description: 'Jaa Kipinäsi, joka voi syttyä ja levittää valoa.',
  text_area_placeholder: 'Miten voit valaista jonkun polkua?',
  crop_image: 'Rajaa kuva',
  recurring_anniversary: 'Toista joka vuosi',
  nick_name: 'Lempinimi',
  birth_name: 'Syntymänimi',
  date_of_birth: 'Syntymäaika',
  date_of_death: 'Kuolinaika',
  time_of_birth: 'Syntymäkellonaika',
  time_of_death: 'Kuolinkellonaika',
  place_of_birth: 'Syntymäpaikka',
  place_of_death: 'Kuolinpaikka',
  cause_of_death: 'Kuolinsyy',
  municipality: 'Kunta',
  country: 'Maa',
  cemetery: 'Hautausmaa',
  grave_number: 'Hautanumero',
  grave_info_updating: 'Päivitetään hautatietoja… odota…',
  deceased_name: 'Nimi',
  deceased_placeholder: 'Kirjoita vainajan nimi',
  deceased_gender: 'Sukupuoli',
  i_am: 'Olen',
  buried_is_mine: 'Vainaja on minun',
  select_relationship: 'Valitse suhde',
  upload_document: 'Lataa asiakirja haudalle',
  upload_document_description: 'Valitse ladattava asiakirja:',
  death_certificate: 'Kuolintodistus',
  birth_certificate: 'Syntymätodistus',
  invoice: 'Kuitti hauta- tai vuokrakulusta',
  power_of_attorney: 'Valtuutustodistus',
  driving_license: 'Vainajan henkilökortti',
  proof_of_person: 'Lataa asiakirja vainajasta',
  proof_of_person_description: 'Asiakirjan on oltava PDF, PNG tai JPG ja enintään 5 Mt',
  replace_files: 'Korvaa tiedostot',
  browse_files: 'Etsi tiedostosi',
  drag_image: 'tai vedä tiedosto tähän',
  dear: 'Hyvä',
  new_grave_first_description: 'Tervetuloa luomaan uusi Verkkohauta.',
  new_grave_second_description: 'Täällä voit luoda turvallisen ja kunnioittavan haudan.',
  new_grave_third_description:
    'Luomalla Verkkohautain vahvistat, että sinulla on lupa tehdä tämä vainajalle.',
  new_grave_fourth_description: "Napsauta 'Hyväksy' jatkaaksesi.",
  new_grave_agree_terms: 'Hyväksyn yllä olevat ehdot',
  enter_name_error: 'Anna henkilön nimi',
  select_gender_error: 'Valitse henkilön sukupuoli.',
  select_relation_error: 'Valitse suhteesi henkilöön.',
  select_date_error: 'Valitse päivämäärä',
  select_reason_error: 'Valitse kuolinsyy',
  reason_of_death: 'Kuolinsyy',
  other_reason: 'Anna muu syy',
  other_reason_error: 'Anna muu kuolinsyy',
  select_country: 'Valitse maa',
  select_municipality: 'Valitse kunta',
  select_cemetery: 'Valitse hautausmaa',
  select_country_error: 'Valitse maa',
  select_municipality_error: 'Valitse kunta',
  select_cemetery_error: 'Valitse hautausmaa',
  create_the_grave: 'Luo hauta',
  create_the_message: 'Haudan luonti käynnissä… odota…',
  death_date_error: 'Valitse kelvollinen kuolinaika',
  birth_date_error: 'Valitse kelvollinen syntymäaika',
  month_0: 'tammikuu',
  month_1: 'helmikuu',
  month_2: 'maaliskuu',
  month_3: 'huhtikuu',
  month_4: 'toukokuu',
  month_5: 'kesäkuu',
  month_6: 'heinäkuu',
  month_7: 'elokuu',
  month_8: 'syyskuu',
  month_9: 'lokakuu',
  month_10: 'marraskuu',
  month_11: 'joulukuu',
  unknown_year: 'Tuntematon vuosi',
  unknown_month: 'Tuntematon kuukausi',
  'life.unknown_month': 'Tuntematon kuukausi',
  weekday_0: 'sunnuntai',
  weekday_1: 'maanantai',
  weekday_2: 'tiistai',
  weekday_3: 'keskiviikko',
  weekday_4: 'torstai',
  weekday_5: 'perjantai',
  weekday_6: 'lauantai',
  father: 'Isä',
  mother: 'Äiti',
  son: 'Poika',
  husband: 'Mies',
  wife: 'Nainen',
  brother: 'Veli',
  sister: 'Sisko',
  maternal_grandfather: 'Äidinisä',
  maternal_grandmother: 'Äidinäiti',
  paternal_grandfather: 'Isänisä',
  paternal_grandmother: 'Isänäiti',
  maternal_uncle: 'Äidin veli',
  maternal_aunt: 'Äidin sisko',
  paternal_uncle: 'Isän veli',
  paternal_aunt: 'Isän sisko',
  farfar: 'Isänisä',
  morfar: 'Äidinisä',
  farmor: 'Isänäiti',
  mormor: 'Äidinäiti',
  grandfather: 'Isoisä',
  grandmother: 'Isoäiti',
  grandchild: 'Lapsenlapsi',
  grandson: 'Lapsenlapsi',
  granddaughter: 'Lapsenlapsi',
  uncle: 'Setä',
  uncle_child: 'Serkku',
  aunt: 'Täti',
  aunt_child: 'Serkku',
  nephew: 'Veljenpoika/siskonpoika',
  niece: 'Veljentytär/siskontytär',
  cousin: 'Serkku',
  aunt_husband: 'Tädin puoliso',
  uncle_wife: 'Sedän puoliso',
  cousin_wife: 'Serkun puoliso',
  cousin_husband: 'Serkun puoliso',
  stepbrother: 'Velipuoli',
  stepsister: 'Siskopuoli',
  stepfather: 'Isäpuoli',
  stepmother: 'Äitipuoli',
  stepson: 'Lapsipuoli (poika)',
  stepdaughter: 'Lapsipuoli (tyttö)',
  father_in_law: 'Appi',
  mother_in_law: 'Anoppi',
  brother_in_law: 'Lanko',
  sister_in_law: 'Käly',
  son_in_law: 'Vävy',
  daughter_in_law: 'Miniä',
  self: 'Minä',
  parent: 'Vanhempi',
  child: 'Lapsi',
  sibling: 'Sisarus',
  spouse: 'Puoliso',
  grandparent: 'Isovanhempi',
  great_grandparent: 'Isoisovanhempi',
  great_grandchild: 'Lapsenlapsenlapsi',
  great_great_grandparent: 'Isoisoisovanhempi',
  great_great_grandchild: 'Lapsenlapsenlapsenlapsi',
  great_great_great_grandparent: 'Isoisoisoisovanhempi',
  great_great_great_grandchild: 'Lapsenlapsenlapsenlapsenlapsi',
  aunt_or_uncle: 'Täti/Setä',
  great_uncle: 'Isosetä',
  great_aunt: 'Isotäti',
  great_aunt_or_uncle: 'Isotäti/Isosetä',
  nibling: 'Sisaruksen lapsi',
  grand_niece: 'Sisaruksen lapsenlapsi',
  grand_nephew: 'Sisaruksen lapsenlapsi',
  grand_nibling: 'Sisaruksen lapsenlapsi',
  great_niece: 'Sisaruksen lapsenlapsenlapsi',
  great_nephew: 'Sisaruksen lapsenlapsenlapsi',
  great_nibling: 'Sisaruksen lapsenlapsenlapsi',
  cousin_in_law: 'Serkun puoliso',
  aunt_in_law: 'Aviotäti',
  uncle_in_law: 'Aviosetä',
  first_cousin_in_law: 'Avioliiton kautta serkku',
  uncle_in_law_son: 'Aviosedän poika',
  first_cousin: 'Serkku',
  first_cousin_once_removed: 'Serkku (yksi sukupolvi eroa)',
  first_cousin_twice_removed: 'Serkku (kaksi sukupolvea eroa)',
  second_cousin: 'Pikkuserkku',
  second_cousin_once_removed: 'Pikkuserkku (yksi sukupolvi eroa)',
  second_cousin_twice_removed: 'Pikkuserkku (kaksi sukupolvea eroa)',
  third_cousin: 'Pikkupikkuserkku',
  third_cousin_once_removed: 'Pikkupikkuserkku (yksi sukupolvi eroa)',
  third_cousin_twice_removed: 'Pikkupikkuserkku (kaksi sukupolvea eroa)',
  aunt_uncle_in_law: 'Täti/Setä (avioliiton kautta)',
  nibling_in_law: 'Sisaruksen lapsi (avioliiton kautta)',
  niece_in_law: 'Veljentytär/siskontytär (avioliiton kautta)',
  nephew_in_law: 'Veljenpoika/siskonpoika (avioliiton kautta)',
  parent_in_law: 'Appivanhempi',
  child_in_law: 'Vävy/Miniä',
  sibling_in_law: 'Lanko/Käly',
  grandparent_in_law: 'Appivanhempi (vanhempi sukupolvi)',
  grandchild_in_law: 'Puolison lapsenlapsi',
  step_parent: 'Puolivanhempi',
  step_mother: 'Äitipuoli',
  step_father: 'Isäpuoli',
  step_child: 'Puolilapsi',
  step_daughter: 'Lapsipuoli (tyttö)',
  step_son: 'Lapsipuoli (poika)',
  step_sibling: 'Puolisisarus',
  step_sister: 'Siskopuoli',
  step_brother: 'Velipuoli',
  boyfriend: 'Poikaystävä',
  girlfriend: 'Tyttöystävä',
  adopt_son: 'Adoptoitu poika',
  adopt_daughter: 'Adoptoitu tytär',
  adopted_son: 'Adoptoitu poika',
  adopted_daughter: 'Adoptoitu tytär',
  moons: 'Kuut',
  my_moons: 'Omat kuut',
  has_you_as_moon: 'Pitää sinua kuunaan',
  moons_empty_title: 'Ei kuita vielä.',
  moons_empty_description: 'Kuu on ihminen, joka on ohjannut sinua. Joku, jonka valoa seuraat.',
  friends: 'Ystävät',
  friends_and_family: 'Perhe ja ystävät',
  colleagues: 'Työkaverit',
  friend: 'Ystävä',
  other: 'Muu',
  daughter: 'Tytär',
  partner: 'Kumppani',
  relation_category_parent: 'Vanhempi',
  relation_category_child: 'Lapsi',
  relation_category_partner: 'Kumppani',
  relation_category_sibling: 'Sisarus',
  relation_category_grandparent: 'Isovanhempi',
  relation_category_aunt_uncle: 'Täti/Setä',
  relation_quick_pick_hint: 'Esivalitsimme valinnan. Vahvista tai vaihda.',
  relation_quick_pick_parent_choose: 'Valitse äiti tai isä.',
  relation_quick_pick_sibling_choose: 'Valitse veli tai sisko.',
  relation_quick_pick_child_choose: 'Valitse poika tai tytär.',
  open_details: 'Avaa yksityiskohta',
  colleague: 'Kollega',
  great_granddaughter: 'Isoisänlapsenlapsi (tyttö)',
  great_grandson: 'Isoisänlapsenlapsi (poika)',
  great_grandmother: 'Isoisoäiti',
  great_grandfather: 'Isoisoisä',
  great_great_granddaughter: 'Isoisoisänlapsenlapsi (tyttö)',
  great_great_grandson: 'Isoisoisänlapsenlapsi (poika)',
  great_great_grandmother: 'Isoisoisoäiti',
  great_great_grandfather: 'Isoisoisoisä',
  great_great_great_granddaughter: 'Isoisoisoisänlapsenlapsi (tyttö)',
  great_great_great_grandson: 'Isoisoisoisänlapsenlapsi (poika)',
  great_great_great_grandmother: 'Isoisoisoisoäiti',
  great_great_great_grandfather: 'Isoisoisoisoisä',
  cohabitant: 'Avopuoliso',
  contact_person: 'Yhteyshenkilösi',
  invited_person_name: 'Kutsutun nimi',
  monthly: 'Kuukausittain',
  semi_annual: 'Puolivuosittain',
  annually: 'Vuosittain',
  biennial: 'Kahden vuoden välein',
  auth_modal_description:
    'Kirjaudu sisään tai luo ilmainen tili vieraillaksesi haudoilla ja käyttääksesi kaikkia ominaisuuksia.',
  auth_modal_heading: 'Kirjaudu sisään | Luo tili',
  active: 'Aktiivinen',
  requested_to_remove: 'Pyydetty poistamaan',
  manage_members: 'Hallitse jäseniä',
  remove_members_warring:
    'Poista {remainingNumber} jäsentä lisää tai peru heidän kutsunsa (tai molemmat).',
  remove_members_warning: 'Poista jäseniä tai pienennä määrää jatkaaksesi.',
  subscription_base_price: 'Perustilaushinta',
  membership: 'jäsenyys',
  relation_to_grave: 'Kutsuttu suhde kohteeseen {graveName}',
  relation_to_person: '{graveName}-suhde kutsuttuun',
  administrator_access: 'Järjestelmänvalvojan oikeudet',
  select_role: 'Valitse rooli',
  administrator: 'Järjestelmänvalvoja',
  normal: 'Normaali',
  select_role_error: 'Valitse käyttäjän rooli',
  user_name: 'Käyttäjänimi',
  remove_all_grave_user: 'Tärkeä: Päivitys hautahallintaan',
  remove_all_grave_user_message:
    'Pidä vähintään yksi henkilö tai ylläpitäjä liitettynä. Jos haluat poistaa kaikki, siirrä omistajuus tai poista hauta.',
  send_it: 'Lähetä',
  public_view: 'Julkinen näkymä',
  spark_posting_to_privacy: 'Näkyy {privacy}',
  constellation: 'Tähtikuva',
  moons_only: 'Vain kuu',
  form: 'Lomake',
  state_of_mind: 'Olotila',
  spark_state_of_mind_info:
    'Valitse olotilasi. Se vaikuttaa siihen, miten säteesi otetaan vastaan.',
  spark_state_of_mind_info_label: 'Mielentilan info',
  spark_form_info_label: 'Tietoa ilmaisutavasta',
  spark_remove_link_preview_to_add_media: 'Poista linkin esikatselu lisätäksesi median.',
  taggable_composer_type_to_tag: 'Kirjoita nimi mainitaksesi',
  taggable_composer_no_matches: 'Ei osumia',
  taggable_composer_clear: 'Tyhjennä',
  question: 'kysymys',
  insight: 'oivallus',
  experience: 'kokemus',
  discovery: 'löytö',
  feeling: 'tunne',
  value: 'arvo',
  energy: 'energia',
  select_category: 'Valitse kategoria',
  spark_delete: 'Säde poistettu',
  spark_create: 'Säde luotu',
  spark_update: 'Säde päivitetty',
  ENG: 'Englanti',
  NOR: 'Norja',
  loading: 'Ladataan…',
  in_your_mind: 'Jaa ajatus, kysymys tai kokemus…',
  spark_reflection_placeholder:
    'Vastaa siihen, mitä tämä kipinä herättää sinussa – oivallus, toivo tai yhteys.',
  create_spark: 'Luo Säde',
  reflect_on_spark: 'Reflect on Spark',
  empty_graves:
    'Käytä vasemmassa yläkulmassa olevaa hakukenttää löytääksesi haudan, johon olet yhteydessä. Kun suhde on asetettu, hauta näkyy tässä.',
  all: 'Kaikki',
  owner: 'Omistaja',
  affiliated: 'Liittynyt',
  view_all: 'Näytä kaikki',
  close_relation: 'Kun lisäät jonkun, hän näkyy tässä.',
  no_relation_set: 'Ei suhteita asetettu',
  love_ones: 'Ne, jotka kulkevat {name} kanssa',
  set_relation: 'Valitse suhteesi',
  join_set_relation_free: 'Valitse suhteesi henkilöön {firstName}',
  join_sheet_title: 'Valitse suhteesi henkilöön {name}',
  join_sheet_intro:
    'Henkilökohtainen tila läheisyyteen {name}:iin – saatavilla silloin kun haluat.',
  join_sheet_auth_title: 'Kirjaudu sisään jatkaaksesi',
  join_sheet_auth_intro:
    'Kirjaudu sisään reagoidaksesi, lisätäksesi reflektion tai kirjoittaaksesi kommentin.',
  join_sheet_intent_react_title: 'Kirjaudu sisään reagoidaksesi Kipinöihin',
  join_sheet_intent_react_intro:
    'Kun olet kirjautunut sisään, voit reagoida ja osallistua keskusteluun.',
  join_sheet_intent_weekly_question_title: 'Kirjaudu sisään vastataksesi viikon kysymykseen',
  join_sheet_intent_weekly_question_intro:
    'Kun olet kirjautunut sisään, voit jakaa oman vastauksesi Kipinänä.',
  join_sheet_intent_reflect_title: 'Kirjaudu sisään lisätäksesi reflektion',
  join_sheet_intent_reflect_intro: 'Kun olet kirjautunut sisään, voit jakaa reflektiosi.',
  join_sheet_intent_composer_title: 'Kirjaudu sisään kirjoittaaksesi kommentin',
  join_sheet_intent_composer_intro: 'Kun olet kirjautunut sisään, voit osallistua keskusteluun.',
  join_sheet_intent_submit_title: 'Kirjaudu sisään julkaistaksesi kommenttisi',
  join_sheet_intent_submit_intro: 'Kun olet kirjautunut sisään, kommenttisi voidaan jakaa.',
  guest_quota_notice_title: 'Lisää hakuja tänään',
  guest_quota_notice_body: 'Jatkaaksesi hakemista tänään voit kirjautua sisään tai luoda tilin.',
  please_sign_in_to_continue: 'Kirjaudu sisään jatkaaksesi.',
  join_sheet_subtitle: 'Paikka läheisyyteen {name}:iin.',
  join_sheet_name_fallback: 'läheisiäsi',
  relation_request_send: 'Suhdepyyntö lähetetty',
  relation_updated_success: 'Suhdetta on päivitetty.',
  relation_update_failed: 'Suhdetta ei voitu päivittää.',
  relation_removed_success: 'Suhde on poistettu.',
  relation_remove_failed: 'Suhdetta ei voitu poistaa.',
  relation_connection: '{name} on minun {reciprocalRelation}, ja minä olen {name}n {relation}.',
  request_send: 'Pyyntö lähetetty',
  empty_sparks: 'Ei säteitä, luo uusi',
  'sparks.empty_stars':
    'Yksikään kipinä ei ole vielä muuttunut tähdeksi. Kun kipinä kasvaa tähdeksi, se näkyy täällä.',
  create_post: 'Hautaseinä · {graveName}',
  grave_wall_cta_primary: 'Jätä sanat',
  grave_wall_cta_secondary: 'Sulje',
  post: 'Julkaise',
  update_post: 'Päivitä julkaisu',
  account_heading: 'Poista tilisi',
  delete_account: 'Poista tili',
  delete_account_pending: 'Tilin poisto käynnissä',
  deleted_message_pending:
    'Poistopyyntö lähetetty. Tili ja tiedot poistetaan. Voit peruuttaa ennen klo 23:50 tänään. Ota yhteyttä supportiin.',
  deleted_message:
    'Jos poistat tilisi, kaikki tiedot poistetaan pysyvästi. Poisto on lopullinen klo 23:50 jälkeen. Ota yhteyttä: kontakt@nettgrav.no, jos sinulla on kysyttävää.',
  confirm_delete_account: 'Tämä poistaa tilin ja kaiken sisällön.',
  confirm_cancel_account: 'Tämä pysäyttää poiston ja pitää tilin.',
  account_delete_confirm_button: 'Poista tili',
  account_delete_cancel_button: 'Säilytä tili',
  account_cancel_delete_confirm_button: 'Pysäytä poisto',
  account_cancel_delete_cancel_button: 'Säilytä tili',
  phone_number_error: 'Puhelinnumero/salasana ei täsmää',
  email_error_login: 'Sähköposti ja salasana eivät täsmää.',
  set_relation_heading: 'Yhdistä hautaan',
  set_relation_free_description: 'Kerro, kuka {graveName} on sinulle, saadaksesi pääsyn.',
  set_relation_access: 'Jäsenenä voit:',
  do_you_know: 'Kuka {graveName} on sinulle?',
  set_relation_description: 'Lähetä pyyntö liittyä jäseneksi sukulaisena, ystävänä tai tukijana',
  set_relation_info_message:
    'Ilmaiskäyttäjiä pyydetään maksamaan 2 $/kk kun klikkaat “Vahvista ja liity”.',
  click_button_below: 'Valitse suhde jatkaaksesi.',
  feature_title_1: 'Muistoalbumi',
  feature_description_1: 'Lisää valokuvia rakkaastasi ja perheestäsi.',
  feature_title_2: 'Muistoseinä',
  feature_description_2: 'Lue ja jaa muistoja muiden kanssa, jotka tunsivat heidät.',
  feature_title_3: 'Juhlavuuskalenteri',
  feature_description_3: 'Saat muistutuksia tärkeistä päivistä.',
  feature_title_4: 'Arvoarkisto',
  feature_description_4: 'Tallenna rakkaasi opettamat tärkeät opetukset.',
  feature_title_5: 'Elämäarkisto',
  feature_description_5: 'Kirjoita tarinoita heidän elämästään.',
  choose_relation: 'Valitse suhde',
  relation_label: 'Olen {grave}s',
  reciprocal_label: '{grave} on minun',
  set_relation_note: 'Valitse, kuka vainaja on sinulle, ja anna haudalle koti täällä.',
  set_relation_other: 'Kaikille, jotka tunsivat vainajan – kollega, fani tai muu.',
  set_relation_placeholder: 'Esim. Olin ystäviä {grave} kanssa Oslon yliopistossa…',
  confirm_relation_member: 'Vahvista suhde ja liity',
  pay_and_reactivate: 'Maksa jäsenyyden aktivoimiseksi',
  confirm_membership: 'Vahvista jäsenyys',
  enlightened: 'Valaistunut',
  inspired: 'Innoittunut',
  spark_reaction_add_wood: 'Lisää puuta',
  spark_reaction_add_breath: 'Puhalla kipinään elämää',
  spark_reaction_add_light: 'Valaise kipinä valolla',
  spark_reaction_legacy: 'Aiemmat reaktiot',
  spark_stage_spark: 'Kipinä',
  spark_stage_campfire: 'Nuotio',
  spark_stage_star: 'Tähti',
  'spark.openDetail': 'Avaa kipinä',
  reflected: 'Heijastunut',
  comments: 'vastauksia',
  comment: 'vastaus',
  empty_comments: 'Ei vastauksia',
  comment_placeholder: 'Kirjoita tähän…',
  reply: 'Vastaa',
  view_replies: 'Näytä kaikki {total} vastausta',
  create_grave_body: 'Luodaksesi uuden Verkkohautain tarvitset Conscious-jäsenyyden.',
  upgrade_modal_heading: 'Luo uusi hauta',
  go_to: 'Siirry',
  our_plans: 'aktivoi jäsenyys',
  choose_the_subscription: 'saadaksesi kaikki ominaisuudet.',
  link_grave_body: 'Hienoa, että haluat yhdistää vainajat. Tarvitset Conscious-jäsenyyden.',
  add_more_images_body: 'Lisätäksesi lisää kuvia albumeihin, päivitä tilauksesi.',
  inviting_body: 'Kutsut ovat käytettävissä Conscious-jäsenyyden kanssa.',
  life_archive_body: 'Elämäarkisto on käytettävissä Conscious-jäsenyyden kanssa.',
  upload_images_body: 'Lisätäksesi kuvia, päivitä nykyinen tilauksesi.',
  add_value_body: 'Hienoa, että haluat lisätä ominaisuuden. Tarvitset Conscious-jäsenyyden.',
  search_limit_body:
    'Sukella syvemmälle Verkkohautaiin Conscious-suunnitelmalla. Päivitä tänään rajattomiin hakuihin.',
  grave_invitation_first_text: 'Sinut on kutsuttu auttamaan haudalla',
  of: ' / ',
  grave_invitation_second_text: 'Täällä voitte koota muistoja, kuvia ja merkkipäiviä yhdessä.',
  grave_email_info:
    'Tämä sähköposti on lukittu tähän kutsuun. Jos jokin on pielessä, ota yhteyttä kutsujaan.',
  subscription_email_info:
    'Tämä sähköposti on lukittu tähän tilaukseen. Jos jokin on pielessä, ota yhteyttä sen luoneeseen henkilöön.',
  grave_invitation_message: '{name} on kutsunut sinut mukaan huolehtimaan {grave}n haudasta.',
  accept_or_pay: 'Hyväksy ja maksa',
  paid_grave_user_message:
    'Sinut on kutsunut {userName} maksetulla tilauksella. Hyväksy liittyäksesi tai hylkää.',
  unpaid_grave_user_message: 'Sinut on kutsuttu {userName}. Liittyäksesi päivitä maksulliseksi.',
  active_unpaid_grave_user_message:
    'Sinulla ei ole aktiivista tilausta. Aktivoi uudelleen osallistuaksesi.',
  invite: 'Kutsu',
  complete_relation_setup: 'Viimeistele maksu vahvistaaksesi yhteyden',
  already_set_relation: 'Olet jo asettanut suhteen hautaan {graveName} nimellä {relation}.',
  already_accept_relation: 'Olet jo hyväksynyt yhteyden hautaan {graveName} nimellä {relation}.',
  finalize_membership:
    'Viimeistelläksesi yhteyden ja avataksesi edut, maksa. Hauta liitetään profiiliisi ja saat pääsyn:',
  click_below_to_complete: 'Klikkaa alla maksun viimeistelemiseksi.',
  complete_payment: 'Viimeistele maksu',
  awaiting_owner_approval: 'Odottaa omistajan hyväksyntää',
  awaiting_approval_message: 'Omistajalle on ilmoitettu pyynnöstäsi. Odota hyväksyntää.',
  subscribed_grave_invitation:
    'Sinut on kutsuttu yhdistämään hautaan {graveName} nimellä {relation} käyttäjän {name} toimesta.',
  click_below_to_accept: 'Klikkaa alla hyväksyäksesi kutsun.',
  accept_invitation: 'Hyväksy kutsu',
  accept_invitation_payment: 'Hyväksy ja maksa',
  complete_invitation: 'Viimeistele kutsu',
  unsubscribed_grave_invitation:
    'Hyväksyäksesi kutsun, viimeistele maksu. Sen jälkeen saat käyttöoikeuden:',
  you_are_invited: 'Olet kutsuttu!',
  reclaim_user_access: 'Palauta pääsysi',
  previous_relation: 'Olet aiemmin ollut yhteydessä hautaan {graveName} nimellä {relation}.',
  downgrade_subscription:
    'Jäsenyytesi on palautettu ilmaiseen tilaan, pääsyä on rajoitettu mutta olet yhä jäsen.',
  regain_access: 'Palauta täysi pääsy päivittämällä jäsenyys.',
  click_below_to_upgrade: 'Klikkaa alla päivittääksesi ja palauttaaksesi pääsyn.',
  upgrade_membership: 'Päivitä jäsenyys',
  set_self_relation: 'Kerro kuka {graveName} on sinulle yhdistääksesi sen.',
  set_relation_linked: 'Kun teet sen, voit:',
  set_self_relation_1: 'Vierailla haudalla milloin tahansa.',
  set_self_relation_2: 'Säilyttää muistoja ja perhettä.',
  set_self_relation_3: 'Antaa haudalle enemmän merkitystä jatkossa.',
  set_self_relation_message: 'Tärkeä viesti:',
  claim_grave_labe: 'Haluan olla vastuussa tästä haudasta. Valitse ruutu.',
  claim_grave_terms_1: 'Tervetuloa Verkkohautaiin.',
  claim_grave_terms_2: 'Täällä voit vaatia turvallisen ja kunnioittavan haudan.',
  claim_grave_terms_3: 'Vaatimalla Verkkohautain vahvistat sinulla olevan luvan.',
  claim_grave_terms_4: 'Usein fyysisen haudan omistaja. Klikkaa “Hyväksy”.',
  i_agreed_claim: 'Hyväksyn ehdot yllä',
  upload_death_document: 'Lataa vainajan kuolintodistus.',
  upload_death_document_limit: 'PDF/PNG/JPG, enintään 5 Mt',
  drag_files: 'tai vedä tiedosto tähän',
  'grave.new.docs.header': 'Olen haudan omistaja/haltija.',
  'grave.new.docs.upload_title': 'Lataa dokumentaatio',
  'grave.new.docs.upload_note': 'Muoto: PDF, PNG tai JPG (enintään 5 Mt).',
  'grave.new.docs.button': 'Lataa dokumentaatio',
  'grave.new.docs.drop_hint': 'Klikkaa tai vedä tiedosto tähän',
  'grave.new.info.title': 'Hoitovastuu haudasta.',
  'grave.new.info.line1': 'Kun jatkat, vahvistat että sinulla on oikeus huolehtia tästä haudasta.',
  'grave.new.info.line2':
    'Tämä koskee yleensä henkilöä, jolla on vastuu fyysisestä haudasta, tai henkilöä jolla on valtuutus.',
  'grave.new.info.line3': 'Dokumentaatiota käytetään vain tähän tarkoitukseen.',
  'grave.new.accept_label': 'Vahvistan, että olen vastuussa tästä haudasta',
  'grave.new.create_cta': 'Luo hauta',
  claim_grave_message: 'Onko sinulla vastuu tämän haudan hoidosta?',
  claim_grave_document_helper: 'Tätä käytetään vain haudan hoitovastuun vahvistamiseen.',
  claim_guardian_info_title: 'Mitä hoitovastuu tarkoittaa?',
  claim_guardian_info_lead: 'Suojelijana huolehdit haudasta ja sen ympärillä olevasta yhteisöstä.',
  claim_guardian_info_bullet_relations: 'Hyväksyä tai hylätä suhteita',
  claim_guardian_info_bullet_content: 'Hallinnoida haudan sisältöä',
  claim_guardian_info_bullet_admins: 'Lisätä tai poistaa ylläpitäjiä',
  claim_guardian_info_note: 'Hoitovastuu vahvistetaan dokumentaatiolla.',
  take_ownership: 'Ryhdy {firstName}n suojelijaksi',
  manage_grave: 'Hallitse hautaa',
  claim_request_queue: 'Pyyntösi vaatia hauta {graveName} on lähetetty. Odottaa hyväksyntää.',
  register_ownership: 'Rekisteröi omistajuus',
  public: 'Julkinen',
  moon: 'Kuu',
  moon_set: 'Valitse omaksi kuuksi',
  moon_remove: 'Poista kuusuhde',
  moon_remove_as_moon: 'Poista kuuna',
  moon_remove_confirm_moon:
    'Tämä poistaa käyttäjän {username} kuunasi. Voit lisätä käyttäjän {username} uudelleen myöhemmin.',
  moon_remove_confirm_as_moon:
    'Tämä poistaa sinut käyttäjän {username} kuuna. Voit valita uudelleen myöhemmin.',
  moon_cancel_request: 'Peruuta pyyntö',
  moon_ping_cta: 'Anna merkki',
  moon_request_sent: 'Kuupyyntö lähetetty.',
  moon_request_accepted: 'Kuu-kutsu hyväksytty.',
  moon_request_declined: 'Kuu-kutsu hylätty.',
  moon_request_page_title: 'Kutsu kuusuhteeseen',
  moon_request_page_subtitle: '{name} haluaa sinut kuukseen.',
  moon_request_sign_in: 'Kirjaudu sisään vastataksesi',
  moon_request_accept: 'Hyväksy',
  moon_request_decline: 'Hylkää',
  moon_request_already_handled: 'Tämä kutsu on jo käsitelty.',
  moon_removed: 'Kuusuhde poistettu.',
  moon_ping_sent: 'Signaali lähetetty.',
  moon_ping_cta_sent: 'Merkki lähetetty',
  moon_ping_sent_hint: 'He saavat tiedon, että olet heidän tukenaan.',
  moon_ping_cooldown:
    'Olet jo antanut merkin tänään. Voit lähettää uuden muutaman tunnin kuluttua.',
  moon_helper_text_line_1: 'Kuu on ihminen, joka on ohjannut sinua.',
  moon_helper_text_line_2: 'Joku, jonka valoa seuraat.',
  moon_helper_text: 'Kuu on ihminen, joka on ohjannut sinua. Joku, jonka valoa seuraat.',
  own_words_tab: 'Omin sanoin',
  own_words_public_tab: 'Omat sanat',
  own_words_title: 'Omin sanoin',
  own_words_subtitle:
    'Paikka sille, mitä haluat muiden ymmärtävän sinusta, kun voitte vielä puhua yhdessä.',
  own_words_prompts_title: 'Aloita kysymyksellä',
  own_words_prompt_1: 'Mitä toivon sinun ymmärtävän minusta?',
  own_words_prompt_2: 'Mikä antaa elämälleni suunnan?',
  own_words_prompt_3: 'Mitä on vaikea sanoa ääneen?',
  own_words_prompt_4: 'Mitä minun on tarpeen pukea sanoiksi juuri nyt?',
  own_words_placeholder: 'Kirjoita omin sanoin...',
  own_words_visibility_title: 'Kuka voi lukea tämän?',
  own_words_visibility_everyone: 'Kaikki Nettgravissa',
  own_words_self_only: 'Vain sinä voit lukea tämän, kunnes valitset toisen näkyvyyden.',
  own_words_reader_invitation_title: 'Miten lukija voi kohdata sanasi?',
  own_words_reader_invitation_help:
    'Yksityisen keskustelun valinnat näyttävät viestipainikkeen sanojesi yhteydessä.',
  own_words_reader_invitation_listen: 'Vain lue',
  own_words_reader_invitation_ask: 'Kysy minulta yksityisessä keskustelussa',
  own_words_reader_invitation_understand_together: 'Ymmärretään yhdessä yksityisessä keskustelussa',
  own_words_reader_invitation_keep: 'Pidä tämä tallessa',
  own_words_publish: 'Jaa sanani',
  own_words_update: 'Päivitä',
  own_words_publish_success: 'Sanasi on jaettu.',
  own_words_publish_needs_words: 'Kirjoita jotain ennen jakamista.',
  own_words_save_error: 'Tallentaminen ei onnistunut juuri nyt.',
  own_words_public_title: 'Omin sanoin',
  own_words_public_subtitle: 'Sanat, jotka {name} kirjoitti ja päätti jakaa.',
  own_words_updated: 'Päivitetty {date}',
  own_words_chat_cta: 'Kysy ymmärtääksesi',
  own_words_chat_ask_cta: 'Lähetä yksityisviesti',
  own_words_chat_understand_cta: 'Ymmärretään yhdessä',
  own_words_chat_error: 'Keskustelua ei voitu avata juuri nyt.',
  after_me_tab: 'Jälkeeni',
  after_me_title: 'Jälkeeni',
  after_me_subtitle: 'Paikka tehdä valinnoista ja toiveista selkeämpiä.',
  after_me_intro_title: 'Jos en jonain päivänä pysty itse sanomaan tätä',
  after_me_intro_text: 'Voit kirjoittaa vähän tai paljon. Voit muuttaa kaiken myöhemmin.',
  after_me_step_counter: 'Vaihe {current}/{total}',
  after_me_step_intentions_title: 'Mitä toivot tämän antavan?',
  after_me_step_words_title: 'Jotain, jonka haluan muiden tietävän',
  after_me_step_legacy_title: 'Se mikä elää eteenpäin',
  after_me_words_help: 'Sen ei tarvitse olla täydellinen. Kirjoita se omilla sanoillasi.',
  after_me_writing_prompts_title: 'Aloita kysymyksestä',
  after_me_writing_prompt_1: 'Mitä toivon teidän ymmärtävän minusta?',
  after_me_writing_prompt_2: 'Mikä on antanut elämälleni suunnan?',
  after_me_writing_prompt_3: 'Mitä toivon voivani antaa eteenpäin?',
  after_me_writing_prompt_4: 'Mitä läheisteni tulisi tietää?',
  after_me_public_tab: 'Omin sanoin',
  after_me_public_title: 'Mitä haluan teidän tietävän minusta',
  after_me_public_subtitle: '{name} on kirjoittanut nämä sanat ja jakanut ne omilla ehdoillaan.',
  after_me_public_intentions_title: 'Mitä toivon tämän antavan',
  after_me_public_legacy_title: 'Mitä toivon antavani eteenpäin',
  after_me_public_choices_title: 'Valintani',
  after_me_public_updated: 'Päivitetty {date}',
  after_me_public_chat_cta: 'Kysy ymmärtääksesi',
  after_me_public_chat_error: 'Keskustelua ei voitu avata juuri nyt.',
  after_me_emotional_context_title: 'Mistä nämä sanat tulevat?',
  after_me_emotional_context_help: 'Valitse vain, jos se helpottaa sanojesi ymmärtämistä.',
  after_me_emotional_context_vulnerable: 'Haavoittuvuus',
  after_me_emotional_context_grateful: 'Kiitollisuus',
  after_me_emotional_context_hopeful: 'Toivo',
  after_me_emotional_context_uncertain: 'Epävarmuus',
  after_me_emotional_context_peaceful: 'Rauha',
  after_me_reader_invitation_title: 'Miten haluat tulla kohdatuksi?',
  after_me_reader_invitation_help: 'Tee selväksi, miten haluat tulla kohdatuksi.',
  after_me_reader_invitation_listen: 'Kuuntele vain',
  after_me_reader_invitation_ask: 'Kysy minulta',
  after_me_reader_invitation_understand_together: 'Ymmärretään yhdessä',
  after_me_reader_invitation_keep: 'Pidä tästä huolta',
  after_me_public_emotional_context_label: 'Sanat tulevat',
  after_me_public_reader_invitation_label: 'Haluan tulla kohdatuksi näin',
  after_me_legacy_help: 'Tämä on valinnainen. Se voi antaa suuntaa läheisillesi.',
  after_me_step_boundaries_title: 'Mitä et halua?',
  after_me_step_sharing_title: 'Kenen tulisi tietää?',
  after_me_label_visibility: 'Kuka voi nähdä tämän?',
  after_me_label_activation_mode: 'Milloin tämän pitäisi näkyä?',
  after_me_label_intentions: 'Mitä toivot tämän antavan?',
  after_me_label_message_text: 'Jotain, jonka haluan muiden tietävän',
  after_me_label_grave_choice: 'Haudan muoto',
  after_me_label_ceremony_choice: 'Seremonian muoto',
  after_me_label_place_choice: 'Toivottu paikka',
  after_me_label_religious_preference: 'Haluatko uskonnollisen kehyksen?',
  after_me_label_body_title: 'Keho',
  after_me_label_body_choice: 'Onko sinulla toive tuhkauksesta tai arkkuhautauksesta?',
  after_me_label_legacy_focus: 'Suunta',
  after_me_label_legacy_reason: 'Jos haluat, kirjoita yksi lause miksi.',
  after_me_label_boundaries: 'Mitä et halua?',
  after_me_visibility_moons: 'Kuut',
  after_me_visibility_family_friends: 'Perhe ja ystävät',
  after_me_visibility_self_only: 'Vain minä',
  after_me_activation_show_when_deceased: 'Näytä, jos muiden pitää tehdä valintoja puolestani',
  after_me_activation_visible_now: 'Näkyvissä nyt',
  after_me_intention_calm: 'Rauha',
  after_me_intention_clarity: 'Selkeys',
  after_me_intention_closeness: 'Läheisyys',
  after_me_intention_calm_help: 'Jotta läheisten ei tarvitse arvailla.',
  after_me_intention_clarity_help: 'Jotta valintasi on helppo ymmärtää.',
  after_me_intention_closeness_help: 'Jotta se, mitä tapahtuu, voi tuntua aidolta.',
  after_me_choice_unsure: 'Epävarma',
  after_me_choice_both: 'Molemmat',
  after_me_grave_choice_physical: 'Fyysinen hauta',
  after_me_grave_choice_nettgrav: 'Verkkohauta',
  after_me_ceremony_choice_small: 'Pieni',
  after_me_ceremony_choice_open: 'Avoin',
  after_me_ceremony_choice_none: 'Ei mitään',
  after_me_body_choice_cremation: 'Tuhkaus',
  after_me_body_choice_coffin_burial: 'Arkkuhautaus',
  after_me_place_choice_church: 'Kirkko',
  after_me_place_choice_nature: 'Luonto',
  after_me_place_choice_home: 'Koti',
  after_me_religious_preference_religious: 'Kyllä',
  after_me_religious_preference_non_religious: 'Ei',
  after_me_legacy_focus_knowledge: 'Tieto',
  after_me_legacy_focus_knowledge_help: 'Ymmärrys, joka voi tehdä elämästä selkeämpää ja pidempää.',
  after_me_legacy_focus_health: 'Terveys',
  after_me_legacy_focus_health_help:
    'Työ, joka voi auttaa siihen, että harvempi elämä päättyy liian varhain.',
  after_me_legacy_focus_care: 'Huolenpito',
  after_me_legacy_focus_care_help:
    'Arvokkuutta ja läheisyyttä siellä, missä ihmiset ovat haavoittuvimmillaan.',
  after_me_legacy_focus_nature: 'Luonto',
  after_me_legacy_focus_nature_help: 'Elämän jatkuvuus ja se, mikä kantaa meitä eteenpäin.',
  after_me_legacy_focus_creation: 'Luominen',
  after_me_legacy_focus_creation_help: 'Se, mitä ihminen rakentaa, ilmaisee ja vie eteenpäin.',
  after_me_legacy_focus_freedom: 'Vapaus',
  after_me_placeholder_message_text: 'Onko jotain, minkä haluat tehdä selväksi läheisillesi?',
  after_me_placeholder_legacy_reason: 'Kirjoita lyhyt lause…',
  after_me_placeholder_boundaries: 'Joskus tärkeintä on asettaa raja.',
  after_me_status_ready: 'Selkeä',
  after_me_status_draft: 'Luonnos',
  after_me_status_ready_hint: 'Voit tehdä muutoksia milloin tahansa.',
  after_me_save_state_idle: 'Luonnos',
  after_me_save_state_saving: 'Tallennetaan…',
  after_me_save_state_saved: 'Tallennettu',
  after_me_save_state_error: 'Tallennus epäonnistui',
  after_me_back: 'Takaisin',
  after_me_next: 'Jatka',
  after_me_mark_ready: 'Tee selkeäksi',
  after_me_update: 'Päivitä',
  after_me_mark_ready_success: 'Tallennettu selkeäksi.',
  after_me_mark_ready_needs_more: 'Tarvitsemme hieman lisää, jotta tästä tulee selkeä.',
  after_me_saved_inline: 'Selkeä versio tallennettu',
  after_me_warning_self_only: 'Vain sinä näet tämän. Muut eivät voi auttaa, jos jotain tapahtuu.',
  after_me_last_updated: 'Päivitetty {date}',
  after_me_save_error: 'Tallennus ei onnistunut juuri nyt. Yritä uudelleen.',
  after_me_error_visibility_missing: 'Valitse, kuka voi nähdä tämän.',
  after_me_error_activation_mode_missing: 'Valitse, milloin tämän tulee näkyä.',
  after_me_error_intentions_missing: 'Valitse vähintään yksi tarkoitus.',
  after_me_error_content_missing: 'Lisää muutama sana ennen kuin teet tästä selkeän.',
  after_me_error_message_text_too_long: 'Teksti on liian pitkä. Lyhennä sitä hieman.',
  after_me_error_boundaries_text_too_long:
    'Rajoja kuvaava teksti on liian pitkä. Lyhennä sitä hieman.',
  after_me_error_legacy_reason_too_long: 'Perusteluteksti on liian pitkä. Lyhennä sitä hieman.',
  after_me_practical_title: 'Yksinkertaiset valinnat',
  after_me_practical_intro: 'Tämä ei koske yksityiskohtia. Vain sitä, mikä on tärkeintä.',
  after_me_boundaries_help: 'Joskus tärkeintä on asettaa raja.',
  private: 'Yksityinen',
  relatives: 'Sukulaiset',
  need_subscription: 'Tarvitset tilauksen lisätäksesi muistoja.',
  upgrade_subscription: 'Päivitä tilaus',
  no_memories_added: 'Paikka sille, mikä jää.',
  no_memories_added_with_relation: 'Paikka sille, mikä jää.',
  no_memories_added_ceremony: 'Paikka sanoille myös nyt.',
  no_memories_added_with_relation_ceremony: 'Paikka sanoille myös nyt.',
  no_memories_added_no_relation_hint:
    'Niille, jotka kuuluivat. Valitse suhteesi nähdäksesi muistoseinän ja sen, mikä elää edelleen.',
  grave_wall_pending_review_hint:
    'Suhteesi on rekisteröity. Muistoseinä avautuu, kun Verkkohauta on hyväksynyt haudan.',
  input_memory_placeholder: 'Jätä muutama sana tähän.',
  input_memory_placeholder_ceremony: 'Kirjoita kun tarvitset sitä.',
  memory_discard_message: 'Haluatko varmasti hylätä muutokset?',
  discard_changes: 'Hylkää muutokset?',
  discard: 'Hylkää',
  discard_cancel: 'Jatka muokkaamista',
  post_update_success: 'Julkaisu päivitetty',
  post_share_success: 'Julkaisu jaettu',
  post_share_failed: 'Julkaisun jakaminen epäonnistui. Yritä uudelleen.',
  post_failed: 'Julkaisu epäonnistui. Yritä uudelleen.',
  company_request_approved: 'Yrityspyyntö hyväksytty',
  company_request_declined: 'Yrityspyyntö hylätty',
  ad_request_approved: 'Mainospyyntö hyväksytty',
  ad_request_declined: 'Mainospyyntö hylätty',
  spark_comment_create_failed: 'Kommentin luonti epäonnistui',
  spark_comment_update_failed: 'Kommentin päivitys epäonnistui',
  settings_notification_preferences_saved: 'Ilmoitusasetukset tallennettu',
  file_upload_failed: 'Tiedoston lataus epäonnistui',
  posting: 'Julkaistaan…',
  updating: 'Päivitetään…',
  edit_post: 'Muokkaa julkaisua',
  update_memory: 'Päivitä',
  create_memory_post: 'Julkaise hautaan',
  memory_description_placeholder: 'Jätä muutama sana tähän.',
  add_photos_videos: 'Lisää kuvia/videoita',
  click_or_drag_media: 'Klikkaa tai raahaa media tänne',
  edit_image: 'Muokkaa kuvaa',
  edit_video: 'Muokkaa videota',
  add_caption: 'Lisää kuvateksti…',
  memory_deleted_success: 'Muisto poistettu!',
  memory_delete_failed: 'Muiston poisto epäonnistui.',
  memory_load_failed: 'Julkaisua ei voitu ladata. Yritä uudelleen.',
  comments_load_failed: 'Kommentteja ei voitu ladata. Yritä uudelleen.',
  comment_delete_failed: 'Kommenttia ei voitu poistaa. Yritä uudelleen.',
  grave_wall_load_failed: 'Hautaseinää ei voitu ladata',
  grave_wall_load_failed_description: 'Yritä uudelleen. Sisältöäsi ei ole muutettu.',
  delete_memory_title: 'Poista tästä paikasta?',
  delete_media_confirmation:
    'Tämä poistaa median tästä paikasta. Voit lisätä sen myöhemmin uudelleen.',
  delete_img_title: 'Poista tästä paikasta?',
  delete_memory_content:
    'Tämä poistaa sisällön tästä paikasta. Voit lisätä sen myöhemmin uudelleen.',
  delete_memory_confirm: 'Poista',
  write_something_or_add_media:
    'Säde tarvitsee jotain syttyäkseen. Jaa kuva, muisto tai muutama sana – ja anna sen loistaa.',
  empty_grave_post_warning:
    'Hautajulkaisu tarvitsee jotain jaettavaa. Lisää kuva, muisto tai muutama sana – ja anna sen elää eteenpäin.',
  empty_memory_post_warning:
    'Et ole kirjoittanut vielä mitään. Jaa muutama sana, ajatus tai muisto ennen kuin julkaiset.',
  add_to_your_post: 'Lisää kuva tai video',
  memory_review: 'Muiston esikatselu',
  grave_wall: 'Hautaseinä',
  grave_ceremony_title: 'Kuolinilmoitus ja seremonia',
  grave_ceremony_death_notice_section: 'Kuolinilmoitus',
  grave_ceremony_ceremony_section: 'Seremonia',
  grave_ceremony_edit: 'Muokkaa',
  grave_ceremony_subtitle_ready: 'Aika ja paikka, kun ne varmistuvat.',
  grave_ceremony_subtitle_empty: 'Lisää aika ja paikka, kun ne varmistuvat.',
  grave_ceremony_published_by: 'Tiedon jakoi {name}',
  grave_ceremony_published_by_relation: '{relation} – {graveName}',
  grave_ceremony_updated_at: 'Päivitetty {dateTime}',
  grave_ceremony_when: 'Ajankohta',
  grave_ceremony_where: 'Paikka',
  grave_ceremony_place_of_death: 'Kuolinpaikka',
  grave_ceremony_message: 'Ilmoitus',
  grave_ceremony_save: 'Tallenna',
  grave_ceremony_not_set: 'Ei asetettu',
  grave_ceremony_saved: 'Seremoniatiedot tallennettu.',
  grave_ceremony_save_failed: 'Tallennus ei onnistunut juuri nyt.',
  grave_ceremony_attendance_coming: 'Tulen',
  grave_ceremony_attendance_unsure: 'Epävarma',
  grave_ceremony_attendance_not_coming: 'En pääse paikalle',
  grave_ceremony_attendance_summary: 'Vastaukset',
  grave_ceremony_attendance_prompt: 'Voitko osallistua seremoniaan?',
  grave_ceremony_response_saved: 'Vastauksesi on tallennettu.',
  grave_ceremony_response_failed: 'Vastauksen tallennus ei onnistunut juuri nyt.',
  grave_ceremony_copy_link_failed: 'Linkin kopiointi ei onnistunut juuri nyt.',
  grave_ceremony_redirecting: 'Avataan kuolinilmoitus hautasivulla…',
  grave_ceremony_timing_pending: 'Aikaa ja paikkaa ei ole vielä asetettu',
  grave_ceremony_responses_title: 'Ketkä tulevat',
  grave_ceremony_share_link: 'Jaa kuolinilmoitus',
  grave_ceremony_link_copied: 'Kuolinilmoituksen linkki kopioitu',
  grave_ceremony_responses_empty: 'Ei vastauksia vielä.',
  grave_ceremony_responses_load_failed: 'Vastauslistan haku ei onnistunut juuri nyt.',
  grave_ceremony_move_to_anniversaries: 'Siirrä merkkipäiviin nyt',
  grave_ceremony_move_to_anniversaries_saved: 'Siirretty merkkipäiviin.',
  grave_ceremony_move_to_anniversaries_failed: 'Siirto ei onnistunut juuri nyt.',
  create_grave_ceremony_visibility_notice:
    'Kuolinilmoitus julkaistaan hautaseinällä, ja sen voi jakaa muille. Voit muokata tietoja myöhemmin.',
  life_archive_menu: 'Elämäarkisto',
  media: 'Media',
  connect_grave: 'Yhdistä hauta',
  upgrade_plan_modal: 'Päivitä suunnitelma',
  more: 'Lisää',
  about_name: 'Nimi',
  about_gender: 'Sukupuoli',
  relations: 'Suhteet',
  about_birthplace: 'Syntymäpaikka',
  about_nickname: 'Lempinimi',
  about_birth_name: 'Syntymänimi',
  about_death_location: 'Kuolinpaikka',
  about_cemetery: 'Hautausmaa',
  about_birthday: 'Syntymäpäivä',
  about_death_date: 'Kuolinpäivä',
  about_relations: 'Suhteet',
  about_cause_of_death: 'Kuolinsyy',
  about_country: 'Maa',
  about_title: 'Tietoa',
  about_privacy: 'Näkyvyys',
  buried: 'Haudattu',
  edit_grave_details: 'Muokkaa hautatietoja',
  relationships: 'Suhteet',
  grave_people_tab_label: 'Ne jotka kuuluvat tähän',
  grave_people_title: 'Ne jotka kuuluvat tähän',
  grave_people_title_with_name: 'Ne jotka olivat lähellä henkilöä {name}',
  grave_people_subtitle_with_name: 'Nämä ovat ihmiset, jotka olivat osa henkilön {name} elämää.',
  work: 'Työ',
  announcements: 'Kuolinilmoitukset',
  grave_link: 'Yhdessä',
  grave_link_header: '{graveName}, {relation}, on yhdistetty',
  placeholder_name: 'Anna nimi',
  placeholder_nickname: 'Anna lempinimi',
  placeholder_birth_name: 'Anna syntymänimi',
  placeholder_birthplace: 'Anna syntymäpaikka',
  placeholder_death_location: 'Anna kuolinpaikka',
  placeholder_gender: 'Valitse sukupuoli',
  placeholder_country: 'Valitse maa',
  placeholder_municipality: 'Valitse kunta',
  placeholder_cemetery: 'Valitse hautausmaa',
  placeholder_cause_of_death: 'Valitse kuolinsyy',
  placeholder_privacy: 'Valitse näkyvyys',
  placeholder_date_of_birth: 'Valitse syntymäaika',
  placeholder_time_of_birth: 'Valitse syntymäaika',
  placeholder_date_of_death: 'Valitse kuolinaika',
  placeholder_time_of_death: 'Valitse kuolinaika',
  grave_owner: 'haparantaja',
  admin: 'ylläpitäjä',
  edit_relation: 'Muokkaa suhdetta',
  remove_member: 'Poista jäsen',
  confirm_delete_user_title: 'Oletko varma?',
  confirm_button: 'Poista',
  cancel_button: 'Säilytä',
  confirm_delete_message:
    'Tämä poistaa käyttäjän {username} perheenjäsenenä. Voit lisätä käyttäjän {username} myöhemmin uudelleen.',
  confirm_remove_member_self_title: 'Haluatko poistua tältä haudalta?',
  confirm_remove_member_self_message:
    'Menetät käyttöoikeuden nyt, mutta voit liittyä uudelleen myöhemmin.',
  confirm_remove_member_other_title: 'Poistetaanko {username} tältä haudalta?',
  confirm_remove_member_other_message:
    '{username} menettää käyttöoikeuden nyt, mutta hänet voi kutsua uudelleen myöhemmin.',
  relation_to_buried: 'Heidän suhteensa sinuun',
  relation_to_user: 'Suhteesi vainajaan',
  role_required: 'Valitse rooli',
  relation_required: 'Valitse suhde',
  direction_required: 'Valitse suhteen suunta.',
  relation_you_are_prefix: 'Olet',
  relation_you_are_suffix: '{name}lle',
  relation_they_are_prefix: '{name} on sinun',
  invitation_relation_you_are_prefix: 'Kutsuttu on',
  invitation_relation_you_are_suffix: '{name}lle',
  invitation_relation_they_are_prefix: '{name} on kutsutun',
  invite_family_member: 'Kutsu joku',
  grave_people_invite_button: 'Anna perheelle pääsy',
  email_required: 'Anna sähköposti',
  email_required_validation: 'Anna kelvollinen sähköposti',
  name_required: 'Anna nimi',
  pending_invitations: 'Odotuvat kutsut',
  find_grave_member: 'Hae suhteista',
  grave_people_pending_invitations: 'Odottavat kutsut',
  grave_people_search_placeholder: 'Etsi henkilö',
  grave_people_search_failed: 'Henkilöitä ei voitu hakea. Yritä uudelleen.',
  grave_people_search_empty_title: 'Ei tuloksia',
  grave_people_search_empty_message: 'Kokeile toista nimeä.',
  grave_invitations_load_failed: 'Kutsuja ei voitu ladata.',
  relation_requests_load_failed: 'Suhdepyyntöjä ei voitu ladata.',
  relation_request_update_failed: 'Suhdepyyntöä ei voitu päivittää.',
  grave_invitation_sent: 'Kutsu on lähetetty.',
  grave_invitation_updated: 'Kutsu on päivitetty.',
  find_invited_user: 'Etsi kutsumiasi',
  find_workplace: 'Etsi työpaikka',
  add_workplace: 'Lisää työpaikka',
  company_name_label: 'Yrityksen nimi',
  company_name_placeholder: 'Anna yrityksen nimi',
  company_name_required: 'Yrityksen nimi vaaditaan',
  city_label: 'Kaupunki',
  city_placeholder: 'Anna kaupunki',
  city_required: 'Kaupunki vaaditaan',
  position_label: 'Titteli',
  position_placeholder: 'Anna titteli',
  position_required: 'Asema vaaditaan',
  start_year_label: 'Aloitusvuosi',
  start_year_placeholder: 'Valitse aloitusvuosi',
  start_year_required: 'Aloitusvuosi vaaditaan',
  end_year_label: 'Päättymisvuosi',
  end_year_placeholder: 'Valitse päättymisvuosi',
  end_year_required: 'Päättymisvuosi vaaditaan',
  description_label: 'Kuvaus',
  description_placeholder: 'Syötä työhön liittyvä kuvaus',
  publicPrivacy_label: 'Yksityisyys',
  publicPrivacy_placeholder: 'Valitse yksityisasetus',
  publicPrivacy_required: 'Yksityisyyden valinta vaaditaan',
  invalid_end_date: 'Epäkelpo päättymispäivä',
  invalid_end_date_message: 'Päättymispäivä tulee aloituspäivän jälkeen.',
  no_workplaces_added: 'Paikkoja, jotka kuuluivat elämään.',
  add_workplaces_message: 'Valitse suhteesi lisätäksesi työpaikkoja, joilla oli merkitystä.',
  add_workplaces_message_member: 'Täällä voit lisätä, missä henkilö työskenteli elämänsä aikana.',
  no_invitations_sent: 'Jaa hauta läheisillesi',
  no_invitations_message: 'Kutsu perhe ja ystävät olemaan läsnä – silloin kun heille sopii.',
  grave_people_empty_title: 'Ei odottavia kutsuja',
  grave_people_empty_message: 'Lähettämäsi kutsut näkyvät täällä, kunnes niihin vastataan.',
  grave_relation_responsible: 'Vastaa',
  grave_people_owner_tag: 'Hautaa ylläpitävä',
  photos: 'Albumi',
  find_interests: 'Etsi kiinnostuksen kohteita',
  add_interest: 'Lisää kiinnostus',
  interest_name: 'Kiinnostuksen nimi',
  interest_name_placeholder: 'Syötä kiinnostuksen nimi',
  interest_name_required: 'Kiinnostuksen nimi vaaditaan',
  interest_category: 'Kategoria',
  interest_category_placeholder: 'Valitse kategoria',
  interest_category_required: 'Kategoria vaaditaan',
  interest_description: 'Kuvaus',
  interest_description_placeholder: 'Syötä kuvaus',
  interest_description_required: 'Kuvaus vaaditaan',
  confirm_delete_workplace_message:
    'Tämä poistaa työpaikan. Voit lisätä työpaikan myöhemmin uudelleen.',
  confirm_delete_interests_message:
    'Tämä poistaa kiinnostuksen. Voit lisätä kiinnostuksen myöhemmin uudelleen.',
  confirm_delete_payment_method_message: 'Tämä poistaa maksutavan. Voit lisätä uuden myöhemmin.',
  no_interests_added: 'Se, mikä toi iloa, rauhaa tai uteliaisuutta.',
  add_interests_message: 'Valitse suhteesi jakaaksesi kiinnostuksia, jotka kuuluivat elämään.',
  add_interests_message_member:
    'Täällä voit jakaa, mikä herätti uteliaisuuden, inspiroi tai sai heidät hymyilemään.',
  add_passion: 'Lisää intohimo',
  confirm_delete_passion_message:
    'Tämä poistaa intohimon tästä paikasta. Voit lisätä intohimon myöhemmin uudelleen.',
  confirm_delete_gift_message:
    'Tämä poistaa lahjan tästä paikasta. Voit lisätä lahjan myöhemmin uudelleen.',
  passion_description: 'Intohimon kuvaus',
  passion_description_placeholder: 'Syötä intohimon kuvaus',
  passion_description_required: 'Intohimon kuvaus vaaditaan',
  no_passion_added: 'Se, mikä toi energiaa ja merkitystä.',
  add_passion_message: 'Valitse suhteesi lisätäksesi intohimoja, joilla oli merkitystä.',
  add_passion_message_member:
    'Lisää, mistä he todella välittivät – mikä antoi energiaa, merkitystä tai iloa.',
  no_grave_linked: 'Yhteydet tuovat yhteyttä.',
  add_grave_linked_message:
    'Näytä, miten {firstName} liittyy perheeseensä. Kytke {firstName} niihin, jotka merkitsevät – riippumatta siitä, missä haudat ovat.',
  grave_link: 'Yhdessä',
  grave_link_empty_primary: 'Jotkin haudat kuuluivat yhteen elämässä.',
  grave_link_empty_secondary:
    'Täällä ne voivat olla yhdessä – riippumatta siitä, minne ne on haudattu.',
  grave_link_empty_tertiary: 'Valitse suhteesi yhdistääksesi heidät verkkohaudassa.',
  grave_link_empty_image_alt: 'Kaksi toisiinsa yhdistettyä hautaa',
  grave_link_open_grave: 'Avaa henkilön {name} hauta',
  grave_link_more_actions: 'Lisää hautayhteyden toimintoja',
  grave_link_removed: 'Hautayhteys on poistettu.',
  grave_link_remove_failed: 'Yhteyden poistaminen ei onnistunut. Yritä hetken kuluttua uudelleen.',
  grave_link_updated: 'Hautayhteys on päivitetty.',
  photo_albums_manage: 'Muokkaa kokoelmaa',
  upload_photo: 'Lataa kuva',
  photo_uploading_title: 'Ladataan kuvia',
  photo_album_system_name: 'Kootut kuvat',
  photo_album_images_count: '{count, plural, one {# kuva} other {# kuvaa}}',
  photo_album_empty_count: 'Ei kuvia vielä',
  photo_tagging_label: 'Näytä myös muilla haudoilla',
  photo_tagging_placeholder: 'Valitse haudat',
  photo_tagged_section_title: 'Kuvat, jotka jaetaan muiden hautojen kanssa',
  photo_tagged_source: 'Myös haudalla {graveName}',
  photo_tagged_open_original: 'Katso alkuperäinen',
  photo_upload_progress: 'Ladataan {completed}/{total}',
  photo_upload_partial_failure:
    '{successCount} kuvaa ladattiin, {failedCount} epäonnistui. Voit yrittää uudelleen.',
  photo_album_delete_confirm_title: 'Poistetaanko albumi?',
  photo_album_delete_confirm_body: 'Kuvia ei poisteta. Ne siirretään Kootut kuvat -albumiin.',
  photo_album_delete_confirm_body_with_images:
    'Kuvat ovat edelleen saatavilla Kootut kuvat -albumissa.',
  photo_album_delete_confirm_body_empty: 'Tämä albumi on tyhjä ja se poistetaan.',
  photo_album_delete_confirm_action: 'Poista albumi',
  photo_delete_image_title: 'Poistetaanko kuva?',
  photo_delete_image_content:
    'Kuva poistetaan tältä haudalta. Voit lisätä sen myöhemmin uudelleen.',
  photo_delete_failed: 'Kuvaa ei voitu poistaa. Yritä uudelleen.',
  grave_photos_loading: 'Ladataan kuvia',
  grave_photos_load_failed: 'Kuvia ei voitu ladata',
  grave_photos_load_failed_description: 'Yritä uudelleen. Sisältöäsi ei ole muutettu.',
  grave_photos_retry: 'Yritä uudelleen',
  grave_photos_load_more: 'Näytä lisää kuvia',
  grave_photos_load_more_failed: 'Lisää kuvia ei voitu ladata.',
  photo_albums_load_failed: 'Albumikokoelmaa ei voitu ladata.',
  grave_photo_alt: 'Kuva henkilön {name} hautapaikalla',
  photo_comment_action_failed: 'Kommenttia ei voitu tallentaa. Yritä uudelleen.',
  photo_comment_delete_title: 'Poistetaanko kommentti?',
  photo_comment_delete_content: 'Kommentti poistetaan pysyvästi.',
  photo_move_to_album: 'Siirrä albumiin',
  photo_move_to_album_title: 'Siirrä kuva albumiin',
  photo_move_to_album_placeholder: 'Valitse albumi',
  no_photos_added: 'Tänne kuvat voivat kertyä ajan myötä.',
  add_photos_message: 'Kun kuva lisätään, siitä tulee osa tarinaa.',
  album_empty_primary: 'Kuvia, jotka kertyvät ajan myötä.',
  album_empty_album_title: 'Ei kuvia vielä',
  album_empty_album_message: 'Kun kuva lisätään, siitä tulee osa tarinaa.',
  album_empty_secondary: 'Valitse suhteesi lisätäksesi kuvia ja nähdäksesi enemmän tarinaa.',
  album_empty_cta: 'Yhdistä {firstName}',
  select_cover_photo: 'Valitse kansikuva',
  add_photos: 'Lisää kuvia',
  choose_cover_photo: 'Valitse kansikuva',
  adjust_cover_position: 'Säädä sijaintia',
  upload_image: 'Lisää kuva',
  remove_image: 'Poista kannesta',
  remove_grave_avatar: 'Poista profiilikuva',
  grave_avatar_removed: 'Profiilikuva poistettu.',
  grave_avatar_remove_failed: 'Profiilikuvan poistaminen epäonnistui.',
  edit_profile_photo: 'Muokkaa profiilikuvaa',
  edit_cover_image: 'Muokkaa hauta-kansikuvaa',
  add_cover_photo: 'Lisää kansikuva',
  edit: 'Muokkaa',
  upload_photos: 'Lataa kuvia',
  label_description: 'Kuvaus',
  placeholder_description: 'Syötä kuvaus',
  label_address: 'Osoite',
  placeholder_address: 'Syötä osoite',
  date_time: 'Päivämäärä ja aika',
  create_anniversary: 'Luo merkkipäivä',
  edit_anniversary: 'Muokkaa merkkipäivää',
  add_life_event: 'Lisää tarina',
  no_events_added: '{firstName}n kirja kokoaa tarinat, jotka kuuluvat {firstName}n elämään.',
  life_events_empty_primary: 'Täällä elämän tarinat saavat tilaa.',
  life_events_empty_secondary: 'Liity hautaan, jos haluat jakaa muistoja ja tarinoita.',
  life_events_empty_cta: 'Yhdistä {firstName}',
  add_events_message:
    'Täällä voit jakaa muistoja, hetkiä ja sanoja, jotka kertovat kuka {firstName} oli.',
  life_events_load_failed: 'Elämäntarinaa ei voitu ladata.',
  life_events_load_failed_description: 'Yritä uudelleen. Sisältöäsi ei ole muutettu.',
  try_again: 'Yritä uudelleen',
  life_event_media_update_failed: 'Kuvaa ei voitu päivittää. Yritä uudelleen.',
  life_event_media_delete_failed: 'Mediaa ei voitu poistaa. Yritä uudelleen.',
  event_label_name: 'Tarina otsikko',
  event_placeholder_name: 'Syötä otsikko',
  event_required_name: 'Otsikko vaaditaan',
  event_label_date: 'Tarina päivämäärä',
  event_placeholder_date: 'Valitse päivämäärä',
  event_required_date: 'Päivämäärä vaaditaan',
  event_label_theme: 'Valitse teema',
  event_placeholder_theme: 'Valitse teema',
  event_required_theme: 'Teema vaaditaan',
  event_label_country: 'Maa',
  event_placeholder_country: 'Valitse maa',
  event_required_country: 'Maa vaaditaan',
  event_theme_selected: 'Valittu väri:',
  event_label_description: 'Tarinateksti',
  event_placeholder_description: 'Kirjoita tarina tähän',
  event_required_description: 'Tarinateksti vaaditaan',
  event_theme_light: 'Vaalea teema',
  event_theme_dark: 'Tumma teema',
  create_event: 'Luo tarina',
  create_event_grave_info: 'Lisää elämäntapahtuma {graveName}n haudalle.',
  edit_event: 'Muokkaa tarinaa',
  show_all: 'Näytä kaikki',
  set_as_cover: 'Aseta kansikuvaksi',
  creator: 'Tekijä',
  previous: 'Edellinen',
  view_more_events: 'Näytä lisää elämänkertatarinoita',
  view_more: 'Näytä lisää',
  connect_grave_title: 'Haudat, jotka voit liittää {graveName}',
  connect_grave_select_title: 'Valitse hauta, johon haluat liittää',
  connect_grave_relations_title: 'Aseta suhteet',
  connect_grave_relation_subject: '{name} on',
  connect_grave_relation_object: '{name}lle',
  connect_grave_confirm: 'Yhdistä haudat',
  connect_grave_section_direct: 'Omat haudat',
  connect_grave_section_other: 'Muut asiaankuuluvat',
  link_to_grave: 'Yhdistä tähän hautaan',
  your: 'Sinun',
  graves_not_found: 'Ei hautoja saatavilla juuri nyt.',
  connect_grave_empty_title: 'Muita hautoja ei ole täällä vielä',
  connect_grave_empty_message: 'Kun saat pääsyn useampaan, voit liittää ne yhteen.',
  connect_grave_load_failed: 'Hautojen lataaminen ei onnistunut juuri nyt.',
  share: 'Jaa',
  linked_copied: 'Linkki kopioitu',
  share_memory: 'Jaa muisto',
  copy_link: 'Kopioi linkki',
  media_not_added: 'Ei mediaa lisätty.',
  delete_event_title: 'Vahvista tarinan poisto?',
  grave_is_private_title: '{graveName}n hauta on yksityinen',
  grave_is_private_message: 'Vain läheiset sukulaiset näkevät muistit ja tarinat täällä.',
  grave_relations_private_title: 'Suhteet ovat yksityisiä',
  grave_relations_private_message: 'Koska hauta on yksityinen, suhteet näkyvät vain läheisille.',
  grave_user_not_found_message:
    '{firstName}n ympärille kokoontuvat suhteet. Aloita itsestäsi ja lisää ne, jotka merkitsevät.',
  grave_user_not_found_message_primary: '{firstName}n ympärille kokoontuvat suhteet.',
  grave_user_not_found_message_secondary: 'Aloita itsestäsi ja lisää ne, jotka merkitsevät.',
  grave_relations_empty_primary: 'Täällä näet, ketkä kuuluvat mukaan.',
  grave_relations_empty_secondary:
    'Liity hautaan nähdäksesi, ketkä kuuluvat mukaan {firstName}n ympärillä.',
  grave_relations_empty_cta: 'Yhdistä {firstName}',
  connect_with_grave: 'Valitse suhteesi henkilöön {graveName}',
  connect_grave_message:
    'Aseta suhteesi rakkaaseen. Vaatii Premium-tilauksen. Päivitä päästäksesi.',
  cancel_relation_request: 'Peruuta suhdepyyntö',
  cancel_claim_request: 'Peruuta omistajuuspyyntö',
  grave_welcome_title: 'Tervetuloa {name}n haudalle.',
  grave_intro_text: 'Täällä voit lukea, pohtia, jakaa tarinoita tai vain olla hiljaa.',
  grave_natural_feelings_text:
    'On luonnollista ajatella omaa elämää ja menetyksiä, kun vierailet haudalla. Se on täysin ok. Et ole yksin.',
  grave_what_you_can_do_title: 'Tässä voit:',
  grave_read_stories: 'Lukea tarinoita ja muistoja',
  grave_react_comment_care: 'Reagoida ja kommentoida',
  grave_share_reflections: 'Jakaa omia pohdintoja',
  grave_light_candle: 'Olla lähellä merkkipäivinä ja kutsua muita vainajan tunteneita',
  grave_why_nettgrav_matters_title: 'Verkkohaudan missio',
  grave_support_end_of_time_center:
    'Jokainen Verkkohauta tukee End Of Time Centerin työtä kohti terveempää maailmaa, jossa harvempi kuolee sairauksiin.',
  grave_team_end_of_time_message:
    'Verkkohaudassa voit myös lukea viestejä yhteistyökumppaneiltamme – yrityksiltä, jotka haluavat tehdä enemmän puolestasi ja edistää parempaa maailmaa.',
  grave_enter_grave_button: 'Sulje',
  my_light_welcome_title: 'Minun Valoni',
  my_light_you_are_the_light: 'Sinä olet valo.',
  my_light_intro_text: 'Tämä on tilasi.',
  my_light_sparks_relationships_graves: 'Tänne tulee ratkaisuja siihen mikä merkitsee.',
  my_light_what_you_find_here_title:
    'Kaiken täällä rakennetun tavoitteena on tukea hyviä sosiaalisia elämiä.',
  my_light_sparks: 'Voiman, huolenpidon ja inhimillisen läheisyyden varassa.',
  my_light_graves: 'Tämä on paikka sinulle.',
  my_light_loved_ones: 'Sille mitä kannat, ja mitä haluat antaa eteenpäin.',
  my_light_everything_begins_with_you: 'Lisää on tulossa.',
  my_light_enter_button: 'Ymmärretty',
  my_light_profile_occupation_label: 'Ammatti tai rooli',
  my_light_profile_occupation_placeholder: 'Mitä teet työksesi?',
  my_light_profile_bio_label: 'Tietoa minusta',
  my_light_profile_bio_placeholder: 'Kirjoita muutama rivi itsestäsi',
  compass_tab: 'Kompassini',
  compass_title: 'Kompassini',
  compass_title_other: 'Näin {name} pitää suuntansa',
  compass_subtitle: 'Se, minkä mukaan yritän elää.',
  compass_empty_lead: 'Jotkut haluavat kirjoittaa ylös suunnan, josta haluavat pitää kiinni.',
  compass_empty_copy: 'Se voi selkeyttää sekä elämää että ihmissuhteita.',
  compass_empty_cta: 'Kirjoita kompassini',
  compass_help_primary: 'Kirjoita se niin kuin se on sinulle.',
  compass_label_pressure_pattern: 'Se mikä vie minut pois suunnasta',
  compass_nav_pressure_pattern: 'Pois suunnasta',
  compass_help_pressure_pattern: 'Mikä saa sinut yleensä menettämään suunnan?',
  compass_placeholder_pressure_pattern: 'Kun haluan olla pidetty enemmän kuin rehellinen.',
  compass_label_anchor_statement: 'Se mistä en tingi',
  compass_nav_anchor_statement: 'En tingi tästä',
  compass_help_anchor_statement: 'Se mistä en tingi.',
  compass_placeholder_anchor_statement: 'En valehtele itselleni.',
  compass_label_choice_question: 'Kysymys joka pitää minut suunnassa',
  compass_nav_choice_question: 'Kysymykseni',
  compass_help_choice_question: 'Yksi kysymys ennen tärkeitä valintoja.',
  compass_placeholder_choice_question: 'Onko tämä totta vai vain turvallista?',
  compass_label_known_for: 'Näin huomaat että olen pois suunnasta',
  compass_nav_known_for: 'Näin huomaat sen',
  compass_help_known_for: 'Mitä muut voivat huomata.',
  compass_placeholder_known_for: 'Hiljenen ja vetäydyn.',
  compass_label_growth_edge: 'Näin löydän takaisin',
  compass_nav_growth_edge: 'Näin löydän takaisin',
  compass_help_growth_edge: 'Mikä auttaa sinua palaamaan suuntaan?',
  compass_placeholder_growth_edge: 'Tarvitsen hiljaisuutta ja yhden rehellisen keskustelun.',
  compass_label_visibility: 'Näkyvyys',
  compass_visibility_self_only: 'Vain minä',
  compass_visibility_moons: 'Kuut',
  compass_visibility_family_friends: 'Perhe ja ystävät',
  compass_visibility_public: 'Julkinen',
  compass_visibility_shown_for: 'Näkyy: {visibility}',
  compass_visibility_owner_hint:
    'Näin kompassisi näkyy muille valitsemasi näkyvyysasetuksen perusteella.',
  compass_visibility_reason_family_friends:
    'Näet tämän, koska sinut on merkitty perheeksi tai ystäväksi.',
  compass_visibility_reason_moons: 'Näet tämän, koska sinut on merkitty kuuksi.',
  compass_visibility_reason_public: 'Näet tämän, koska kompassi on jaettu julkisesti.',
  compass_visibility_reason_default: 'Näkyvyyttä hallitsee omistaja.',
  compass_safety_hint: 'Kompassisi voi muuttua, kun elämä muuttuu.',
  compass_share_nudge: 'Haluatko jakaa kompassin läheisten kanssa?',
  compass_share_nudge_moons: 'Jaa kuille',
  compass_share_nudge_family: 'Jaa perheelle ja ystäville',
  compass_share_nudge_public: 'Jaa julkisesti',
  compass_step_indicator: 'Kenttä {current}/{total}',
  compass_step_counter: '{current}/{total}',
  compass_summary_title: 'Näin pysyn suunnassa',
  compass_prev: 'Edellinen',
  compass_prev_alt: '← Edellinen',
  compass_prev_to: '← Kohtaan {label}',
  compass_next: 'Jatka',
  compass_next_alt: 'Seuraava →',
  compass_next_to: 'Kohtaan {label} →',
  compass_save: 'Tallenna',
  compass_saving: 'Tallennetaan...',
  compass_saved: 'Tallennettu',
  compass_save_error: 'Tallennus ei onnistunut juuri nyt.',
  compass_signal_cta: 'Kiitos kun jaoit',
  compass_signal_sent: 'Merkki lähetetty',
  compass_signal_sent_to: 'Kiitos lähetetty käyttäjälle {name}',
  compass_signal_toast_sent: 'Kiitos lähetetty.',
  compass_signal_error: 'Kiitoksen lähetys ei onnistunut juuri nyt.',
  compass_signal_hint:
    'Hiljainen kiitos siitä, että he jakoivat kompassinsa. Sitä ei näytetä julkisesti.',
  compass_signal_sent_hint: 'Se näkyy vain käyttäjälle {name}.',
  compass_signal_guest_hint: 'Kirjaudu sisään antaaksesi heille tietää, että näit tämän.',
  compass_signal_guest_cta: 'Kirjaudu sisään',
  compass_can_change: 'Voit muuttaa tätä milloin tahansa.',
  compass_shared_none: 'Kompassia ei ole vielä jaettu.',
  my_light_profile_cancel: 'Sulje',
  my_light_profile_save: 'Tallenna',
  my_light_about_title: 'Minusta',
  conversation_starters_tab_self: 'Kysy minulta',
  conversation_starters_tab_other: 'Kysy käyttäjältä {name}',
  conversation_starters_title_self: 'Kysy minulta',
  conversation_starters_title_other: 'Kysy käyttäjältä {name}',
  conversation_starters_subtitle: 'Jotkin keskustelut tarvitsevat vain paikan alkaa.',
  conversation_starters_placeholder: 'Kirjoita jotain, josta muut voivat kysyä sinulta',
  conversation_starters_suggestion_1: 'miksi minä',
  conversation_starters_suggestion_2: 'miten minä',
  conversation_starters_suggestion_3: 'mitä opin, kun',
  conversation_starters_suggestion_4: 'mikä sai minut',
  conversation_starters_visibility_label: 'Kuka voi nähdä tämän?',
  conversation_starters_visibility_everyone: 'Kaikki',
  conversation_starters_visibility_moons: 'Kuut',
  conversation_starters_visibility_family_friends: 'Perhe ja ystävät',
  conversation_starters_visibility_self_only: 'Vain minä',
  conversation_starters_add: 'Lisää',
  conversation_starters_ask: 'Kysy käyttäjältä {name}',
  conversation_starters_chat_draft:
    'Hei {name}. Kirjoitit, että voin kysyä sinulta aiheesta ”{starter}”.',
  conversation_starters_empty: 'Lisää jotain, joka voi avata hyvän keskustelun.',
  conversation_starters_save_error: 'Keskustelunavausta ei voitu tallentaa juuri nyt.',
  conversation_starters_delete_error: 'Keskustelunavausta ei voitu poistaa juuri nyt.',
  conversation_starters_chat_error: 'Keskustelua ei voitu avata juuri nyt.',
  day_title: 'Tämä päivä',
  day_subtitle: 'Jotain pohdittavaa, joku ymmärrettäväksi ja jotain säilytettävää.',
  day_reflection_label: 'Päivän ajatus',
  day_reflection_1: 'Minkä olet ajan myötä oppinut ymmärtämään toisin?',
  day_reflection_2: 'Mikä kysymys kulkee mukanasi juuri nyt?',
  day_reflection_3: 'Mistä toivoisit useampien ihmisten olevan uteliaita?',
  day_reflection_4: 'Mitä toinen ihminen on opettanut sinulle tietämättään?',
  day_reflection_5: 'Mitä läheisyys merkitsee sinulle tänään?',
  day_reflection_action: 'Siirry Luo säde -sivulle',
  day_connection_label: 'Ymmärretään yhdessä',
  day_connection_title:
    '{name} on jakanut jotain, jonka hän haluaa ymmärtää yhdessä muiden kanssa.',
  day_connection_empty_title: 'Onko jotain, jonka haluat ymmärtää yhdessä muiden kanssa?',
  day_connection_empty_text:
    'Jaa se omin sanoin ja valitse, voiko Verkkohauta auttaa uusia ihmisiä löytämään sen.',
  day_connection_action: 'Lue ja ymmärrä yhdessä',
  day_connection_empty_action: 'Jaa omin sanoin',
  day_preserve_label: 'Säilytä',
  day_preserve_title: 'Onko olemassa kuva, jonka tarinan vain sinä tunnet?',
  day_preserve_action: 'Siirry haudoillesi',
  own_words_discovery_title: 'Anna Verkkohaudan yhdistää minut uusiin ihmisiin',
  own_words_discovery_help:
    'Nämä sanat voidaan näyttää Tämä päivä -näkymässä ihmisille, joita et tunne. Voit poistaa tämän käytöstä milloin tahansa.',
  my_light_about_subtitle: 'Muutama sana minusta, kuten elämä nyt tuntuu.',
  my_light_questions_title: 'Kolme kysymystä',
  my_light_question_1: 'Mikä on minulle tärkeää elämässä juuri nyt?',
  my_light_question_2: 'Mikä tuo minulle rauhaa, merkitystä tai energiaa arkeen?',
  my_light_question_3: 'Mitä olen oppimassa itsestäni?',
  spark_energy_tooltip: 'Säteesi tekee maailmasta paremman paikan.',
  grave_support_title: 'Mitä tämä hauta tukee?',
  grave_support_intro: 'Jokainen Verkkohauta on osa jotain suurempaa.',
  grave_support_body:
    'Tämä hauta tukee End Of Time Centeriä – tiedekeskusta yhdellä radikaalilla visiolla: Maailma ilman kuolemaa.',
  grave_support_help:
    'Yhdessä etsimme vastauksia siihen, miksi kuolemme ja miten kuolemasta saatu ymmärrys voi auttaa meitä elämään syvemmin ja myötätuntoisemmin – itseämme ja toisiamme kohtaan.',
  grave_support_read_more: 'Lue lisää End Of Time Centeristä.',
  end_of_time_center_title: 'End Of Time Center',
  end_of_time_center_intro:
    'Verkkohauta on The End Of Time Corporationin ensimmäinen tuote. Suunnittelemme End Of Time Centerin perustamista – tiedekeskuksen, jossa tutkitaan elämää ja kuolemaa radikaalilla tavoitteella: Ymmärtää kuolemaa ja luoda tulevaisuus, jossa kukaan ei tarvitse hautaa.',
  end_of_time_center_body:
    'Täällä tutkijat, visionäärit ja ongelmanratkaisijat kokoontuvat kehittämään tietoa, ratkaisuja ja uusia näkökulmia elämän suurimpiin kysymyksiin. Yhdessä haemme oivalluksia ja inspiraatiota, jotka voivat tehdä maailmasta turvallisemman, lämpimämmän – ja ehkä hieman ikuisemman.',
  end_of_time_center_close: 'Sulje',
  about_this_grave: 'Tietoa tästä haudasta',
  my_light: 'Minun Valoni',
  relation_confirmation_label: 'Automaattinen relaatio­vahvistus',
  auto_confirm_on: 'Automaattinen',
  auto_confirm_off: 'Vaatii hyväksynnän',
  relation_requests: 'Suhdepyynnöt',
  connection_request_sent_info:
    'Yhteyspyyntösi on lähetetty hautausmaan {graveName} omistajalle. Kun se hyväksytään, hauta näkyy liitetyissä haudoissasi.',
  connection_request_sent: 'Yhteyspyyntö lähetetty.',
  connection_created_unverified: 'Hautayhteys luotiin ilman hautapaikan ylläpitäjän vahvistusta.',
  connection_request_failed: 'Yhteyspyyntöä ei voitu lähettää. Yritä myöhemmin uudelleen.',
  linked_grave_unverified_status: 'Hautapaikan ylläpitäjä ei ole vahvistanut yhteyttä',
  grave_already_connected: '{graveName} is already connected',
  is_grave_already_connected: 'Is this grave already connected?',
  take_grave_ownership: 'Haluatko tulla tämän haudan omistajaksi?',
  grave_privacy_public:
    'Tämä hauta on julkinen. Kuka tahansa voi nähdä ja olla vuorovaikutuksessa julkisen sisällön kanssa.',
  grave_privacy_private:
    'Tämä hauta on yksityinen. Vain kutsutut käyttäjät näkevät sisällön. Muut eivät näe mitään.',
  grave_privacy_relatives:
    'Tämä hauta on asetettu suvuille. Sukulaiset voivat nähdä sekä sukulaissisällön että julkisen sisällön. Muut näkevät vain julkisen sisällön.',
  please_fill_all_fields: 'Täytä kaikki pakolliset kentät',
  grave_invitations: 'Haudan kutsut',
  'relationships.manageInvites': 'Kutsu perheenjäsenet ja ystävät',
  invite_you_as: 'kutsuu sinut nimikkeellä',
  grave_invitation: 'Haudankutsu',
  grave_invitations_not_found_title: 'Ei kutsuja',
  grave_invitations_not_found_subtile:
    'Et ole saanut hautakutsuja. Kun joku kutsuu sinut, näet ne täällä.',
  invited_you_to_grave: '{name} kutsui sinut hautaan',
  search_by_name: 'Hae nimellä',
  confirm_delete_linked_grave_message:
    'Tämä poistaa linkin tähän hautaan. Voit linkittää haudan myöhemmin uudelleen.',
  search_grave_heading: 'Etsi etsimäsi hauta',
  search_grave_intro: 'Hae nimellä tai rajaa tuloksia.',
  search_all_heading: 'Löydä ihmiset ja haudat',
  search_all_intro: 'Hae ihmistä tai hautaa nimellä.',
  search_all_placeholder: 'Hae ihmisiä ja hautoja',
  search_people_heading: 'Etsi etsimäsi henkilö',
  search_people_intro: 'Hae nimellä löytääksesi ihmisiä.',
  search_people_placeholder: 'Hae ihmisiä',
  search_grave_guest_cta_title: 'Kun löydät oikean haudan',
  search_grave_guest_cta_body: 'voit liittyä siihen, jättää merkin ja seurata ajan mittaan.',
  search_grave_guest_cta_button: 'Luo tili',
  search_grave_loading_title: 'Haemme hautaa...',
  search_grave_loading_subtitle: 'Tämä kestää yleensä alle sekunnin.',
  search_all_loading_title: 'Haemme tuloksia...',
  search_all_loading_subtitle: 'Tämä kestää yleensä alle sekunnin.',
  search_people_loading_title: 'Haemme jäseniä...',
  search_people_loading_subtitle: 'Tämä kestää yleensä alle sekunnin.',
  search_grave_placeholder: 'Hae nimellä',
  search_open: 'Avaa haku',
  search_open_full: 'Hae',
  search_submit: 'Hae',
  clear_search: 'Tyhjennä haku',
  close_search: 'Sulje haku',
  search_grave_none_subtext:
    'Kokeile toista nimeä tai käytä vähemmän kirjaimia. Voit myös rajata tuloksia kunnalla ja hautausmaalla.',
  search_grave_none_text: 'Ei tuloksia haulle',
  search: 'Hae',
  search_grave_perfect_matches: 'Voisiko tämä olla etsimäsi?',
  search_grave_filter_heading: 'Suodata maan, kunnan ja hautausmaan mukaan',
  search_grave_show_filters: 'Näytä lisä hakuvaihtoehtoja',
  search_grave_hide_filters: 'Piilota hakuvaihtoehdot',
  search_grave_image_heading: 'Etsi hautoja aloittaaksesi.',
  search_grave_image_subtitle: 'Kenen etsit tänään?',
  search_grave_search_for: 'Tulokset haulle',
  search_grave_no_relation_hint:
    'Voit vierailla haudalla nyt. Kun valitset suhteen, siitä tulee osa tilaasi täällä.',
  search_grave_visit_cta: 'Vieraile haudalla',
  grave_invitation_email: 'Sähköpostiosoite',
  grave_invitation_email_placeholder: 'Kirjoita sähköpostiosoite',
  grave_invitation_email_required: 'Sähköposti vaaditaan',
  grave_invitation_email_required_validation: 'Anna kelvollinen sähköposti',
  grave_invitation_invited_person_name: 'Nimi',
  grave_invitation_invited_person_name_placeholder: 'Kirjoita nimi',
  grave_invitation_name_required: 'Nimi vaaditaan',
  grave_invitation_relation_to_grave: 'Suhteenne',
  grave_invitation_relation_to_grave_modal: 'Kutsutun suhde henkilöön {graveName}',
  grave_invitation_relation_to_grave_help: 'Aseta suhde niin kuin kutsuttu henkilö sen näkee.',
  grave_invitation_relation_required: 'Suhde vaaditaan',
  grave_invitation_select_relationship: 'Valitse, miten olette yhteydessä',
  grave_invitation_select_relationship_short: 'Valitse suhde',
  grave_invitation_relation_to_person: 'Näin he näkevät {graveName}',
  grave_invitation_relation_to_person_modal: '{graveName}n suhde kutsuttuun henkilöön',
  grave_invitation_relation_to_person_help: 'Tämä näkyy kutsutun henkilön näkökulmasta.',
  grave_invitation_select_reciprocal: 'Valitse suhde (esimerkiksi vanhempi tai sisarus)',
  grave_invitation_direction_required: 'Suhteen suunta vaaditaan',
  grave_invitation_administrator_access: 'Ylläpitäjän oikeudet',
  grave_invitation_role_required: 'Rooli vaaditaan',
  grave_invitation_administrator: 'Ylläpitäjä',
  grave_invitation_normal: 'Normaali',
  anniversary_create_name: 'Nimi',
  anniversary_create_placeholder_name: 'Syötä nimi',
  anniversary_create_date_time: 'Päivämäärä',
  anniversary_create_name_required: 'Syötä nimi',
  anniversary_create_date_time_required: 'Valitse päivämäärä',
  anniversary_create_date_hint: 'Voidaan muuttaa myöhemmin.',
  anniversaries_create_title: 'Lisää merkkipäivä',
  anniversaries_create_hint: 'Kokoontumista, käyntiä tai teille tärkeää päivää varten.',
  spark_create_modal_category: 'Sädekategoria:',
  spark_suggestions_label: 'Pieniä ideoita:',
  spark_category_question: 'kysymys',
  spark_category_insight: 'oivallus',
  spark_category_experience: 'kokemus',
  spark_category_discovery: 'löytö',
  spark_category_emotion: 'tunne',
  spark_category_value: 'arvo',
  spark_category_energy: 'energia',
  spark_category_intention: 'tarkoitus',
  spark_category_Story: 'Tarina',
  spark_category_Feeling: 'Tunne',
  edit_spark: 'Muokkaa Säde',
  share_spark: 'Jaa Säde',
  extinguish_park: 'Sammuta Säde',
  spark_info_title: 'Mikä on minun Säteeni?',
  spark_info_intro:
    'Säde syntyy sinussa. Se voi olla ajatus, kysymys, kokemus tai jokin, joka saa sinut pysähtymään ja kuuntelemaan itseäsi. Kun jaat sen, se voi herättää muissa pohdintaa, läheisyyttä tai toimintaa.',
  spark_examples_title: 'Esimerkkejä Sädeestä',
  spark_form_info:
    'Valitse säteesi muoto. Näin näytät muille, miten haluat jakaa totuutesi – kysymyksenä, tarinana, oivalluksena, tunteena tai tarkoituksena.',
  spark_example_question: 'Kysymys jota pohdit.',
  spark_example_insight: 'Oivallus jonka olet saanut.',
  spark_example_experience: 'Kokemus joka kosketti sinua.',
  spark_example_value: 'Arvo jonka haluat nostaa esiin.',
  spark_why_title: 'Miksi luoda Säde?',
  spark_why_inspire: 'Innostaaksesi muita.',
  spark_why_express: 'Antaaksesi sanoja ajatuksillesi ja tunteillesi.',
  spark_why_share: 'Jakaaksesi jotain sinulle merkityksellistä.',
  spark_why_build: 'Rakennaaksesi lämpimämpää ja avoimempaa yhteisöä.',
  spark_how_title: 'Kuinka luoda Säde?',
  spark_how_step1: 'Kirjoita ajatus, kysymys tai jaa tunne.',
  spark_how_step2: 'Valitse luokka: Kysymys, Oivallus, Kokemus, Arvo, Tunne, Energia.',
  spark_how_step3: 'Julkaise – ja anna säteesi loistaa muille!',
  spark_helper_text:
    'Jaa säteesi – kysymys, ajatus tai tunne. Pienetkin sanat voivat tuoda valoa muille.',
  spark_show_inspirations: 'Inspiroidu – hae kysymys',
  spark_get_question: 'Hae kysymys',
  spark_selected_question: 'Mikä on sinun Kipinäsi?',
  spark_change_question: 'Vaihda kysymys',
  spark_optional_helper: 'Panoksesi voi olla säde muille.',
  spark_textarea_label: 'Mikä herättää sinussa Säteesi?',
  'sparks.media.limits': 'Enintään 5 kuvaa tai videota. Enintään 50 Mt tiedostoa kohden.',
  'sparks.media.tooMany': 'Voit lisätä enintään 5 kuvaa tai videota.',
  'sparks.media.tooLarge': '{name} on suurempi kuin 50 Mt.',
  'sparks.media.invalidType': '{name} ei ole tuettu kuva- tai videomuoto.',
  spark_reflection_label: 'Lisää kipinäsi vastaukseksi.',
  spark_menu_button: 'Sädemenu',
  spark_share_button: 'Jaa',
  discard_draft: 'Laita luonnos sivuun',
  share_life_event: 'Jaa elämänkertatapahtuma',
  delete_spark_title: 'Haluatko poistaa tämän säteen?',
  share_link_spark: 'Säde on valmis jaettavaksi',
  public_view_description: 'Tämä säde on jaettu kaikkien kanssa',
  moons_only_description: 'Tämä säde on jaettu kuujesi kanssa',
  constellation_description: 'Tämä säde on jaettu tähtikuviosi kanssa',
  memory_public_description:
    'Kaikki, jotka vierailevat {name}-muistosivulla Verkkohaudassa, voivat lukea tämän julkaisun.',
  memory_private_description: 'Julkaisusi näkyy vain sinulle',
  memory_relatives_description:
    'Se, mitä jaat täällä, näkyy vain henkilöille, joilla on suhde {name}:een Verkkohaudassa.',
  memory_privacy_label: 'Yksityisyys',
  memory_description_label: 'Sanat jotka jätät',
  file_remove_failed: 'Tiedoston poistaminen epäonnistui.',
  add_value: 'Lisää ominaisuus',
  spark_feeling_Reflecting: 'Pohdiskeleva',
  spark_feeling_Reflecting_description: 'Luo Gnist ajatuksesta, jota olet pohtinut paljon.',
  spark_feeling_Wonder: 'Ihme',
  spark_feeling_Wonder_description: 'Luo Gnist kysymyksestä, jota pohdit.',
  spark_feeling_Connection: 'Yhteys',
  spark_feeling_Connection_description: 'Luo Gnist, joka yhdistää ihmiset.',
  spark_feeling_Freedom: 'Vapaus',
  spark_feeling_Hopeful: 'Toivo',
  spark_feeling_Gratitude: 'Kiitollisuus',
  spark_feeling_Peace: 'Rauha',
  spark_feeling_Freedom_description:
    'Luo Gnist vapaasta, sisäisestä paikastasi – paikasta, josta tulee pitää huolta. Jaa pelkäämättä muutoksen käynnistymistä.',
  spark_feeling_tooltip: 'Valitse näkökulma',
  memory_reaction_name_Healed: 'Näytä, että se lohdutti',
  memory_reaction_name_Love: 'Näytä rakkautta',
  memory_reaction_name_Remembered: 'Minä muistan sen myös',
  memory_reaction_name_Cherished: 'Arvosta muistoa',
  views: 'näkymää',
  grave_memories: 'Hautamuistot',
  grave_memories_placeholder: 'Jätä muutama sana tähän.',
  grave_memories_message: 'Paikka jättää sanoja, kun olet käymässä.',
  grave_post_on: 'Julkaistu:',
  select_grave: 'Valitse hauta',
  select_a_grave: 'valitse hauta',
  user_values_title: 'Tämän näemme {name}ssa',
  user_values_menu: 'Tämän näen {name}ssa',
  profile_values_tab_self: 'Mitä muut ovat ymmärtäneet minusta',
  profile_values_tab_self_mobile: 'Minusta ymmärretty',
  profile_values_tab_other: 'Mitä muut ovat ymmärtäneet henkilöstä {name}',
  profile_values_tab_other_mobile: 'Tietoja hänestä',
  profile_people_tab_self: 'Minun ihmiseni',
  profile_people_tab_self_mobile: 'Ihmiset',
  compass_tab_mobile: 'Kompassi',
  profile_people_tab_other: 'Ihmiset henkilön {name} ympärillä',
  profile_people_tab_other_mobile: 'Ihmiset',
  my_light_profile_label: 'Minun valoni',
  my_light_profile_purpose_self:
    'Paikka arvoillesi, läheisillesi ja sille, mitä haluat välittää eteenpäin.',
  my_light_profile_purpose_other:
    'Paikka sille, mikä luonnehtii henkilöä {name}, läheisille ihmisille ja sille, mikä jatkuu.',
  intention_moment_section_title_self: 'Mitä muut ovat ymmärtäneet minusta',
  intention_moment_section_title_other: 'Mitä muut ovat ymmärtäneet henkilöstä {name}',
  intention_moment_section_intro:
    'Hetkiä, jotka muut huomasivat, ja keskusteluja siitä, miten ne koettiin.',
  intention_moment_add: 'Jaa hetki',
  intention_moment_empty_self_title: 'Kukaan ei ole vielä jakanut tällaista hetkeä',
  intention_moment_empty_self_message:
    'Muut voivat jakaa huomaamansa hetken, ja sinä voit vastata omasta näkökulmastasi.',
  intention_moment_empty_other_title: 'Huomasitko jotakin henkilössä {name}?',
  intention_moment_empty_other_message: 'Jaa konkreettinen hetki ja se, mitä se teki sinulle.',
  intention_moment_empty_readonly_title:
    'Kukaan ei ole vielä jakanut tällaista hetkeä henkilöstä {name}',
  intention_moment_empty_readonly_message:
    'Tässä näkyvät hetket, jotka henkilölle {name} läheiset ihmiset päättävät jakaa.',
  intention_moment_create_title: 'Jotakin, jonka huomasit henkilössä {name}',
  intention_moment_edit_title: 'Muokkaa hetkeä',
  intention_moment_observed_label: 'Mitä tapahtui?',
  intention_moment_observed_help:
    'Kerro konkreettisesta teosta, valinnasta tai hetkestä henkilön {name} kanssa.',
  intention_moment_observed_placeholder: 'Kuvaile tilanne sellaisena kuin koit sen.',
  intention_moment_impact_label: 'Mitä se herätti sinussa?',
  intention_moment_impact_help: 'Mitä ajattelit, tunsit tai teit toisin sen jälkeen?',
  intention_moment_impact_placeholder: 'Se sai minut ...',
  intention_moment_share: 'Jaa hetki',
  intention_moment_update: 'Tallenna',
  intention_moment_save_error: 'Hetkeä ei voitu tallentaa. Yritä uudelleen.',
  intention_moment_card_impact: 'Mitä se teki minulle',
  intention_moment_legacy_value: 'Valittu sana: {value}',
  intention_moment_delete_title: 'Poistetaanko hetki?',
  intention_moment_delete_message: 'Kirjoitus poistetaan pysyvästi.',
  intention_moment_hide_title: 'Poistetaanko tämä profiilistasi?',
  intention_moment_hide_message:
    'Kirjoitus poistetaan. Sanoja ei muuteta eikä niitä esitetä sinun ominasi.',
  intention_moment_hide_action: 'Poista',
  intention_moment_creator_consent: 'Julkinen näkyvyys sopii minulle, jos myös {name} haluaa sitä.',
  intention_moment_private_until_both:
    'Kortti pysyy yksityisenä, kunnes molemmat valitsevat julkisen näkyvyyden.',
  intention_moment_response_title: 'Näin sinä koit tilanteen',
  intention_moment_response_observer_label: 'Tämä huomattiin',
  intention_moment_response_prompt: 'Mikä oli sinulle tärkeää tässä tilanteessa?',
  intention_moment_response_help:
    'Kerro omin sanoin. Tilanne saattoi olla monimutkainen tai jotain, mitä et ollut aiemmin ajatellut.',
  intention_moment_response_placeholder: 'Näin koin sen, mitä sisälläni tapahtui ...',
  intention_moment_subject_consent:
    'Haluan, että koko kortti voidaan näyttää julkisesti Minun valossani.',
  intention_moment_public_only_together:
    'Kortti tulee julkiseksi vain, koska olette molemmat valinneet sen.',
  intention_moment_response_save: 'Jaa näkökulmani',
  intention_moment_card_subject_response: 'Näin {name} koki tilanteen',
  intention_moment_respond: 'Vastaa omasta näkökulmastasi',
  intention_moment_edit_response: 'Muokkaa näkökulmaani',
  intention_moment_continue_chat: 'Jatka keskustelussa',
  intention_moment_chat_error: 'Keskustelua ei voitu avata.',
  intention_moment_content_locked:
    'Kun vastaanottaja on vastannut, yllä olevia sanoja ei voi muuttaa. Voit silti muuttaa suostumustasi.',
  user_values_add_cta: 'Sano mitä näet',
  user_values_empty_title: 'Lisää ominaisuudet, jotka kertovat kuka {firstName} on.',
  user_values_empty_message: 'Jaa, mikä on tärkeää {name}lle, jotta muut tietävät, miten tukea.',
  user_values_empty_self_title: 'Mitä muut näkevät sinussa',
  user_values_empty_self_message: 'Kun joku jakaa sen, mitä näkee sinussa, se näkyy täällä.',
  user_values_modal_title: 'Mitä näet {name}ssa?',
  user_values_modal_edit_title: 'Muokkaa ominaisuutta',
  user_values_modal_heading: 'Valitse ominaisuus, jonka tunnistat, ja kerro miksi.',
  user_values_selected_label: 'Näen tämän {name}ssa',
  user_values_selected_message: 'Mikä saa sinut valitsemaan “{personality}”?',
  user_values_placeholder: 'Kirjoita muutama sana siitä, mitä olet nähnyt tai kokenut.',
  user_values_create_cta: 'Jaa',
  user_values_update_cta: 'Jaa',
  user_values_privacy_public_description: 'Näkyy kaikille, jotka vierailevat {name}n sivulla.',
  user_values_privacy_private_description: 'Vain sinä ja {name} näette tämän ominaisuuden.',
  user_values_privacy_relatives_description:
    'Ihmiset, jotka kutsut tukemaan {name}a, näkevät tämän ominaisuuden.',
  gift_from: 'Sytytti kynttilän',
  grave_values: 'Sanat {graveName}sta',
  grave_values_fallback: 'Sanat',
  grave_values_load_failed: 'Sanoja ei voitu ladata juuri nyt',
  grave_values_load_failed_description: 'Yritä uudelleen. Aiemmin jaettu sisältö on yhä tallessa.',
  grave_values_options_load_failed: 'Ominaisuuksia ei voitu ladata',
  grave_values_options_load_failed_description: 'Yritä uudelleen ennen sanojesi jakamista.',
  grave_values_privacy_label: 'Kuka voi nähdä tämän?',
  grave_values_created: 'Ominaisuus lisättiin.',
  grave_values_updated: 'Ominaisuus päivitettiin.',
  grave_values_deleted: 'Ominaisuus poistettiin.',
  grave_values_save_failed: 'Ominaisuutta ei voitu tallentaa. Yritä uudelleen.',
  the_value_archive: 'Ominaisuudet',
  edit_value_archive: 'Muokkaa ominaisuutta',
  create_value_archive: 'Luo ominaisuus',
  update_value_archive: 'Päivitä ominaisuus',
  value_archive_title: 'Valitse ominaisuus ja lisää tarina',
  value_archive_selected: '{graveName}a kuvaava ominaisuus',
  value_archive_selected_message:
    'Muistat {graveName}n {personality}. Jaa muutama sana, jotka kuvaavat tätä.',
  no_suggestions: 'Ei ehdotuksia',
  value_archive_placeholder: 'Kirjoita muutama sana, jotka kuvaavat ominaisuutta',
  select_personality_warning: 'Valitse ominaisuus.',
  enter_description_warning: 'Muista lisätä muutama sana, jotka kuvaavat ominaisuutta.',
  grave_values_empty_primary: 'Sanoja ja pieniä tarinoita siitä, kuka {firstName} oli muille.',
  grave_values_empty_secondary: 'Liity hautaan jakaaksesi omat sanasi {firstName}sta.',
  grave_values_empty_cta: 'Yhdistä {firstName}',
  no_values_added: '{firstName}n tarina kantaa enemmän.',
  add_values_message:
    'Ominaisuudet ovat sanoja, jotka kuvaavat millaista oli kohdata hänet – mitä hän jätti muille.',
  confirm_delete_value_message:
    'Tämä poistaa ominaisuuden tästä paikasta. Voit lisätä sen myöhemmin uudelleen.',
  confirm_delete_product_message:
    'Tämä poistaa tuotteen. Voit lisätä tuotteen myöhemmin uudelleen.',
  added_personality_value: 'lisäsi',
  create_grave: 'Luo hauta',
  create_grave_mode_label: 'Mitä haluat luoda?',
  create_grave_mode_grave: 'Uusi hauta',
  create_grave_mode_with_ceremony: 'Uusi hauta kuolinilmoituksella',
  create_grave_mode_with_ceremony_mobile: 'Kuolinilmoituksella',
  create_grave_mode_with_ceremony_help:
    'Voit lisätä tärkeimmät tiedot nyt. Aika ja paikka voidaan lisätä myöhemmin.',
  create_grave_ceremony_accuracy_confirm_label:
    'Vahvistan, että tiedot ovat oikein niin hyvin kuin tiedän.',
  create_grave_ceremony_confirm_required:
    'Vahvista, että tiedot ovat oikein niin hyvin kuin tiedät.',
  create_grave_death_notice_section: 'Kuolinilmoitus',
  create_grave_ceremony_section: 'Seremonia',
  create_grave_ceremony_message_label: 'Viesti perheelle ja ystäville',
  create_grave_ceremony_message_placeholder: 'Kirjoita lyhyt viesti.',
  create_grave_ceremony_place_of_death_label: 'Missä henkilö menehtyi',
  create_grave_ceremony_place_of_death_placeholder: 'esim. kotona, hoivakodissa tai sairaalassa',
  create_grave_ceremony_timing_pending: 'Aikaa ja paikkaa ei ole vielä asetettu',
  create_grave_ceremony_timing_pending_help: 'Voit päivittää tämän myöhemmin haudalla.',
  create_grave_ceremony_funeral_date_label: 'Seremonia (päivä)',
  create_grave_ceremony_funeral_time_label: 'Seremonia (aika)',
  create_grave_ceremony_funeral_time_placeholder: 'esim. 12:00',
  create_grave_ceremony_funeral_at_label: 'Seremonia (päivä ja aika)',
  create_grave_ceremony_funeral_venue_label: 'Paikka',
  create_grave_optional_field_help: 'Valinnainen',
  create_grave_ceremony_funeral_venue_placeholder: 'esim. Lade kirkko',
  create_grave_any_proof: 'Onko sinulla dokumentteja vahvistamaan kuolema?',
  create_grave_validation_name_required: 'Nimi vaaditaan',
  create_grave_validation_gender_required: 'Sukupuoli vaaditaan',
  create_grave_validation_birthday_required: 'Syntymäaika vaaditaan',
  create_grave_validation_death_date_required: 'Kuolinaika vaaditaan',
  create_grave_validation_country_required: 'Maa vaaditaan',
  create_grave_validation_municipality_required: 'Kunta vaaditaan',
  create_grave_validation_cemetery_required: 'Hautausmaa vaaditaan',
  create_grave_validation_relation_required: 'Suhde vaaditaan',
  create_grave_validation_reciprocal_relation_required: 'Vastavuoroinen suhde vaaditaan',
  create_grave_validation_reason_required: 'Kuolinsyy vaaditaan',
  create_grave_validation_other_reason_required: 'Muu syy vaaditaan',
  create_grave_select_document_heading: 'Valitse asiakirja',
  create_grave_select_document_message: 'Valitse ladattava asiakirja ja hyväksy ehdot',
  spark_feeling: 'Valitse näkökulma',
  added_spark_feeling_Reflecting: 'luo kipinän pohdinnalla',
  added_spark_feeling_Wonder: 'luo kipinän ihmetyksellä',
  added_spark_feeling_Connection: 'luo kipinän yhteydellä',
  added_spark_feeling_Freedom: 'luo kipinän vapaudella',
  added_spark_feeling_Hopeful: 'luo kipinän toivolla',
  added_spark_feeling_Gratitude: 'luo kipinän kiitollisuudella',
  added_spark_feeling_Peace: 'luo kipinän rauhalla',
  added_reflection_feeling_Reflecting: 'pohtii reflektiolla',
  added_reflection_feeling_Wonder: 'pohtii ihmetyksellä',
  added_reflection_feeling_Connection: 'pohtii yhteydellä',
  added_reflection_feeling_Freedom: 'pohtii vapaudella',
  added_reflection_feeling_Hopeful: 'pohtii toivolla',
  added_reflection_feeling_Gratitude: 'pohtii kiitollisuudella',
  added_reflection_feeling_Peace: 'pohtii rauhalla',
  spark_reflections_header: 'Pohdinnat',
  spark_add_reflection: 'Lisää pohdinta',
  spark_reflections_empty: 'Ole ensimmäinen, joka lisää pohdinnan.',
  spark_reflections_count: '{count, plural, one {# pohdinta} other {# pohdintaa}}',
  spark_reflectors_count: '{count, plural, one {# henkilö} other {# henkilöä}}',
  spark_reflecting_on: 'Pohdit aihetta',
  spark_reflection_feeling: 'Tila: {state}',
  spark_original_label: 'Alkuperäinen kipinä',
  spark_reflection_context_label: 'Pohdinta',
  spark_unknown_user: 'Joku',
  spark_reactions_empty: 'Tälle valinnalle ei ole vielä reaktioita.',
  memory_feeling_Remembering: 'Muistaa',
  memory_feeling_Remembering_description:
    'Elä uudelleen hetket ja tarinat, jotka pitävät muiston elossa.',
  memory_feeling_Honoring: 'Arvostaa',
  memory_feeling_Honoring_description:
    'Ilmaise kiitollisuutta ja tunnusta arvot ja jäljet, jotka he jättivät.',
  memory_feeling_Reflecting: 'Pohtii',
  memory_feeling_Reflecting_description:
    'Pysähdy tuntemaan, mitä heidän elämänsä ja läsnäolonsa merkitsevät sinulle.',
  memory_feeling_Thankful: 'Kiitollinen',
  memory_feeling_Thankful_description:
    'Kerro, mistä olet kiitollinen – heidän rakkaudestaan, viisaudestaan tai muistoista, joita kannat mukanasi.',
  memory_feeling_Missing: 'Kaipaa',
  memory_feeling_Missing_description: 'Sanoita ikävä ja tyhjyys, jonka heidän poissaolonsa jättää.',
  memory_feeling_Forgiving: 'Antaa anteeksi',
  memory_feeling_Forgiving_description: 'Valitsee anteeksiannon ja irti päästämisen.',
  added_memory_feeling_Remembering: 'muistaa {graveName}',
  added_memory_feeling_Honoring: 'arvostaa {graveName}',
  added_memory_feeling_Reflecting: 'pohtii {graveName}a',
  added_memory_feeling_Thankful: 'on kiitollinen {graveName}sta',
  added_memory_feeling_Missing: 'kaipaa {graveName}a',
  added_memory_feeling_Forgiving: 'antaa anteeksi {graveName}n',
  view_header_desktop: 'Työpöydän esikatselu',
  view_header_mobile: 'Mobiiliesikatselu',
  memory_posts: 'Muistopostaukset',
  view_deceased_name: 'Haudan nimi',
  grave_duplicate_title: 'Tämä hauta on jo olemassa',
  grave_duplicate_message:
    'Samalla nimellä ja tiedoilla oleva hauta on jo Verkkohaudassa. Emme luo uutta hautaa, kun löydämme varman osuman. Vieraile olemassa olevassa ja liity siihen.',
  grave_duplicate_button: 'Siirry olemassa olevaan hautaan',
  create_grave_pending_review_notice:
    'Hauta on lähetetty Verkkohaudalle tarkistettavaksi eikä ole vielä julkisesti näkyvissä.',
  create_grave_create_error: 'Hautaa ei voitu luoda. Tarkista tiedot ja yritä uudelleen.',
  create_grave_potential_duplicates_title: 'Löysimme samankaltaisen haudan',
  create_grave_potential_duplicates_message:
    'Tarkista, onko joku näistä sama henkilö ennen kuin luot uuden haudan.',
  create_grave_potential_duplicates_button: 'Siirry haudalle',
  grave_create_invalid_date_title: 'Virheellinen päivämääräjärjestys',
  grave_create_invalid_date_message:
    'Kuolinpäivä ei voi olla ennen syntymäpäivää. Tarkista päivämäärät ja yritä uudelleen.',
  memory_feeling_tooltip: 'Tunne',
  memory_feeling: 'Tunne',
  conscious_verified_badge:
    'Saat vahvistetun merkin – luottamuksen, läsnäolon ja huolen merkki yhteisössä',
  conscious_supports_free_graves:
    'Autat pitämään kaikki haudat avoimina ja huolenpidettyinä, jotta kaikki voivat muistaa rakkaansa maksukyvystä riippumatta.',
  conscious_ad_free_safe_space:
    'Tuet turvallista, mainoksetonta tilaa, joka perustuu kuulumiseen, lämpöön ja rehellisyyteen.',
  conscious_supports_community_and_mission:
    'Lahjoituksesi ylläpitää Verkkohauta-yhteisöä ja laajempaa End Of Time -tehtävää nyt ja tulevaisuudessa.',
  partner_page_title: 'Kumppanit – The End of Time',
  partner_page_mission: 'Tue muistoa, kiitollisuutta ja totuutta.',
  partner_welcome_title: 'Tervetuloa!',
  partner_welcome_message:
    'Liity kumppaniksi. Tue muistoa, kiitollisuutta ja totuutta perheille ja yhteisöille.',
  partner_company_name: 'Yrityksen nimi',
  partner_company_website: 'Yrityksen verkkosivusto',
  partner_company_mission: 'Lyhyt missiolauseke',
  partner_company_logo: 'Logo',
  partner_continue: 'Jatka',
  partner_choose_context_title: 'Valitse tukiympäristö',
  partner_appears_memory_album: 'Näkyy lempeästi perheiden muistialbumeissa.',
  partner_appears_value_archive: 'Kiitollisuus on mahdollista kumppaneidemme ansiosta.',
  partner_appears_funeral_room: 'Yhdessä kanssasi muiston tueksi.',
  partner_appears_anniversary_calendar: 'Juhlimme muistoja kumppaneiden avulla.',
  partner_appears_groups: 'Yhteisötuki kumppaniemme ansiosta.',
  partner_appears_store: 'Tuotu sinulle huolella kumppaneiden voimin.',
  partner_upload_or_generate_title: 'Lataa tai luo mainoksesi',
  partner_upload_image_video: 'Lataa kuva/video',
  partner_select_theme: 'Valitse teema',
  partner_select_theme_remembrance: 'Muistaminen',
  partner_select_theme_gratitude: 'Kiitollisuus',
  partner_select_theme_support: 'Tuki',
  partner_or: 'Tai',
  partner_describe_generate:
    "Kuvaile, mitä haluat luoda (esim. 'pehmeä kynttilä lempeällä taustalla')",
  partner_generate_ai: 'Luo tekoälyllä',
  partner_upload_success: 'Luova sisältö ladattu!',
  partner_generate_success: 'Luotu tekoälyllä!',
  partner_write_message_title: 'Kirjoita viestisi',
  partner_write_message_placeholder: 'Kirjoita lämmin, kannustava viesti…',
  partner_make_warmer: 'Tee viestistä lämpimämpi / runollisempi',
  partner_live_preview: 'Esikatselu reaaliajassa',
  partner_message_preview_placeholder: 'Viestisi näkyy täällä.',
  partner_set_commitment_title: 'Aseta sitoutumisesi',
  partner_commitment_cpm: 'CPM (per 1 000 näyttökertaa)',
  partner_commitment_cpm_desc: '~6 200 näyttökertaa/kk, 140 NOK CPM',
  partner_commitment_cpc: 'CPC (per klikkaus)',
  partner_commitment_cpc_desc: 'Maksa vain klikkauksista',
  partner_commitment_flat: 'Kiinteä kuukausisponsorointi',
  partner_commitment_flat_desc: 'Kiinteä maksu, kaikki sisältyy',
  partner_campaign_summary: 'Kampanjan yhteenveto',
  partner_estimated_monthly_reach: 'Arvioitu kuukausikattavuus',
  partner_commitment: 'Sitoutuminen',
  partner_submit_review: 'Lähetä tarkistukseen',
  partner_status_thank_you: 'Kiitos! Kumppanuutesi tarkistetaan 24 tunnin kuluessa.',
  partner_status_subtitle:
    'Saat päivityksen sähköpostitse, kun se on hyväksytty. Voit seurata tilaa koontinäytöltä.',
  partner_go_to_dashboard: 'Siirry koontinäytölle',
  partner_your_campaigns: 'Kampanjasi',
  partner_placement: 'Sijoittelu',
  partner_status: 'Tila',
  partner_impressions: 'Näyttökerrat',
  partner_clicks: 'Klikkaukset',
  partner_actions: 'Toiminnot',
  partner_view_company: 'Näytä yritys',
  partner_sponsored: 'End Of Time Call',
  partner_call_cta: 'End Of Time Call',
  partner_supported_by: 'Tuettu ❤️ {count} tietoisella jäsenellä',
  partner_highlight_this_partner: 'Korosta tätä kumppania',
  partner_about: 'Tietoa',
  partner_partner_since: 'Kumppani vuodesta: {date}',
  partner_causes_supported: 'Tukemasi syyt:',
  partner_active_campaigns: 'Aktiiviset kampanjat:',
  partner_families_supported: 'Tuetut perheet',
  partner_testimonials: 'Suositukset:',
  partner_total_highlights: 'Kokonaiskorostukset',
  partner_see_support_helps: 'Katso, miten tukesi auttaa',
  partner_share_impact: 'Jaa tämän kumppanin vaikutus',
  partner_invite_more_causes: 'Kutsu tätä kumppania tukemaan lisää syitä',
  partner_review_preview_title: 'Tarkista & Esikatsele',
  partner_review_ad_preview: 'Mainosesikatselu',
  partner_review_placement: 'Sijoittelu',
  partner_review_company: 'Yritys',
  partner_review_website: 'Verkkosivusto',
  partner_review_mission: 'Missio',
  partner_review_billing: 'Laskutus',
  partner_confirm_submit: 'Vahvista & Lähetä',
  partner_appears_key_memory_album: 'Muistoalbumi',
  partner_appears_key_value_archive: 'Ominaisuudet',
  partner_appears_key_funeral_room: 'Surutila',
  partner_appears_key_anniversary_calendar: 'Juhlapäiväkalenteri',
  'settings.security.title': 'Tietoturva',
  'settings.security.sessions.title': 'Missä olet kirjautuneena',
  'settings.security.sessions.device': 'Laite',
  'settings.security.sessions.this_device': 'Tämä laite',
  'settings.security.sessions.last_active': 'Viimeksi aktiivinen',
  'settings.security.sessions.created': 'Luotu',
  'settings.security.sessions.expires': 'Vanhentuu',
  'settings.security.sessions.ip': 'IP',
  'settings.security.sessions.logout': 'Kirjaudu ulos',
  'settings.security.sessions.logout_all': 'Kirjaudu ulos kaikilta laitteilta',
  'settings.security.sessions.logout_others': 'Kirjaudu ulos muilta laitteilta',
  'security.alerts.reuse_detected.title': 'Lopetimme istuntosi turvallisuutesi vuoksi',
  'security.alerts.reuse_detected.body':
    'Huomasimme poikkeavan kirjautumisen. Kirjasimme sinut ulos kaikilta laitteilta. Jos tämä ei ollut sinä, vaihda salasanasi.',
  'gettingStarted.title': 'Tervetuloa',
  'gettingStarted.subtitle': 'Aloita etsimällä nimeä löytääksesi haudan.',
  'gettingStarted.search': 'Haku',
  'gettingStarted.search.placeholder': 'Hae nimellä',
  'gettingStarted.addRelation': 'Lisää henkilö',
  'gettingStarted.explainer':
    'Aseta suhteesi, niin saat päivityksiä, merkkipäiviä ja lempeitä muistutuksia.',
  partner_appears_key_groups: 'Ryhmät/Yhteisö',
  partner_appears_key_store: 'Kauppa/Verkkokauppa',
  account_form_email_label: 'Sähköposti',
  account_form_email_placeholder: 'Syötä sähköpostisi',
  account_form_email_required: 'Syötä sähköpostiosoitteesi',
  account_form_email_invalid: 'Syötä kelvollinen sähköpostiosoite',
  account_form_userName_label: 'Nimi',
  account_form_userName_placeholder: 'Syötä nimesi',
  account_form_userName_required: 'Syötä nimesi',
  account_form_userName_invalid: 'Nimessä on oltava vähintään yksi kirjain',
  account_form_gender_label: 'Sukupuoli',
  account_form_gender_placeholder: 'Valitse sukupuoli',
  account_form_gender_required: 'Valitse sukupuoli',
  account_form_gender_option_male: 'Mies',
  account_form_gender_option_female: 'Nainen',
  account_form_gender_option_other: 'Muu',
  account_form_password_label: 'Salasana',
  account_form_password_placeholder: 'Syötä salasanasi',
  account_form_password_required: 'Syötä salasana',
  account_form_password_min: 'Käytä vähintään 8 merkkiä.',
  account_form_password_max: 'Käytä enintään 128 merkkiä.',
  account_form_confirmPassword_label: 'Vahvista salasana',
  account_form_confirmPassword_placeholder: 'Vahvista salasanasi',
  account_form_confirmPassword_required: 'Vahvista salasanasi',
  account_form_confirmPassword_match: 'Salasanat eivät täsmää',
  not_authorized: 'Et ole valtuutettu',
  account_form_country_label: 'Maa',
  account_form_country_placeholder: 'Valitse maa',
  account_form_country_required: 'Valitse maasi',
  account_form_dateOfBirth_label: 'Syntymäaika',
  account_form_dateOfBirth_placeholder: 'Valitse päivämäärä',
  account_form_dateOfBirth_required: 'Valitse syntymäaikasi',
  account_form_dateOfBirth_underage: 'Saatavilla 13-vuotiaille ja sitä vanhemmille.',
  account_form_language_label: 'Kieli',
  account_form_language_placeholder: 'Valitse kieli',
  account_form_language_required: 'Valitse haluamasi kieli',
  language_english: 'Englanti',
  language_norwegian: 'Norja',
  language_danish: 'Tanska',
  language_swedish: 'Ruotsi',
  language_finnish: 'Suomi',
  account_form_checked_label: 'Hyväksyn {termsLink}',
  account_form_checked_required: 'Hyväksy jatkaaksesi.',
  account_form_creating_account: 'Luodaan tili...',
  account_form_submit: 'Luo tili',
  registration_too_many_attempts:
    'Liian monta rekisteröitymisyritystä. Odota hetki ennen kuin yrität uudelleen.',
  registration_failed: 'Tiliä ei voitu luoda. Yritä uudelleen.',
  grave_tab: 'Hae',
  home_welcome: 'Vie hauta pilveen verkkohauta.fi-palvelulla.',
  home_subheading: 'Saatavilla ja lähellä arkeasi. Hae nimellä aloittaaksesi.',
  home_create_account: 'Luo tili',
  home_login: 'Kirjaudu sisään',
  home_terms: 'Jatkamalla hyväksyt',
  footer_copyright: '© 2013–2026 Verkkohauta.fi.',
  footer_built_by: 'The End Of Time Corporation',
  footer_teotc_name: 'Verkkohauta kehitetään ja sitä operoi The End of Time Corporation (TEOTC).',
  footer_intro_eyebrow: 'Verkkohauta — missä rakkaus ei koskaan lopu.',
  footer_intro_body:
    'Tuotteita ja palveluita yhdestä näkökulmasta — siitä, mikä kestää kaiken ajan.',
  footer_col_nettgrav: 'Verkkohauta',
  footer_col_explore: 'Tutki',
  footer_col_teotc: 'End of Time',
  footer_col_contact: 'Yhteystiedot',
  footer_find_grave: 'Löydä hauta',
  footer_graves: 'Hae kaikista haudoista',
  footer_about: 'Tietoa Verkkohaudasta',
  footer_create_spark: 'Luo Kipinä',
  footer_my_light: 'Minun valoni',
  footer_rooms: 'Huoneet',
  footer_partner: 'Kumppani',
  footer_how_it_works: 'Näin Verkkohauta toimii',
  footer_create_nettgrav: 'Luo Verkkohauta',
  footer_about_teotc: 'Tietoa TEOTC:sta',
  footer_nettarv: 'Nettarv',
  footer_matvarebutikken: 'Matvarebutikken',
  footer_become_partner: 'Ryhdy kumppaniksi',
  footer_privacy: 'Tietosuoja',
  footer_terms: 'Ehdot',
  footer_cookies: 'Evästeet',
  footer_end_of_time_center: 'The End of Time Center',
  footer_end_of_time_chat: 'End Of Time Chat',
  my_light_info_title: 'Minun valoni',
  my_light_info_intro: 'Paikka sille, mikä merkitsee sinulle eniten, omassa tahdissasi.',
  my_light_info_body_1: 'Minun valoni on elämäsi sivu Verkkohaudassa.',
  my_light_info_body_2:
    'Täällä yhdistyt ihmisiin, joista välität, rakennat suhteita ajan myötä — ja voit tehdä tärkeimmän selkeäksi.',
  my_light_info_body_3: 'Kyse ei ole siitä, että jakaisi eniten.',
  my_light_info_body_4: 'Kyse on läsnäolosta.',
  my_light_info_section_what_you_can_do_title: 'Mitä voit tehdä Minun valoni -sivulla',
  my_light_info_body_5: 'Voit:',
  my_light_info_body_6: 'vahvistaa suhteita ihmisiin, joista välität',
  my_light_info_body_7: 'jakaa sanoja ja läsnäoloa, jotka tekevät hyvää',
  my_light_info_body_8: '• sanoa toisillenne hyviä sanoja — kun vielä elämme',
  my_light_info_body_9: 'valita Kuut — ne lähimmät, joihin luotat',
  my_light_info_body_10:
    'asettaa suunta Kompassini-osiossa ja tehdä tärkein selkeäksi Jälkeeni-osiossa',
  my_light_info_body_11: 'Minun valoni sisältää sekä tämän päivän elämän — että suunnan eteenpäin.',
  my_light_info_section_not_title: 'Mitä tämä ei ole',
  my_light_info_body_12:
    'Minun valoni ei ole sosiaalinen verkosto. Kyse ei ole vauhdista, huomiosta tai kasvusta.',
  my_light_info_body_13: 'Täällä tärkein voidaan jakaa rauhassa, läheisyydellä ja huolenpidolla.',
  my_light_info_section_why_title: 'Miksi se on olemassa?',
  my_light_info_body_14: 'Koska ihmiset tarvitsevat toisiaan.',
  my_light_info_body_15: 'Ja koska on hyvä sanoa se, mikä merkitsee — samalla kun elämme.',
  my_light_info_cta: 'Siirry Minun valoni -sivulle',
  'my_light_guest_preview.eyebrow': 'Sinulle, joka olet vieras',
  'my_light_guest_preview.supporting': 'Tässä näet, mitä Minun valoni sisältää.',
  'my_light_guest_preview.primary_cta': 'Kirjaudu Minun valooni',
  'my_light_guest_preview.secondary_cta': 'Luo tili',
  'my_light_guest_preview.panel_label': 'Mitä Minun valoni sisältää',
  'my_light_guest_preview.modules_title': 'Tältä Minun valoni näyttää',
  'my_light_guest_preview.modules_intro': 'Nämä ovat alueet, jotka kohtaat Minun valoni -sivulla.',
  'my_light_guest_preview.card_about_title': 'Minusta',
  'my_light_guest_preview.card_about_body':
    'Lyhyt esittely, muutama rivi siitä kuka olet, ja kolme kysymystä jotka kuvaavat elämää sellaisena kuin se tuntuu nyt.',
  'my_light_guest_preview.card_relations_title': 'Läheiset ihmiset',
  'my_light_guest_preview.card_relations_body':
    'Täällä näet lähimmät ihmiset ympärilläsi ja sen, kenellä on erityinen rooli silloin kun asiat merkitsevät eniten.',
  'my_light_guest_preview.card_compass_title': 'Kompassini',
  'my_light_guest_preview.card_compass_body':
    'Täällä voit sanoittaa, mikä pitää sinut suunnassa, mikä merkitsee eniten ja mitä muiden olisi hyvä ymmärtää sinusta.',
  'my_light_guest_preview.card_moons_title': 'Kuut',
  'my_light_guest_preview.card_moons_body':
    'Kuut ovat läheisiä ihmisiä ympärilläsi, jotka vaikuttavat elämääsi läheisyydellä, suunnalla ja turvalla.',
  'my_light_guest_preview.card_after_me_title': 'Jälkeeni',
  'my_light_guest_preview.card_after_me_body':
    'Jälkeeni on paikka, jossa teet tärkeimmän selkeäksi niille, joita rakastat.',
  'my_light_guest_preview.footer_title': 'Henkilökohtainen paikka suhteelle ja vastuulle',
  'my_light_guest_preview.sample_name': 'Esimerkkiprofiili',
  'my_light_guest_preview.sample_role': 'Opettaja ja vanhempi',
  'my_light_guest_preview.sample_bio':
    'Yritän tehdä tilaa rehellisille keskusteluille, rauhallisille aamuille ja ihmisille, joiden lähellä minun on hyvä olla.',
  'my_light_guest_preview.answer_1': 'Suojella aikaa niiden kanssa, joita rakastan.',
  'my_light_guest_preview.answer_2': 'Kävelyt, hiljaisuus ja yksi rehellinen keskustelu.',
  'my_light_guest_preview.connection_name_1': 'Anna Berg',
  'my_light_guest_preview.connection_role_1': 'Sisar',
  'my_light_guest_preview.connection_name_2': 'Isak Berg',
  'my_light_guest_preview.connection_role_2': 'Perheystävä',
  'my_light_guest_preview.compass_value_1':
    'En halua kadottaa yhteyttä siihen, mikä merkitsee eniten.',
  'my_light_guest_preview.compass_value_2':
    'Luoako tämä enemmän totuutta vai vain vähemmän epämukavuutta?',
  'my_light_guest_preview.moon_name_1': 'Liv',
  'my_light_guest_preview.moon_role_1': 'Läheinen ystävä',
  'my_light_guest_preview.moon_name_2': 'Maren',
  'my_light_guest_preview.moon_role_2': 'Tytär',
  'my_light_guest_preview.moon_status': 'Kuu',
  'my_light_guest_preview.after_me_status': 'Selkeä',
  'my_light_guest_preview.after_me_updated': 'Päivitetty hiljattain',
  'my_light_guest_preview.after_me_message':
    'Jos jotain tapahtuu, olkoon se yksinkertaista, lämmintä ja ilman arvailua.',
  end_of_time_center_title: 'The End of Time Center',
  end_of_time_center_intro: 'Työ, joka alkaa siellä missä elämä päättyy.',
  end_of_time_center_body_1: 'Hauta on olemassa, koska ihminen on kuollut.',
  end_of_time_center_body_2:
    'Etsimme ymmärrystä siitä, miksi elämä päättyy, ja siitä miten tieto, oivallus ja tutkimus voivat auttaa siihen, että harvempi elämä päättyy tulevaisuudessa.\nEi lupauksilla, vaan pitkäjänteisellä työllä.',
  end_of_time_center_section_1_title: 'Menetyksestä toimintaan',
  end_of_time_center_section_1_body_1:
    'Useimmat pysähtyvät kuolemaan.\nThe End of Time Center alkaa siitä.',
  end_of_time_center_section_1_body_2:
    'Kun ihminen kuolee, jää kysymyksiä, joihin muistot eivät yksin vastaa. Täällä tutkimus, pohdinta ja kehitys kokoontuvat ymmärtämään elämän haavoittuvuutta ja ajan roolia sairaudessa, ikääntymisessä ja kuolemassa.',
  end_of_time_center_section_1_body_3: 'Tämä ei ole muistotyötä.\nSe on vastuu.',
  end_of_time_center_section_2_title: 'Hauta siltana',
  end_of_time_center_section_2_body_1:
    'Verkkohaudassa hauta on enemmän kuin hiljaisuuden paikka.\nSe on silta sen välillä, mikä on ollut – ja mikä voi tulla.',
  end_of_time_center_section_2_body_2:
    'Haudalle sidotut teot – kynttilät, ympyrät ja läsnäolo – ankkuroituvat The End of Time Centeriin. Näin haudalle annetaan suunta eteenpäin, kohti ymmärrystä, yhteyttä ja tutkimusta elämän rajoista.\nTätä työtä kutsutaan nimellä End of Time Care.',
  end_of_time_center_section_3_title: 'Pitkäjänteinen työ',
  end_of_time_center_section_3_body_1:
    'The End of Time Center on The End Of Time Corporationin pitkäjänteinen hanke. Työ on juurtunut Norjaan ja kehittyy kunnioittaen elämän monimutkaisuutta ja ihmisen tarvetta merkitykseen.',
  end_of_time_center_section_3_body_2:
    'Tämä ei ole projekti, jota skaalataan nopeasti.\nSe on työ, jonka tulee kestää.',
  end_of_time_center_section_4_title: 'Siksi The End of Time Center on olemassa',
  end_of_time_center_section_4_body_1:
    'Koska yksi elämä päättyi.\nSiitä tuli hauta.\nJa koska se velvoittaa.',
  end_of_time_chat_title: 'End Of Time Chat',
  end_of_time_chat_intro: 'Keskusteluja, jotka kestävät hiljaisuuden',
  end_of_time_chat_beta_label: 'Beta-versio',
  end_of_time_chat_beta_short:
    'Keskeiset salaussuojaukset ovat käytössä. Koska kyseessä on beta, ominaisuudet ja käyttöliittymän yksityiskohdat voivat muuttua.',
  end_of_time_chat_open_beta: 'Avaa beta-keskustelu',
  end_of_time_chat_explore_security: 'Näin keskustelusi suojataan',
  end_of_time_chat_security_eyebrow: 'Yksityinen alusta alkaen',
  end_of_time_chat_security_summary_title: 'Suojauksen tila',
  end_of_time_chat_security_active: 'Käytössä',
  end_of_time_chat_security_note:
    'Keskustelusi suojataan salauksella ja muilla turvatoimilla, mutta mikään digitaalinen palvelu ei voi taata täydellistä turvallisuutta.',
  end_of_time_chat_beta_title: 'Valmis käyttöön, edelleen kehittyvä',
  end_of_time_chat_beta_body:
    'End of Time Chat on nyt saatavilla beta-versiona. Saatat kohdata keskeneräisiä yksityiskohtia, kun parannamme vakautta, puheluita, synkronointia ja kokonaiskokemusta.',
  end_of_time_chat_beta_point_1:
    'Ominaisuudet ja käyttöliittymän yksityiskohdat voivat muuttua beta-jakson aikana.',
  end_of_time_chat_beta_point_2: 'Tilapäisiä synkronointi- tai puheluyhteysongelmia voi esiintyä.',
  end_of_time_chat_beta_point_3:
    'Älä käytä beta-palvelua hätätilanteisiin tai aikakriittiseen viestintään.',
  end_of_time_chat_security_title: 'Rakennettu suojaamaan keskustelua',
  end_of_time_chat_security_intro:
    'Salaus ei ole valinnainen lisä. Se on osa viestien, ryhmien ja puheluiden rakennetta alusta alkaen.',
  end_of_time_chat_e2ee_title: 'Päästä päähän -salaus',
  end_of_time_chat_e2ee_body:
    'Keskustelun sisältö salataan osallistujien laitteilla. Verkkohauta välittää salattua tietoa luettavan keskustelukopion sijaan.',
  end_of_time_chat_pq_title: 'Hybridi kvanttien jälkeinen suojaus',
  end_of_time_chat_pq_body:
    'Hybridi X-Wing-avainten muodostus yhdistää vakiintuneen salauksen kvanttien jälkeiseen suojaukseen. Se auttaa pienentämään riskiä, että tänään tallennettu salattu liikenne puretaan tulevaisuuden kvanttitietokoneilla.',
  end_of_time_chat_mls_title: 'Turvallinen ryhmäavainten kierto',
  end_of_time_chat_mls_body:
    'Messaging Layer Security päivittää ryhmän salaisuuksia jäsenyyden ja keskustelun tilan muuttuessa ja auttaa rajoittamaan vaarantuneen avaimen vaikutusta ajan myötä.',
  end_of_time_chat_cta_title: 'Turvallisempi tila merkityksellisille keskusteluille',
  end_of_time_chat_cta_body:
    'Käytä betaa, kerro meille mikä ei toimi odotetusti ja auta meitä tekemään yksityisestä viestinnästä luotettavampaa.',
  end_of_time_chat_feedback: 'Ilmoita beta-ongelmasta',
  end_of_time_chat_body_1: 'Tulossa pian',
  end_of_time_chat_body_2:
    'Jotkut keskustelut ovat liian haavoittuvia avoimeen. Toiset ovat liian totta kadotakseen.',
  end_of_time_chat_body_3:
    'End of Time Chat on luotu ihmisille, jotka haluavat turvallisen tilan läheisille keskusteluille – jossa suhteet voivat jatkua rehellisyyden, lempeyden ja ajan kanssa.',
  end_of_time_chat_section_1_title: 'Huone, ei virta',
  end_of_time_chat_section_1_body_1:
    'Tämä ei ole sosiaalinen alusta.\nSe ei ole paikka näkyvyydelle, vauhdille tai suoritukselle.',
  end_of_time_chat_section_1_body_2:
    'End of Time Chat on suljettu tila niiden välillä, jotka ovat valinneet toisensa.\nKeskustelut saavat olla sitä mitä ne ovat – ilman yleisöä.',
  end_of_time_chat_section_2_title: 'Rakennettu luottamukselle',
  end_of_time_chat_section_2_body_1:
    'Keskustelut ovat päästä päähän -salattuja ja rakennettu turvallisuus periaatteeksi. Se mikä jaetaan, pysyy niiden välillä joille se kuuluu.',
  end_of_time_chat_section_2_body_2:
    'Teknologia on olemassa yhdestä syystä:\nSuojelemaan inhimillistä.',
  end_of_time_chat_section_3_title: 'Miksi End Of Time Chat on olemassa',
  end_of_time_chat_section_3_body_1:
    'Koska suhteet eivät pääty, kun elämä vaikeutuu.\nKoska läheisyys tarvitsee tiloja, jotka eivät hyödynnä haavoittuvuutta.\nKoska jotkut sanat voidaan jakaa vain, kun se on turvallista.',
  end_of_time_chat_section_3_body_2:
    'End of Time Chat on myös luotu niille keskusteluille, jotka haluamme käydä eläessämme.\nJotta voimme sanoa, mihin uskomme.\nJotta voimme näyttää, mikä on tärkeää.\nJotta voimme olla se, joka sanoo rakastan sinua ensin.',
  end_of_time_chat_section_3_body_3:
    'On voimaa olla aito.\nMyös silloin, kun siihen ei vastata.\nMyös silloin, kun se tekee meistä haavoittuvia.',
  end_of_time_chat_section_4_title: 'Osa Verkkohautaa',
  end_of_time_chat_section_4_body_1:
    'End of Time Chat on kehitetty osaksi Verkkohautaa.\nPaikka elämälle, suhteille ja läsnäololle – myös menetyksen jälkeen.',
  end_of_time_chat_section_5_title: 'Perusperiaate',
  end_of_time_chat_section_5_body_1:
    'End of Time Chat ei ole tuote.\nSe on tila, joka suojaa suhteita.',
  about_nettgrav_title: 'Tietoa Verkkohaudasta',
  about_nettgrav_intro:
    'Verkkohauta on luotu läheisyyttä varten sekä niille, jotka on haudattu, että niille jotka elävät eteenpäin.',
  about_nettgrav_body_1:
    'Kun kuolema tapahtuu, syntyy usein tarpeita joita pelkkä fyysinen hauta ei voi kantaa. Verkkohauta mahdollistaa läsnäolon myös verkossa – ajan, etäisyyden ja elämäntilanteiden yli.',
  about_nettgrav_body_2:
    'Hauta on enemmän kuin paikka. Se kantaa ihmisen, eletyn elämän ja suhteet ympärillä. Verkkohauta on tehty antamaan tälle tilalle arvokkuutta ja pysyvyyttä.',
  about_nettgrav_body_3:
    'Verkkohauta on olemassa riippumatta fyysisestä haudasta. Vaikka hauta muuttuu, siirtyy tai otetaan uudelleen käyttöön, digitaalinen paikka säilyy pysyvänä läheisyyden ja muistojen tilana.',
  about_nettgrav_body_4:
    'Palvelu on kehitetty Norjassa keskittyen kestävyyteen, kunnioitukseen ja inhimilliseen läheisyyteen. Verkkohauta saa tukea julkisista innovaatiorahoista Innovation Norwayn kautta, ja se on pitkälti rakennettu perheen ja ystävien tuella.',
  about_nettgrav_body_5:
    'Verkkohaudan taustalla ovat samat ihmiset kuin The End Of Time Corporationissa – norjalainen, pitkäjänteinen työ luoda palveluja, jotka kohtaavat kuoleman, ajan ja ihmisen tarpeen merkityksestä ja yhteydestä.',
  create_spark_title: 'Luo Kipinä',
  create_spark_intro: 'Tila sille, mikä on sinulle totta',
  create_spark_body_1: 'Oman uskon puolustaminen voi olla tunnepitoinen matka.',
  create_spark_body_2: 'Luo Kipinä antaa tilaa sanoittaa se, mikä on sinulle totta – eläessäsi.',
  create_spark_body_3: 'Kipinä voi olla ajatus, arvo, ihmettely tai pohdinta.',
  create_spark_body_4: 'Jotakin, jonka haluat ilmaista, ilman vaatimusta vastauksista.',
  create_spark_body_5:
    'Kipinän luominen ei ole muiden vakuuttamista, vaan rehellisyyttä itseä ja ympäröivää maailmaa kohtaan.',
  create_spark_body_6: 'Verkkohaudassa on sekä elämää että muistoja.',
  create_spark_body_7: 'Haudat kantavat historiaa. Kipinät kantavat sitä, mikä elää nyt.',
  partner_title: 'Kumppani',
  partner_intro:
    'Verkkohauta tekee yhteistyötä kumppaneiden kanssa, jotka haluavat tukea hyviä elämiä Verkkohautaa käyttävälle ihmisille ja perheille.',
  partner_body_1:
    'Yhteistyö Verkkohaudassa tarkoittaa ihmisten tukemista elämän tärkeissä hetkissä – läheisyydellä, huolenpidolla ja pitkäjänteisyydellä. Yhdessä haluamme vahvistaa emotionaalista ja psyykkistä kestävyyttä sekä valintoja, joilla on merkitystä ajan yli.',
  partner_body_2:
    'Organisaatioille ja brändeille, jotka haluavat rakentaa yhteiskuntaa jakamisen ja anteliaisuuden kautta, kumppaniohjelmamme on tarjolla yhteistyössä End of Time -verkoston kanssa, joka investoi resursseja sinne missä niitä tarvitaan.',
  partner_cta: 'Ryhty kumppaniksi',
  how_it_works_title: 'Näin Verkkohauta toimii',
  how_it_works_intro: 'Verkkohauta on paikka läheisyydelle omiin ihmisiin ja sille mikä merkitsee.',
  how_it_works_lead_1: 'Paikka, joka on fyysisen haudan rinnalla – ja joka säilyy ajan yli.',
  how_it_works_lead_2: 'Tämä sivu selittää, miten Verkkohauta toimii ja mitä voit odottaa.',
  how_it_works_section_1_title: 'Paikka fyysisen haudan rinnalla',
  how_it_works_section_1_body_1: 'Fyysinen hauta on paikka, jossa voi vierailla.',
  how_it_works_section_1_body_2:
    'Verkkohauta mahdollistaa läsnäolon myös verkossa, kun etäisyys, aika tai elämäntilanne tekee käynnin vaikeaksi.',
  how_it_works_section_1_body_3: 'Verkkohauta on riippumaton fyysisen haudan kestosta.',
  how_it_works_section_1_body_4:
    'Vaikka hauta muuttuu, siirtyy tai otetaan uudelleen käyttöön, Verkkohauta säilyy pysyvänä kuulumisen paikkana.',
  create_nettgrav_title: 'Luo Verkkohauta',
  create_nettgrav_intro: 'Verkkohaudan voi luoda silloin kun sitä tarvitaan.',
  create_nettgrav_body_1:
    'Verkkohaudan luomiseksi syötä haudatun nimi ja valitse kunta ja hautausmaa, jos nämä ovat tiedossa.',
  create_nettgrav_body_2: 'Verkkohauta ei ole riippuvainen fyysisestä haudasta.',
  create_nettgrav_body_3: 'Lähtökohtamme on haudattu – ei paikka.',
  create_nettgrav_section_create_title: 'Luo hauta verkossa',
  create_nettgrav_section_missing_title: 'Kun kunta tai hautausmaa puuttuu',
  create_nettgrav_missing_body_1:
    'Verkkohauta ei ajan myötä keskity kaikkien kuntien ja hautausmaiden rekisteröintiin.',
  create_nettgrav_missing_body_2: 'Jos kuntaa tai hautausmaata ei löydy listasta, valitse:',
  create_nettgrav_missing_body_3: 'Verkkohauta kuntana',
  create_nettgrav_missing_body_4: 'End Of Time Cemetery hautausmaana',
  create_nettgrav_missing_body_5: 'Tällöin Verkkohauta luodaan ilman kustannuksia.',
  create_nettgrav_missing_body_6:
    'Tämä Verkkohauta toimii samalla tavalla kuin muutkin ja tarjoaa pysyvän digitaalisen paikan läheisyydelle, muistoille ja suhteille.',
  create_nettgrav_section_place_title: 'Digitaalinen haudan luonti – paikka joka kestää',
  create_nettgrav_place_body_1: 'Verkkohauta perustuu yksinkertaiseen ajatukseen:',
  create_nettgrav_place_body_2: 'Haudattu on muualla kuin fyysisessä haudassa.',
  create_nettgrav_place_body_3:
    'Siksi Verkkohauta on tehty niille jotka elävät edelleen – perheelle, ystäville ja läheisille – sekä yhteydelle joka säilyy ajan myötä.',
  create_nettgrav_place_body_4:
    'End Of Time Cemetery on Verkkohaudan oma hautausmaa, tehty vastaanottamaan Verkkohautoja riippumatta fyysisestä paikasta ja tarkoitettu kestämään ajan myötä.',
  create_nettgrav_section_login_title: 'Kirjaudu sisään ja luo uusi Verkkohauta',
  create_nettgrav_login_body_1: 'Kirjaudu sisään ja luo uusi Verkkohauta',
  create_nettgrav_login_cta: 'Kirjaudu sisään ja luo uusi Verkkohauta',
  how_it_works_section_2_title: 'Etsi tai käy haudalla',
  how_it_works_section_2_body_1: 'Verkkohaudassa voit:',
  how_it_works_section_2_body_2: 'etsiä olemassa olevia hautoja',
  how_it_works_section_2_body_3: 'luoda uuden verkkohaudan',
  how_it_works_section_2_body_4: 'vierailla haudalla verkossa',
  how_it_works_section_2_body_5: 'liittää suhteesi haudattuun',
  how_it_works_section_2_body_6:
    'tutustua ihmiseen, jota hauta edustaa. Sinun ei tarvitse tehdä mitään tiettyä. Voit vain olla siellä – hiljaa ja ilman vaatimuksia.',
  how_it_works_section_3_title: 'Pienet teot, jotka merkitsevät',
  how_it_works_section_3_body_1: 'Verkkohauta rakentuu yksinkertaisista teoista:',
  how_it_works_section_3_body_2: 'lähettää lahjan',
  how_it_works_section_3_body_3: 'jakaa muutaman sanan',
  how_it_works_section_3_body_4: 'lisätä kuvan tai muiston',
  how_it_works_section_3_body_5: 'merkitä merkkipäiviä',
  how_it_works_section_3_body_6:
    'Kaikki on vapaaehtoista ja voidaan tehdä silloin kun se tuntuu oikealta.',
  how_it_works_section_3_body_7: 'Ei odotuksia. Ei määräaikoja.',
  how_it_works_section_4_title: 'Perhe ja läheiset',
  how_it_works_section_4_body_1: 'Verkkohauta voidaan jakaa perheen ja läheisten kanssa.',
  how_it_works_section_4_body_2: 'Sinä päätät:',
  how_it_works_section_4_body_3: 'kuka saa pääsyn',
  how_it_works_section_4_body_4: 'mitä jaetaan',
  how_it_works_section_4_body_5: 'miten hautaa hoidetaan ajan myötä',
  how_it_works_section_4_body_6: 'Näin useampi voi olla läsnä – omilla ehdoillaan.',
  how_it_works_section_5_title: 'Yksityisyys ja turvallisuus',
  how_it_works_section_5_body_1:
    'Verkkohauta on tehty emotionaalista ja inhimillistä turvallisuutta varten.',
  how_it_works_section_5_body_2: 'Sisältö voi olla:',
  how_it_works_section_5_body_3: 'yksityistä',
  how_it_works_section_5_body_4: 'näkyvää kutsutuille',
  how_it_works_section_5_body_5: 'avointa kaikille haudalla vieraileville',
  how_it_works_section_5_body_6: 'Sinä päätät ja voit muuttaa tätä, kun se tuntuu oikealta.',
  how_it_works_section_6_title: 'Luo Kipinä – elämä joka elää nyt',
  how_it_works_section_6_body_1: 'Verkkohaudan lisäksi on Luo Kipinä.',
  how_it_works_section_6_body_2:
    'Luo Kipinä on tila pohdinnalle, ajatuksille ja sille mikä on sinulle totta – kun elät.',
  how_it_works_section_6_body_3:
    'Täällä sanoja voi jakaa elämän, merkityksen ja yhteyden ilmaisuna.',
  how_it_works_section_6_body_4: 'Haudat kantavat historiaa.',
  how_it_works_section_6_body_5: 'Kipinät kantavat sitä, mikä elää nyt.',
  how_it_works_section_7_title: 'Paikka, joka on tehty kestämään',
  how_it_works_section_7_body_1: 'Verkkohauta on rakennettu aikaa varten.',
  how_it_works_section_7_body_2: 'Se on paikka, joka ei katoa eikä vaadi ylläpitoa.',
  how_it_works_section_7_body_3: 'Pysyvä tila läheisyydelle elämään.',
  how_it_works_section_7_body_4: 'Voit palata milloin haluat.',
  how_it_works_section_7_body_5: 'Riittää, että olet siellä.',
  orbit_section_header: 'Maan sijainti',
  orbit_intro_text:
    'Me kaikki matkustamme yhdessä tällä suurella matkalla Auringon ympäri. Et ole koskaan yksin täällä.',
  orbit_day_progress: 'Päivä {day} / 365',
  orbit_position_label: 'Maan sijainti: {position}°',
  page_not_found: 'Tätä sivua ei löydy.',
  grave_load_server_error: 'Palvelimella tapahtui virhe. Lataa sivu uudelleen ja yritä uudelleen.',
  grave_load_failed: 'Hautaa ei voitu ladata. Yritä uudelleen.',
  grave_user_load_failed: 'Käyttäjätietoja ei voitu ladata. Yritä uudelleen.',
  grave_static_data_load_failed: 'Tarvittavia tietoja ei voitu ladata. Yritä uudelleen.',
  see_more: 'näytä lisää',
  filter_button: 'Suodata hautoja',
  search_event: 'Etsi tapahtuma, päivämäärä',
  add_new: 'Lisää uusi',
  search_tab_all: 'Kaikki',
  search_tab_graves: 'Haudat',
  search_tab_members: 'Ihmiset',
  search_people_none_text: 'Jäseniä ei löytynyt haulle',
  user_age: 'Ikä:',
  user_shared_grave: 'jaettu hauta',
  user_shared_graves: 'jaetut haudat',
  view_life_page: 'Näytä Life-sivu',
  see_my_light: 'Katso Minun Valoni',
  see_user_light: 'Katso {name}n Valoa',
  relation_to: 'suhde',
  user_values_heading:
    'Täällä sinuun yhteydessä olevat voivat kertoa, miten he kokevat sinut. Voit myös vierailla henkilön luona ja tehdä hänelle hyvää.',
  add_user_values: 'Sano mitä näet',
  user_values_modal_title: 'Mitä näet {name}ssa?',
  user_values_modal_subtitle:
    'To let someone know that you value and see their inner being is truly valuable. The value given and received is unending.',
  user_values_select_category: 'Select category',
  user_values_select_value: 'Valitse sana, jonka tunnistat.',
  user_values_save: 'Save',
  user_values_note_placeholder: 'Lisää muistiinpano',
  family_tree_page_title: 'Sukupuut',
  family_tree_set_relationships: 'Määritä suhteet',
  family_tree_set_relationship: 'Määritä suhde',
  family_tree_choose_my_relation: 'Valitse suhteeni',
  family_tree_people_you_might_know: 'Henkilöitä, joita saatat tuntea',
  family_tree_no_suggestions: 'Ei ehdotuksia vielä',
  family_tree_relations_in_tree: 'Suhteet puussa',
  family_tree_relations_radius_hint:
    'Näyttää suhteet, jotka ovat mukana puussa {count} sukupolven sisällä.',
  family_tree_focus_in_tree: 'Kohdista puussa',
  family_tree_group_parents: 'Vanhemmat',
  family_tree_group_partners: 'Puolisot',
  family_tree_group_siblings: 'Sisarukset',
  family_tree_group_children: 'Lapset ja jälkeläiset',
  family_tree_group_grandparents_list: 'Isovanhemmat ja vanhemmat sukupolvet',
  family_tree_group_extended_family: 'Muut perheessä',
  family_tree_open_relation: 'Avaa',
  family_tree_open_grave: 'Siirry haudalle',
  family_tree_open_light: 'Siirry valoon',
  family_tree_suggestion_likely_relation: 'Voi olla sinun {relation}',
  family_tree_suggestion_via: '{name} kautta',
  family_tree_your_relations: 'Sinun suhteesi',
  family_tree_empty_title: 'Sukupuusi alkaa kasvaa täällä.',
  family_tree_empty_description:
    'Voit jo asettaa suhteita haudattuihin ja nähdä siteiden muodostuvan. Tämä on varhainen versio – lisää oksia ja ominaisuuksia tulossa pian.',
  family_tree_card_title: 'Sinun sukupuusi',
  family_tree_card_members: '{count} jäsentä',
  family_tree_card_description: 'Sinä ja kaksi poikaasi olette täällä',
  family_tree_view_tree: 'Näytä sukupuu',
  family_tree_empty_state:
    'Suhteesi näkyvät täällä. Aloita liittämällä suhde hautaan tai henkilöön.',
  family_tree_no_relations: 'Ei vielä sukulaisia',
  family_tree_connect_relation: 'Yhdistä sukulainen',
  family_tree_load_more: 'Lataa lisää',
  family_tree_no_info: 'Ei tietoja',
  family_tree_single_node_hint:
    'Sukupuu kasvaa, kun liität suhteita hautoihin ja henkilöihin, kuten vanhempiin tai lapsiin.',
  still_alive: 'yhä elossa',
  family_tree_modal_title: 'Valitse suhteesi henkilöön {name}',
  family_tree_modal_suggestion_title: 'Valitse suhteesi henkilöön {name}',
  family_tree_modal_claim_title: 'Hoitovastuu haudasta',
  family_tree_modal_add_mother_title: 'Lisää äitisi',
  family_tree_modal_add_father_title: 'Lisää isäsi',
  family_tree_role_mother: 'äiti',
  family_tree_role_father: 'isä',
  family_tree_role_person: 'henkilö',
  family_tree_modal_tab_relation: 'Suhde',
  family_tree_modal_tab_care: 'Ryhdy huoltajaksi',
  family_tree_modal_select_grave_label: 'Kirjoita ja valitse hauta-/elämäsivu',
  family_tree_modal_select_grave_placeholder: 'Kirjoita ja valitse nimi',
  family_tree_modal_search_person_label: 'Etsi ja valitse henkilö',
  family_tree_modal_search_person_placeholder: 'Etsi {role}',
  family_tree_modal_search_person_hint: 'Kirjoita vähintään 2 kirjainta hakeaksesi nimellä.',
  family_tree_modal_locked_relation_label: 'Suhde',
  family_tree_modal_locked_relation_value: 'Tallennetaan muodossa: {relation}',
  family_tree_modal_invite_person: 'Ei osumia vielä. Kokeile koko nimeä tai toista kirjoitusasua.',
  family_tree_modal_relation_to_person_label: 'Suhteesi henkilöön {name}',
  family_tree_modal_relation_to_you_label: 'Mikä on tämän henkilön suhde sinuun?',
  family_tree_modal_relation_to_you_with_name_label: 'Mikä on {name}n suhde sinuun?',
  family_tree_connect_relations_modal_title: 'Yhdistä suhteet',
  family_tree_connect_relations_modal_subtitle: 'Helppo yhdistää eri sukulaiset toisiinsa',
  family_tree_connect_relations_first_label: 'Valitse sukulainen',
  family_tree_connect_relations_second_label:
    'Valitse sukulainen jonka haluat liittää yllä olevaan',
  family_tree_connect_relations_third_label: 'Valitse {from}n suhde {to}iin',
  family_tree_connect_relations_third_label_default: 'Valitse ensimmäisen henkilön suhde toiseen',
  family_tree_connect_relations_fourth_label: 'Mikä on {to}n suhde {from}iin',
  family_tree_connect_relations_fourth_label_default: 'Mikä on toisen henkilön suhde ensimmäiseen',
  family_tree_tab: 'Sukupuu',
  family_tree_tree_tab: 'Puu',
  family_tree_no_grave_selected: 'Valitse henkilö aloittaaksesi sukupuun.',
  family_tree_me_label: 'Minä',
  family_tree_you_label: 'Sinä',
  family_tree_you_are_relation: 'Olet {relation}',
  family_tree_additional_connections: '+{count} lisää',
  family_tree_connected_relatives: 'Yhdistetyt sukulaiset',
  family_tree_modal_reciprocal_label: '{name}n suhde sinuun',
  family_tree_modal_more_relations: 'Lisää vaihtoehtoja',
  family_tree_modal_confirm_relation: 'Vahvista suhde',
  family_tree_modal_confirm_care: 'Vahvista hoitovastuu',
  family_tree_modal_relation_search_placeholder: 'Hae suhteita',
  family_tree_modal_relation_search_no_results: 'Ei vastaavia suhteita',
  family_tree_depth: 'Syvyys',
  family_tree_radius_label: 'Sukupolvet',
  family_tree_radius_help: 'Näytä enemmän sukupolvia sukupuussa.',
  family_tree_radius_decrease: 'Näytä vähemmän sukupolvia',
  family_tree_radius_increase: 'Näytä enemmän sukupolvia',
  family_tree_zoom_label: 'Zoom',
  family_tree_zoom_in: 'Lähennä',
  family_tree_zoom_out: 'Loitonna',
  family_tree_fit_view: 'Sovita koko sukupuu',
  family_tree_center_viewer: 'Keskitä minuun',
  family_tree_toggle_panel: 'Paneeli',
  family_tree_children: 'Lapset',
  family_tree_partners: 'Kumppanit',
  family_tree_siblings: 'Sisarukset',
  waiting_for_approval: 'Odottaa hyväksyntää',
  family_tree_relation_of_user: '{name}n {relation}',
  family_tree_deceased_relation_to_user: '{deceased} on {relation} henkilölle {name}',
  family_tree_unknown_person: 'Tämä henkilö',
  family_tree_senses_title: 'Aistit',
  family_tree_add_skill: 'Lisää talentti',
  family_tree_talent_name_placeholder: 'Talentti, lahja tai kyky',
  family_tree_talent_note_placeholder: 'Valinnainen huomio (miten tämä näkyy elämässä)',
  family_tree_no_skills: 'Lahjakkuuksia ei ole vielä lisätty',
  family_tree_cycles_broken_title: 'Mallit jotka katkesivat',
  family_tree_add_cycle_broken: 'Lisää muutos',
  family_tree_cycle_name_placeholder:
    'Malli joka katkesi, tai jotain mitä vietiin eteenpäin toisin',
  family_tree_cycle_note_placeholder: 'Mikä teki tämän muutoksen mahdolliseksi?',
  family_tree_no_cycles_broken: 'Muutoksia ei ole vielä lisätty',
  family_tree_shared_lineage_title: 'Suvun toistuvat mallit',
  family_tree_shared_lineage_intro: 'Jotkin asiat toistuvat sukupolvien läpi.',
  family_tree_no_shared_lineage: 'Tässä tällaiset mallit voivat tulla näkyviksi ajan myötä.',
  family_tree_trait_signal_personal_memory: 'Henkilökohtainen muisto',
  family_tree_trait_signal_possible_family_pattern: 'Mahdollinen sukuperäinen malli',
  family_tree_trait_signal_family_confirmed: 'Suvun vahvistama',
  family_tree_trait_signal_personal_transformation: 'Henkilökohtainen muutos',
  family_tree_trait_signal_possible_family_transformation: 'Mahdollinen perhemuutos',
  family_tree_trait_signal_family_confirmed_transformation: 'Perheen vahvistama muutos',
  family_tree_group_cycles: 'Muutokset',
  family_tree_find_and_add: 'Etsi ja lisää',
  family_tree_done: 'Valmis',
  family_tree_search_loading: 'Ladataan...',
  family_tree_search_no_matches: 'Ei osumia. Voit silti lisätä käsin alla.',
  family_tree_unified_search_placeholder: 'Etsi aisteja, lahjakkuuksia ja muutoksia...',
  family_tree_suggested_senses: 'Ehdotetut aistit',
  family_tree_suggested_talents: 'Ehdotetut lahjakkuudet',
  family_tree_suggested_cycles: 'Ehdotetut muutokset',
  family_tree_origin_personal: 'Henkilökohtainen',
  family_tree_origin_possible_family_pattern: 'Mahdollinen perhemalli',
  family_tree_origin_family_pattern: 'Perhemalli',
  family_tree_origin_personal_change: 'Henkilökohtainen muutos',
  family_tree_origin_possible_family_change: 'Mahdollinen perhemuutos',
  family_tree_origin_family_change: 'Perhemuutos',
  family_tree_added_by_you: 'Lisätty sinun toimesta',
  family_tree_chip_added_in_family: 'Lisätty perheeseen',
  family_tree_agree: 'Tunnistan',
  family_tree_agreed: 'Tunnistan',
  family_tree_shared_in_lineage: 'Jaettu sukulinjassa',
  family_tree_kind_sense: 'Aisti',
  family_tree_kind_talent: 'Lahjakkuus',
  family_tree_kind_cycle: 'Muutos',
  family_tree_lineage_type_cycle: 'Muutos',
  family_tree_lineage_type_talent: 'Lahjakkuus',
  family_tree_parents_title: 'Vanhemmat',
  family_tree_no_parents: 'Vanhempia ei ole merkitty',
  family_tree_add_mother: 'Lisää äiti',
  family_tree_add_father: 'Lisää isä',
  family_tree_detached_title: 'Tunnetut henkilöt ilman yhteyttä vielä',
  family_tree_detached_description:
    'Nämä henkilöt on rekisteröity, mutta heillä ei vielä ole perheyhteyttä tässä puussa.',
  family_tree_close_panel: 'Sulje tietopaneeli',
  family_tree_remove_talent: 'Poista lahjakkuus',
  family_tree_remove_change: 'Poista muutos',
  family_tree_add_note: 'Lisää teksti',
  family_tree_edit_note: 'Muokkaa tekstiä',
  user_has_already_been_taken: 'Käyttäjä on jo käytössä',
  relation_already_exists: 'Suhde on jo olemassa',
  coin_store_categories: 'Kategoriat',
  coin_store_price: 'Hinta',
  coin_store_category_all: 'Kaikki',
  coin_store_category_flowers: 'Kukat',
  coin_store_category_plants: 'Kasvit',
  coin_store_category_candles: 'Kynttilät',
  coin_store_category_cure: 'Cure',
  coin_store_occasions: 'Tilaisuudet',
  coin_store_add_to_cart: 'Valitse tämä',
  coin_store_preview: 'Katso esikatselu',
  coin_store_preview_frame: 'Katso ympyrää',
  coin_store_preview_candle: 'Katso kynttilää',
  coin_store_already_subscribed: 'Jo tilattu',
  coin_store_no_products: 'Ei tuotteita saatavilla',
  coin_store_no_frames: 'Ei kehyksiä saatavilla',
  coin_store_no_flowers: 'Ei kukkia saatavilla',
  coin_store_no_candles: 'Ei kynttilöitä saatavilla',
  coin_store_no_plants: 'Ei kasveja saatavilla',
  coin_store_no_cure_products: 'Ei Cure-tuotteita saatavilla',
  coin_store_search_placeholder: 'Hae',
  coin_store_sort_placeholder: 'Järjestä',
  coin_store_sort_name: 'Nimi',
  coin_store_sort_price_low: 'Hinta: Alhaisesta korkeaan',
  coin_store_sort_price_high: 'Hinta: Korkeasta alhaiseen',
  coin_store_tab_all: 'KAIKKI',
  coin_store_tab_physical: 'FYYSINEN',
  coin_store_tab_digital: 'DIGITAALINEN',
  coin_store_tab_gift: 'LAHJOITA PALVELUS',
  coin_store_category_frames: 'Ympyrät',
  coin_store_hero_heading: 'End Of Time Collection',
  coin_store_hero_subheading: 'Jokainen liekki ja ympyrä tuo läsnäolon takaisin.',
  coin_store_hero_image_alt: 'store illustration',
  coin_store_hero_pill_label: 'Everlight – seuraa haudan vuorokausirytmiä',
  coin_store_hero_note1: 'rauhallinen animaatio, lempeä silmille',
  coin_store_hero_note2: 'suunniteltu läsnäoloon – ei hälyyn',
  coin_store_filters: 'Suodattimet',
  nav_section: 'Navigointi',
  account_section: 'Tili',
  aria_menu: 'valikko',
  aria_profile_menu: 'profiilivalikko',
  aria_notifications: 'ilmoitukset',
  aria_home: 'koti',
  aria_my_light: 'minun valoni',
  aria_open_search: 'avaa haku',
  aria_close_search: 'sulje haku',
  verified: 'Vahvistettu',
  claimed_by_you: 'Rekisteröity sinun toimesta',
  claimed_explainer: 'Tämä hauta on vahvistettu ja liitetty tiliisi.',
  composer_visibility: 'Näkyvyys',
  composer_public: 'Julkinen',
  composer_relatives: 'Sukupiiri',
  composer_private: 'Yksityinen',
  composer_public_desc: 'kaikille',
  composer_relatives_desc: 'Näkyy perheelle/seuraajille',
  composer_private_desc: 'Vain sinulle',
  composer_more: 'Lisää valintoja …',
  composer_fewer: 'Vähemmän valintoja',
  composer_caption_ph: 'Kuvateksti (valinnainen)',
  composer_add_link_prompt: 'Liitä linkki (URL)',
  composer_add_link: 'Lisää linkki',
  composer_add_emoji: 'Lisää emoji',
  composer_search_emoji: 'Etsi emojeja',
  reply: 'Vastaa',
  store_products: 'Ympyrät ja kynttilät',
  store_products_subheading: 'Valitse nyt. Käytä sitä Omat valinnat -sivulta oston jälkeen.',
  store_intro_eyebrow: 'Läsnäoloa Verkkohaudalla',
  store_intro_title: 'Jollekulle, jota ajattelet',
  store_intro_body:
    'Täältä löydät kynttilöitä ja ympyröitä, joilla voit antaa ajatuksellesi henkilökohtaisen ilmeen.',
  store_intro_candles: 'Sytytä kynttilä',
  store_intro_frames: 'Valitse ympyrä',
  store_intro_inventory: 'Näytä Omat valinnat',
  store_frames_description:
    'Digitaalinen ympyrä haudan profiilikuvan ympärille. Oston jälkeen valitset Omat valinnat -sivulta haudan, jolla sitä käytetään.',
  store_candles_description:
    'Digitaalinen kynttilä, jonka voit sytyttää haudalle nyt tai merkkipäivänä. Yksi osto lisää yhden kynttilän Omiin valintoihin.',
  store_view_all: 'Näytä kaikki: {category}',
  store_choose_frame: 'Valitse tämä ympyrä',
  store_choose_candle: 'Valitse tämä kynttilä',
  store_preview_no_grave:
    'Voit tehdä valinnan nyt ja valita haudan Omat valinnat -sivulta oston jälkeen.',
  store_preview_example_grave: 'Esimerkki haudasta',
  store_cart_open: 'Avaa valintasi',
  store_cart_close: 'Sulje valintasi',
  store_cart_decrease: 'Vähennä määrää',
  store_cart_increase: 'Lisää määrää',
  store_cart_remove: 'Poista valinnasta',
  store_cart_empty: 'Et ole vielä valinnut mitään.',
  store_continue_checkout: 'Jatka',
  store_favorites_section: 'Tallennettu myöhempää varten',
  store_favorite_add: 'Tallenna myöhemmäksi',
  store_favorite_remove: 'Poista tallennus',
  coin_store_select_frame_title: 'Valitse ympyrä',
  coin_store_select_frame_subtitle: 'Valitse kehys, jonka haluat lisätä kokoelmaasi.',
  coin_store_select_frame_confirm: 'Valitse tämä?',
  frame_upload_title: 'Add New Frame',
  frame_upload_name_label: 'Name',
  frame_upload_name_placeholder: 'Frame name',
  frame_upload_name_required: 'Enter frame name',
  frame_upload_kind_label: 'Kind',
  frame_upload_kind_svg: 'SVG',
  frame_upload_kind_lottie: 'Lottie',
  frame_upload_kind_gif: 'GIF',
  frame_upload_kind_apng: 'APNG',
  frame_upload_kind_webp: 'WebP',
  frame_upload_kind_mp4: 'MP4',
  frame_upload_kind_webm: 'WebM',
  frame_upload_kind_mov: 'MOV',
  frame_upload_kind_tgs: 'TGS',
  frame_upload_viewbox_label: 'ViewBox',
  frame_upload_viewbox_placeholder: 'e.g., 0 0 100 100',
  frame_upload_viewbox_extra: "Format: 'minX minY width height'",
  frame_upload_inner_circle_label: 'Inner Circle',
  frame_upload_inner_circle_extra: 'Circle center (cx, cy) and radius (r) in viewBox units',
  frame_upload_inner_circle_cx_placeholder: 'cx',
  frame_upload_inner_circle_cy_placeholder: 'cy',
  frame_upload_inner_circle_r_placeholder: 'r',
  frame_upload_asset_file_label: 'Asset File',
  frame_upload_asset_file_button: 'Select file',
  frame_upload_asset_file_required: 'Please select at least one file.',
  frame_upload_price_label: 'Price',
  frame_upload_price_placeholder: 'Enter price',
  frame_upload_price_required: 'Enter price',
  frame_upload_description_label: 'Description',
  frame_upload_description_placeholder: 'Describe this frame',
  frame_upload_color_label: 'Väri',
  frame_upload_color_red: 'Punainen',
  frame_upload_color_blue: 'Sininen',
  frame_upload_color_green: 'Vihreä',
  frame_upload_theme_label: 'Teema',
  frame_upload_theme_light: 'Vaalea',
  frame_upload_theme_dark: 'Tumma',
  frame_upload_submit: 'Upload',
  frame_upload_delete_title: 'Delete Frame',
  frame_upload_delete_content: 'Tämä on pysyvää.',
  frame_upload_delete_ok: 'Delete',
  frame_apply: 'Käytä',
  frame_buy_more: 'Valitse ympyrä',
  frame_available_quantity: 'Saatavilla: x{count}',
  frame_applied_at: 'Aktiivinen:',
  frame_no_graves_yet: 'Kytketyt hautasi näkyvät täällä',
  frame_no_graves_active: 'Ei aktiivisia hautoja vielä.',
  no_frames_available: 'Sinulla ei ole vielä ympyröitä. Katso ympyrät, joista voit valita.',
  frame_modal_title: 'Valitse ympyrä tai lisää kuva',
  frames_store_title: 'Ympyrät',
  send_gift: 'Sytytä kynttilä',
  gift_message_label: 'Sanat haudalle',
  gift_event_context_time: '{event} · {time}',
  gift_message_placeholder: 'Kirjoita muutama sana, jos haluat',
  no_gifts_available: 'Ei lahjoja saatavilla.',
  no_gifts_yet: 'Sytytä kynttilä {graveName}lle',
  candles: 'Kynttilät',
  choose_candle: 'Valitse kynttilä',
  add_candle: 'Lisää kynttilä',
  buy_gifts: 'Osta lahjoja',
  gifts_title: 'Lahjat',
  gifts_empty_state: 'No gifts have been added yet.',
  previous_gift: 'Edellinen lahja',
  next_gift: 'Seuraava lahja',
  gift_update_success: 'Gift updated',
  gift_delete_success: 'Gift deleted',
  gifts_load_error: 'Unable to load gifts right now.',
  gift_update_error: 'Unable to update gift.',
  gift_delete_error: 'Unable to delete gift.',
  gift_edit_title: 'Muokkaa lahjaa',
  gift_sent: 'Lahja lähetetty',
  gift_send_error: 'Lahjan lähetys epäonnistui',
  gift_event_by_user: '{event} käyttäjältä {user}',
  edit_text_description: 'Lisää, muokkaa tai poista tekstiä',
  my_light_tooltip: 'Kipinäsi tekee maailmasta parempaa.',
  products_title: 'Ympyrät ja kynttilät',
  products_add_product: 'Lisää tuote',
  products_edit_product: 'Muokkaa tuotetta',
  products_table_index: 'Nro',
  products_table_name: 'Nimi',
  products_table_image_or_frame: 'Kuva tai kehys',
  products_table_price: 'Hinta',
  products_table_description: 'Kuvaus',
  products_table_action: 'Toiminto',
  products_action_edit: 'Muokkaa',
  products_action_delete: 'Poista',
  products_form_type_label: 'Tyyppi',
  products_form_type_frame: 'Kehys',
  products_form_type_cure: 'Hoito',
  products_form_type_flower: 'Kukka',
  products_form_type_plant: 'Kasvi',
  products_form_type_candle: 'Kynttilä',
  products_form_cure_name_label: 'Nimi',
  products_form_cure_name_placeholder: 'Tuotteen nimi',
  products_form_cure_name_required: 'Anna tuotteen nimi',
  products_form_cure_lengths_label: 'Jaksot',
  products_form_cure_lengths_placeholder: 'Kirjoita sopimuskaudet',
  products_form_cure_lengths_required: 'Anna jaksot',
  products_form_cure_price_label: 'Hinta',
  products_form_cure_price_placeholder: 'Kirjoita hinta',
  products_form_cure_price_required: 'Anna hinta',
  products_form_cure_description_label: 'Kuvaus',
  products_form_cure_description_placeholder: 'Kuvaile tuotetta',
  products_form_cure_image_label: 'Kuva',
  products_form_cure_image_required: 'Valitse kuva.',
  products_form_upload_button: 'Lataa',
  products_form_translations_label: 'Käännökset',
  products_form_add_translation: 'Lisää käännös',
  products_form_translations_help:
    'Lisää kielikohtainen teksti korvataksesi englanninkielisen oletuksen.',
  products_form_translation_locale_label: 'Kieli',
  products_form_translation_locale_required: 'Valitse kieli',
  products_form_translation_locale_placeholder: 'Valitse kieli',
  products_form_translation_name_label: 'Nimi',
  products_form_translation_name_required: 'Anna nimi',
  products_form_translation_name_placeholder: 'Käännetty tuotteen nimi',
  products_form_translation_description_label: 'Kuvaus',
  products_form_translation_description_placeholder: 'Käännetty kuvaus (valinnainen)',
  products_form_translation_remove: 'Poista käännös',
  products_delete_error_in_use: 'Tuotetta ei voi poistaa, koska se on edelleen käytössä.',
  checkout_purchase_success: 'Osto onnistui',
  checkout_payment_failed: 'Maksu epäonnistui',
  checkout_missing_payment_method_id: 'Maksutavan tunnus puuttuu',
  lighthouse_title: 'End Of Time Collection',
  lighthouse_subtitle: 'Jokainen liekki ja ympyrä tuo läsnäolon takaisin.',
  lighthouse_description:
    'Horisontissa horjumaton valo, joka johdattaa rakkauden pimeiden vesien läpi. Tyynet meret, hiljainen voima ja säde, joka sanoo: et ole koskaan yksin. Hellä kunnianosoitus rannikon sydämille ja kaikille, jotka saattoivat toiset turvallisesti kotiin.',
  lighthouse_go_to_store: 'Katso kokoelma',
  frame_info_title: 'Näin lisäät kehyksen',
  frame_info_description:
    '1. Mene haudalle, jota haluat muokata.\n2. Napsauta haudan profiilikuvaa.\n3. Valitse kehys – se näkyy haudalla heti.',
  profile_and_settings: 'Profiili ja asetukset',
  help_and_support: 'Ohje ja tuki',
  report_problem: 'Ilmoita ongelmasta',
  light_theme: 'Vaalea teema',
  dark_theme: 'Tumma teema',
  toggle_theme: 'Vaihda teemaa',
  toggle_theme_to_dark: 'Vaihda tummaan tilaan',
  toggle_theme_to_light: 'Vaihda vaaleaan tilaan',
  partner_title: 'Kumppani',
  partner_become_seller: 'Ryhty kumppaniksi (myyjätili)',
  partner_status_pending: 'Kumppanistatus: odottaa hyväksyntää',
  partner_apply: 'Hae kumppaniksi',
  partner_open_portal: 'Avaa kumppaniportaali',
  partner_dashboard: 'Kumppanikoontinäyttö',
  partner_create_ad: 'Luo mainos/tuote',
  partner_payouts: 'Maksut',
  'designSystem.showcase.title': 'Design System',
  'designSystem.colors.title': 'Portaalin värimalli',
  'designSystem.colors.silver': 'Hopea',
  'designSystem.colors.gold': 'Kulta',
  'designSystem.colors.roseGold': 'Ruusukulta',
  'designSystem.colors.bronze': 'Pronssi',
  'designSystem.colors.titanium': 'Titaani',
  'designSystem.colors.emerald': 'Smaragdi',
  'designSystem.colors.platinum': 'Platina',
  'designSystem.colors.copper': 'Kupari',
  'designSystem.colors.amethyst': 'Ametisti',
  'designSystem.colors.sapphire': 'Safiiri',
  'designSystem.colors.ruby': 'Rubiiini',
  'designSystem.colors.obsidian': 'Obsidiaani',
  'designSystem.colors.aqua': 'Akvamariini',
  'designSystem.colors.sunset': 'Auringonlasku',
  'designSystem.colors.surfaces': 'Pintavärit',
  'designSystem.colors.text': 'Tekstivärit',
  'designSystem.colors.metallic': 'Metalliset paletit',
  'designSystem.colors.viewMetallicIcons': 'Näytä metallikuvake-demo',
  'designSystem.anniversaries.upcoming': 'Tulevat merkkipäivät',
  'designSystem.anniversaries.breakdown.title': 'Seuraavat 7 päivää',
  'designSystem.anniversaries.grave': 'Hauta',
  'designSystem.anniversaries.user': 'Käyttäjä',
  'designSystem.anniversaries.public': 'Julkiset',
  'designSystem.anniversaries.total': 'Yhteensä',
  'designSystem.grid.sectionTitle': 'Ruudukkoasettelu',
  'designSystem.grid.controls.title': 'Interaktiiviset ohjaimet',
  'designSystem.grid.controls.align': 'Pystysuuntainen tasaus',
  'designSystem.grid.controls.justify': 'Vaakasuuntainen tasaus',
  'designSystem.grid.controls.horizontalGutter': 'Vaakasuuntainen väli (px)',
  'designSystem.grid.controls.verticalGutter': 'Pystysuuntainen väli (px)',
  'designSystem.grid.controls.wrap': 'Rivitä',
  'designSystem.grid.controls.currentProps': 'Aktiiviset ominaisuudet',
  'designSystem.grid.preview.title': 'Esikatselu',
  'designSystem.grid.align.top': 'Yläreuna',
  'designSystem.grid.align.middle': 'Keskelle',
  'designSystem.grid.align.bottom': 'Alareuna',
  'designSystem.grid.align.stretch': 'Venytä',
  'designSystem.grid.justify.start': 'Alku',
  'designSystem.grid.justify.center': 'Keskelle',
  'designSystem.grid.justify.end': 'Loppu',
  'designSystem.grid.justify.spaceBetween': 'Tasaus: väliin',
  'designSystem.grid.justify.spaceAround': 'Tasaus: ympärille',
  'designSystem.grid.justify.spaceEvenly': 'Tasaus: tasaisesti',
  'designSystem.grid.box.label': 'Sarake {index}',
  'designSystem.grid.box.span': 'span {value}',
  'designSystem.grid.box.offset': 'Siirtymä {value}',
  'designSystem.grid.box.order': 'Järjestys {value}',
  'designSystem.grid.box.flex': 'flex {value}',
  'designSystem.grid.box.grow': 'Täyttää jäljellä olevan tilan',
  'designSystem.grid.responsive.title': 'Responsiivinen esimerkki',
  'designSystem.grid.responsive.description':
    'Muuta ikkunan kokoa nähdäksesi, miten välit ja tasaukset vaihtuvat katkospisteissä.',
  'designSystem.grid.box.responsive': 'xs 24 → md 12',
  'designSystem.grid.box.responsiveDetail': 'Pinoutuu mobiilissa, jakautuu työpöydällä',
  'designSystem.grid.box.responsiveAlign': 'Jakaa välin automaattisesti kontekstin kautta',
  'designSystem.grid.docs.title': 'Ruudukkoasettelu – Row & Col',
  'designSystem.grid.docs.notes':
    'Row laskee responsiiviset välit ja tasaukset, ja Col heijastaa niitä kontekstin kautta, jotta asettelut pysyvät yhdenmukaisina.',
  'designSystem.mediaUpload.triggerLabel': 'Select files',
  'designSystem.mediaUpload.type.media': 'media',
  'designSystem.mediaUpload.type.image': 'images',
  'designSystem.mediaUpload.type.video': 'videos',
  'designSystem.mediaUpload.type.audio': 'audio',
  'designSystem.mediaUpload.type.file': 'files',
  'designSystem.mediaUpload.dropHint': 'Drag & drop to upload or browse files',
  'designSystem.mediaUpload.dropActive': 'Release to upload',
  'designSystem.mediaUpload.emptyState': 'No files selected yet',
  'designSystem.mediaUpload.previewVideoLabel': 'Preview of {name}',
  'designSystem.mediaUpload.previewImageAlt': 'Preview of {name}',
  'designSystem.mediaUpload.removeFile': 'Remove {name}',
  'designSystem.mediaUpload.editFile': 'Muokkaa {name}',
  'designSystem.mediaUpload.zoom': 'Zoomaus',
  'designSystem.mediaUpload.unnamed': 'Untitled file',
  'designSystem.mediaUpload.showcase.defaultLabel': 'Media library',
  'designSystem.mediaUpload.showcase.defaultDescription':
    'Upload new photos, videos or audio to share with your team.',
  'designSystem.mediaUpload.showcase.controlTitle': 'Configuration',
  'designSystem.mediaUpload.showcase.mediaTypeLabel': 'Media type',
  'designSystem.mediaUpload.showcase.multipleLabel': 'Allow multiple files',
  'designSystem.mediaUpload.showcase.maxFilesLabel': 'Max files',
  'designSystem.mediaUpload.showcase.duplicatesLabel': 'Allow duplicate files',
  'designSystem.mediaUpload.showcase.dragLabel': 'Enable drag & drop',
  'designSystem.mediaUpload.showcase.selectedCount':
    '{count, plural, =0 {No files yet} one {# file selected} other {# files selected}}',
  'designSystem.mediaUpload.showcase.helper': 'Maximum {limit} MB per file',
  'designSystem.mediaUpload.showcase.tooLarge': '{name} exceeds the {limit} MB limit',
  'designSystem.mediaUpload.showcase.untitledFile': 'Selected file',
  'designSystem.mediaUpload.showcase.trigger': 'Upload {label}',
  'designSystem.mediaUpload.showcase.dropHint': 'Drag & drop {label} or browse files',
  'designSystem.mediaUpload.showcase.examplesTitle': 'Examples',
  'designSystem.mediaUpload.showcase.imageTitle': 'Gallery images',
  'designSystem.mediaUpload.showcase.imageDescription':
    'Upload retina-ready hero images for landing pages.',
  'designSystem.mediaUpload.showcase.imageHelper': 'PNG or JPG up to {limit} MB each.',
  'designSystem.mediaUpload.showcase.videoTitle': 'Promo video',
  'designSystem.mediaUpload.showcase.videoDescription':
    'Collect a single teaser video for campaigns.',
  'designSystem.mediaUpload.showcase.videoHelper':
    'MP4 up to {limit} MB. We’ll transcode automatically.',
  'designSystem.mediaUpload.showcase.audioTitle': 'Audio tribute',
  'designSystem.mediaUpload.showcase.audioDescription': 'Gather spoken memories or music clips.',
  'designSystem.mediaUpload.showcase.audioHelper': 'MP3 or WAV up to {limit} MB.',
  'designSystem.mediaUpload.showcase.fileTitle': 'Document upload',
  'designSystem.mediaUpload.showcase.fileDescription': 'Store memorial programs or consent forms.',
  'designSystem.mediaUpload.showcase.fileHelper': 'PDF or DOCX up to {limit} MB each.',
  'designSystem.mediaUpload.showcase.buttonTitle': 'Quick upload button',
  'designSystem.mediaUpload.showcase.buttonDescription':
    'Single tap button with icon for quick uploads.',
  'designSystem.mediaUpload.showcase.buttonHelper': 'Tap the button to pick one or more files.',
  'designSystem.mediaUpload.showcase.buttonTrigger': 'Choose files',
  'designSystem.mediaUpload.showcase.imageButtonCaption':
    'Tap the media button or drop hero images here.',
  'designSystem.mediaUpload.showcase.imageButtonAria': 'Add gallery image',
  'designSystem.mediaUpload.showcase.videoButtonCaption':
    'Drop or select a promo trailer to share.',
  'designSystem.mediaUpload.showcase.videoButtonAria': 'Add campaign video',
  'library.mediaUpload.trigger': '{count, plural, =0 {Upload media} other {Add more media}}',
  'library.mediaUpload.helper': 'Drag files here or browse from your device.',
  'search.publicNotice.title': 'Julkiset tiedot',
  'search.publicNotice.body': 'Kirjaudu sisään nähdäksesi kuvia, muistoja ja muuta.',
  // Header/Notifications additions
  design_system: 'Design-järjestelmä',
  settings: 'Asetukset',
  logout: 'Kirjaudu ulos',
  account_menu: 'Tilivalikko',
  guest_menu: 'Valikko',
  'guest_menu.subtitle': 'Tutustu Verkkohautaan lisää tai kirjaudu sisään jatkaaksesi.',
  more_information: 'Lisätietoa',
  accepted: 'Hyväksytty',
  rejected: 'Hylätty',
  // Groups & Group Details
  'groups.title': 'Huoneet',
  'groups.loading': 'Ladataan ryhmiä…',
  'groups.error': 'Ryhmien lataus epäonnistui',
  'groups.empty': 'Ei ryhmiä vielä.',
  'groups.createGroup': 'Luo ryhmä',
  'groups.form.name': 'Nimi',
  'groups.form.description': 'Kuvaus',
  'groups.form.category': 'Kategoria',
  'groups.form.paid': 'Maksullinen huone',
  'groups.mode.explore': 'Tutki huoneita',
  'groups.mode.mine': 'Omat huoneet',
  'groups.search': 'Hae huoneita',
  'groups.category': 'Kategoria',
  'groups.category.all': 'Kaikki kategoriat',
  'groups.create.title': 'Luo huone',
  'groups.form.desc': 'Kuvaus (valinnainen)',
  'groups.form.create': 'Luo huone',
  'groups.view': 'Näytä',
  'groups.join': 'Liity huoneeseen',
  'groups.empty.hint': 'Kokeile muuttaa suodattimia tai luo uusi huone.',
  loading: 'Loading…',
  'error.generic': 'Something went wrong.',
  'pagination.prev': 'Edellinen',
  'pagination.next': 'Seuraava',
  notifications_load_more: 'Lataa lisää',
  'groups.subtitle': 'Mistä haluaisit puhua tänään?',
  'groups.categories.label': 'Kategoriat',
  'groups.mine.filters.sub': 'Suodata huoneita roolisi mukaan.',
  'groups.mine.filter.all': 'Kaikki',
  'groups.mine.filter.led': 'Johtamasi',
  'groups.mine.filter.member': 'Jäsen',
  'groups.mine.filter.pending': 'Odottaa',
  'groups.mine.section.led': 'Huoneet joita johdat',
  'groups.mine.section.led.sub': 'Huoneet joissa olet omistaja tai admin.',
  'groups.mine.section.member': 'Huoneet joissa olet mukana',
  'groups.mine.section.member.sub': 'Huoneet joissa olet aktiivinen jäsen.',
  'groups.mine.section.pending': 'Odottavat pyynnöt',
  'groups.mine.section.pending.sub': 'Huoneet joissa pyyntösi tai kutsusi odottaa vielä.',
  'groups.mine.empty.title': 'Tässä osiossa ei vielä huoneita',
  'groups.mine.empty.hint': 'Vaihda suodatinta tai tutki huoneita joihin voit liittyä.',
  'groups.mine.empty.cta': 'Tutki huoneita',
  'groups.mine.empty.all.title': 'Et ole mukana missään huoneessa vielä',
  'groups.mine.empty.all.hint': 'Tutki huoneita tai luo oma huone aloittaaksesi.',
  'groups.mine.overview.title': 'Omat huoneesi',
  'groups.mine.overview.sub': 'Huoneet, joita johdat, joissa olet mukana tai joihin odotat pääsyä.',
  'groups.mine.load_error.title': 'Huoneitasi ei voitu ladata',
  'groups.mine.load_error.text': 'Yritä hetken kuluttua uudelleen.',
  'groups.mine.retry': 'Yritä uudelleen',
  'groups.mine.search_empty.title': 'Hakua vastaavia huoneita ei löytynyt',
  'groups.mine.search_empty.text': 'Kokeile toista huoneen nimeä tai tyhjennä haku.',
  'groups.mine.search_empty.clear': 'Tyhjennä haku',
  'groups.mine.feed.error.title': 'Viimeisintä toimintaa ei voitu ladata',
  'groups.mine.feed.error.text': 'Huoneesi ovat edelleen käytettävissä yllä.',
  'groups.sidebar.mine.title': 'Viimeisimmät huoneesi',
  'groups.sidebar.mine.sub': 'Nopea pääsy huoneisiin, joita jo seuraat.',
  'groups.category_name.local': 'Paikallinen',
  'groups.category_name.science_and_tech': 'Tiede ja teknologia',
  'groups.category_name.education': 'Koulutus',
  'groups.category_name.health': 'Terveys',
  'groups.category_name.lifestyle': 'Elämäntapa',
  'groups.category_name.travel': 'Matkailu',
  'groups.category_name.sports': 'Urheilu',
  'groups.category_name.technology': 'Teknologia',
  'groups.category_name.family': 'Perhe',
  'groups.category_name.grief_and_loss': 'Suru ja menetys',
  'groups.category_name.spirituality': 'Uskonto ja usko',
  'groups.category_name.relationships': 'Suhteet',
  'groups.category_name.life_choices': 'Elämänvalinnat',
  'groups.category_name.existence': 'Olemassaolo',
  'groups.category_name.guidance': 'Ohjaus',
  'groups.create.cta': 'Luo huone',
  'groups.empty.title': 'Huoneita ei löytynyt',
  'groups.empty.hint': 'Hakua vastaavia huoneita ei ole juuri nyt.',
  'groups.empty.initial.title': 'Avoimia huoneita ei vielä ole',
  'groups.empty.initial.hint':
    'Luo ensimmäinen huone ja kutsu ihmisiä merkitykselliseen keskusteluun.',
  'groups.empty.clear': 'Tyhjennä haku ja suodattimet',
  'groups.card.view': 'Avaa',
  'groups.card.owner': 'Huoneen ylläpitäjä',
  'groups.card.owner.you': 'Sinä',
  'create_group.title': 'Luo huone',
  'create_group.name': 'Mikä tilan nimi on?',
  'create_group.desc': 'Mitä toivot tämän tilan kannattelevan?',
  'create_group.category': 'Valitse suunta',
  'create_group.paid': 'Maksullinen jäsenyys',
  'create_group.free': 'Ilmainen',
  'create_group.submit': 'Luo',
  'create_group.cancel': 'Peruuta',
  'create_group.cover.label': 'Huonekuva (valinnainen)',
  'create_group.cover.preview_alt': 'Huonekuvan esikatselu',
  'create_group.cover.empty': 'Huonekuvaa ei ole vielä valittu.',
  'create_group.cover.choose': 'Valitse huonekuva',
  'create_group.cover.adjust_crop': 'Säädä rajausta',
  'create_group.cover.remove': 'Poista',
  'create_group.cover.hint':
    'Kuva lisätään, kun huone luodaan, ja sitä voi muuttaa myöhemmin Asetuksissa.',
  'create_group.cover.upload_error': 'Huonekuvan lataus epäonnistui. Voit lisätä sen Asetuksissa.',
  'create_group.cover.image_only': 'Valitse kuvatiedosto.',
  'groups.settings.cover.crop': 'Muokkaa huonekuvaa',
  'groups.settings.cover.safe_area': 'Pidä tärkeät yksityiskohdat katkoviivan sisällä.',
  crop_zoom: 'Zoomaus',
  'gravesHub.title': 'Läheisesi',
  'gravesHub.hero.eyebrow': 'Pysytään lähellä',
  'gravesHub.hero.title': 'Ihmiset joista pidän huolta',
  'gravesHub.hero.subtitle':
    'Kaikki niistä, joita seuraat, löytyy täältä—päivitykset, päivämäärät ja ketkä ovat mukana.',
  'gravesHub.hero.graveCount':
    'Seuraat tällä hetkellä {count, plural, one {# henkilöä} other {# henkilöä}} Verkkohaudassa.',
  'gravesHub.hero.cta': 'Lisää uusi',
  'gravesHub.hero.secondary': 'Näytä kutsut',
  'gravesHub.myGraves': 'Omat haudat',
  'gravesHub.myGraves.count': '{count}',
  'gravesHub.create': 'Lisää henkilö',
  'gravesHub.myGraves.empty': 'Ei ketään vielä. Lisää joku tai hyväksy kutsu aloittaaksesi.',
  'gravesHub.myGraves.emptyAction': 'Lisää uusi',
  'gravesHub.myGraves.viewInvites': 'Hyväksy kutsu',
  'gravesHub.guest':
    'Täältä löydät haudat, joihin kuulut. Paikka läheisyydelle, läsnäololle ja huolenpidolle ajan myötä. Kirjaudu sisään päästäksesi alkuun.',
  'gravesHub.guest_preview.name_1': 'Lorense Hansen',
  'gravesHub.guest_preview.role_1': 'Isoäiti',
  'gravesHub.guest_preview.name_2': 'Oskar Johansen',
  'gravesHub.guest_preview.role_2': 'Isä',
  'gravesHub.guest_preview.name_3': 'Anna Solberg',
  'gravesHub.guest_preview.role_3': 'Perheystävä',
  'gravesHub.guest_preview.place': 'Vestre gravlund, Oslo',
  'gravesHub.guest_preview.selected_copy':
    'Paikka nähdä haudat, joihin olet yhteydessä, avata muistopaikan sivu ja kutsua mukaan muutkin, jotka ovat yhteydessä hautaan.',
  'gravesHub.guest_preview.visit': 'Avaa muistopaikka',
  'gravesHub.guest_preview.invite': 'Kutsu perhe',
  'gravesHub.guest_preview.update_author_1': 'Maren jakoi julkaisun',
  'gravesHub.guest_preview.update_time_1': '2 tuntia sitten',
  'gravesHub.guest_preview.update_body_1':
    'Maren on kiitollinen Lorense Hansenista. Merkki läsnäolosta, ilman että tarvitaan paljon sanoja.',
  'gravesHub.guest_preview.update_author_2': 'Isak jakoi julkaisun',
  'gravesHub.guest_preview.update_time_2': 'Eilen',
  'gravesHub.guest_preview.update_body_2':
    'Isak kaipaa Lorense Hansenia. Läheisten julkaisut, kuvat ja linkit näkyvät täällä.',
  'gravesHub.loading.graves': 'Kootaan ihmisiä joista pidät huolta...',
  'gravesHub.loading.error': 'Emme voineet hakea ihmisiäsi juuri nyt. Päivitä ja yritä uudelleen.',
  'gravesHub.loading.completed': 'Synkronoitu {seconds}s',
  'gravesHub.feed.title': 'Hautaseinä',
  'gravesHub.invite': 'Kutsu perhe mukaan huolehtimaan haudasta',
  'gravesHub.selected.copy': 'Seuraa mitä tapahtuu ja ota mukaan muita, joihin luotat.',
  'gravesHub.memory.photoOnly': 'Lisäsi kuvan haudalle',
  'gravesHub.memory.view': 'Lue muisto',
  'gravesHub.memory.empty': 'Ei vielä päivityksiä—jaa ajatus, jotta kaikki tietävät käyneesi.',
  'gravesHub.memory.loadMore': 'Näytä lisää päivityksiä',
  'gravesHub.visitNamed': 'Vieraile {name}n haudalla',
  'gravesHub.visitFallback': 'Vieraile haudalla',
  'gravesHub.feed.noSelection': 'Valitse henkilö ollaksesi läsnä.',
  'gravesHub.feed.empty': 'Täällä on toistaiseksi hiljaista.',
  'gravesHub.invitations.shortcut':
    '{count, plural, one {# kutsu odottaa} other {# kutsua odottaa}}',
  'gravesHub.invitations.title': 'Yhteisen huolenpidon kutsut',
  'gravesHub.invitations.manage': 'Hallitse',
  'gravesHub.invitations.invitedBy': 'Haluaa huolehtia tästä haudasta kanssasi',
  'gravesHub.invitations.accept': 'Hyväksy',
  'gravesHub.invitations.decline': 'Hylkää',
  'gravesHub.invitations.acceptSuccess': 'Kutsu hyväksyttiin',
  'gravesHub.invitations.declineSuccess': 'Kutsu hylättiin',
  'gravesHub.invitations.actionError': 'Jotain meni vikaan. Yritä uudelleen.',
  'gravesHub.gettingStarted.title': 'Tänään',
  'gravesHub.gettingStarted.reminders': 'Sähköpostimuistutukset',
  'gravesHub.gettingStarted.remindersHint':
    'Saat lempeän ilmoituksen ennen tärkeitä päiviä tai uusia päivityksiä.',
  'gravesHub.starter.anniversaries.title': 'Merkkipäivät',
  'gravesHub.starter.anniversaries.body':
    'Lisää päivämääriä, jotka auttavat perhettä muistamaan yhdessä.',
  'gravesHub.starter.anniversaries.action': 'Lisää päivämäärä',
  'gravesHub.starter.memory.title': 'Kuvat',
  'gravesHub.starter.memory.body': 'Lisää kuvia, jotka perhe haluaa säilyttää yhdessä.',
  'gravesHub.starter.memory.action': 'Lisää kuvia',
  'gravesHub.shortcuts.title': 'Pikavalinnat',
  'gravesHub.shortcuts.invite': 'Kutsu perhe auttamaan',
  'gravesHub.shortcuts.invite.copy':
    'Jaa käyttöoikeus, jotta perhe voi lisätä muistoja, kuvia ja yhteyksiä.',
  'gravesHub.shortcuts.email': 'Sähköpostiasetukset',
  'gravesHub.shortcuts.email.copy': 'Hienosäädä muistutuksia ja ilmoituksia.',
  'gravesHub.shortcuts.open': 'Avaa hauta',
  'gravesHub.shortcuts.open.copy':
    'Avaa koko hautasivu tarinoita, kuvia ja yhteistä huolenpitoa varten.',
  'gravesHub.tips.title': 'Pidä yhteyttä',
  'home.actions.title': 'Verkkohauta: Pysyvä koti elämällemme.',
  'home.actions.subtitle': 'Verkosto totuuden ja yhteyden puolesta, jota ohjaa kestävä merkitys.',
  'home.actions.create.title': 'Luo Verkkohauta',
  'home.actions.create.body':
    'Kokoa perhe ja luokaa pysyvä Verkkohauta – täysin maksutta. Jaa sanoja, kuvia ja kynttilöitä ja vaalikaa tarinaa yhdessä missä päin maailmaa tahansa.',
  'home.actions.create.cta': 'Aloita Verkkohauta',
  'home.actions.find.title': 'Löydä hauta',
  'home.actions.find.body':
    'Löydä kaipaamasi. Näe vahvistetut muistot ja saa ilmoitukset tärkeistä päivistä.',
  'home.actions.find.cta': 'Hae hautoja',
  'home.actions.invite.title': 'Kutsu avustajia',
  'home.actions.invite.body':
    'Kutsu avustajia. Jaa käyttöoikeus läheisillesi, jotta voitte rakentaa elämäntarinan yhdessä ja pitää muiston elossa.',
  'home.actions.invite.cta': 'Lähetä kutsuja',
  'home.actions.spark.title': 'Sytytä Kipinäsi',
  'home.actions.spark.body':
    'Jaa se, mikä on sinulle tärkeää nyt. Kipinäsi on tila ajatuksillesi ja sisäisille totuuksillesi. Jaa valosi maailmalle ja herätä muissa pohdintaa.',
  'home.actions.spark.cta': 'Luo Kipinä',
  'gravesHub.tips.applyFrame.title': 'Tee sivusta henkilökohtainen',
  'gravesHub.tips.applyFrame.body':
    'Sinulla on kehykset valmiina. Haluatko lisätä sellaisen, joka sopii {hasName, select, yes {{firstName}} other {dem}}?',
  'gravesHub.tips.applyFrame.cta': 'Käytä kehystä',
  'gravesHub.tips.invite.title': 'Ota mukaan luotettavia läheisiä',
  'gravesHub.tips.invite.body':
    'Jaa vastuu ja pääsy, jotta tarinat ja huolenpito kannetaan yhdessä.',
  'gravesHub.tips.invite.cta': 'Lähetä kutsu',
  'gravesHub.tips.reminders.title': 'Muistutus sähköpostitse',
  'gravesHub.tips.reminders.body': 'Saat muistutuksen sähköpostitse ennen tärkeitä tapahtumia.',
  'gravesHub.tips.info.title': 'Rakenna tasainen hoidon rytmi',
  'gravesHub.tips.info.body':
    'Käytä muistutuksia, päivityksiä ja jaettua pääsyä, jotta huolenpito pysyy tasaisena ajan mittaan.',
  'gravesHub.store.title': 'Pienet teot, suuri merkitys',
  'gravesHub.store.description':
    'Tutustu End Of Time Collection – valoihin ja ympyröihin, jotka tuovat läsnäolon takaisin.',
  'gravesHub.store.candle.title': 'Sytytä kynttilä',
  'gravesHub.store.candle.body': 'Hiljainen rakkauden teko.',
  'gravesHub.store.candle.cta': 'Pidä liekki elossa',
  'gravesHub.store.frame.title': 'Valitse ympyrä',
  'gravesHub.store.frame.body': 'Löydä yhteyttänne kuvaava.',
  'gravesHub.store.frame.cta': 'Valitse ympyrä',
  'gravesHub.store.tree.title': 'Istuta puu',
  'gravesHub.store.tree.body':
    'Istuta elävä kunnianosoitus heidän nimissään kumppaneidemme kautta.',
  'gravesHub.store.tree.cta': 'Istuta puu',
  'gravesHub.notifications.updated': 'Muistutusasetukset päivitetty',
  'gravesHub.notifications.error': 'Emme voineet päivittää muistutusasetuksiasi. Yritä uudelleen.',
  'gravesHub.notifications.noSelection': 'Valitse henkilö jatkaaksesi.',
  'gravesHub.sidePanel.title': 'Tuki ja opastus',
  'gravesHub.sidePanel.empty': 'Valitse henkilö nähdäksesi vinkkejä ja työkaluja sivun ylläpitoon.',
  // Oston jälkeen – käytä kehystä
  'postPurchase.applyFrame.title': 'Käytä uutta ostostasi nyt?',
  'postPurchase.applyFrame.body': 'Voit lisätä juuri ostamasi tuotteen haudalle heti.',
  'postPurchase.applyFrame.select': 'Valitse henkilö',
  'postPurchase.applyFrame.apply': 'Käytä tälle sivulle',
  'postPurchase.applyFrame.inventory': 'Siirry kokoelmaani',
  'postPurchase.applyFrame.skip': 'Ohita nyt',
  // Varasto pikalinkki
  'inventory.applyFrame': 'Käytä sitä nyt',
  'inventory.applyFrame.select': 'Valitse henkilö',
  'inventory.applyFrame.open': 'Avaa sivu',
  'inventory.apply.select': 'Valitse henkilö',
  'inventory.apply.button.frame': 'Käytä ympyrää nyt',
  'inventory.apply.button.candle': 'Sytytä kynttilä nyt',
  'inventory.apply.button.default': 'Käytä tätä nyt',
  'inventory.apply.title.frame': 'Kenelle annat tämän ympyrän?',
  'inventory.apply.title.candle': 'Ketä varten sytytät kynttilän?',
  'inventory.apply.title.default': 'Käytä ostostasi heti',
  'inventory.apply.link.store': 'Etsi uusi kynttilä kaupasta',
  'inventory.buyMore.frame': 'Löydä uusi ympyrä',
  'inventory.buyMore.candle': 'Etsi uusi kynttilä',
  'inventory.buyMore.default': 'Löydä jotain uutta',
  grave_candles_light_now: 'Sytytä kynttilä {name}lle',
  grave_candles_browse_store: 'Etsi uusi kynttilä',
  cover_photo_adjust_hint: 'Säädä kuvaa kunnes se tuntuu oikealta',
  cover_photo_drag_hint: 'Vedä säätääksesi',
  cover_photo_reset: 'Palauta rajaus',
  frame_apply_success: 'Kehys otettu käyttöön',
  frame_apply_failed: 'Kehyksen käyttöönotto epäonnistui',
  remove_grave_frame: 'Poista profiilikehys',
  frame_remove_success: 'Kehys poistettu',
  frame_remove_failed: 'Kehyksen poistaminen epäonnistui',
  'create_group.invite.title': 'Invite friends (optional)',
  'create_group.invite.placeholder_name': 'Enter name or email',
  'create_group.invite.placeholder_msg': 'Write message',
  loading: 'Loading…',
  'per_page.label': 'Per page',
  'notifications.group_invite.eyebrow': 'Ryhmäkutsu',
  'notifications.group_invite.title': '{inviterName} kutsui sinut ryhmään {groupName}',
  'notifications.group_invite.body': 'Hyväksy kutsu liittyäksesi ryhmäkeskusteluun.',
  'notifications.group_invite.accepted': 'Ryhmäkutsu hyväksytty.',
  'notifications.group_invite.declined': 'Ryhmäkutsu hylätty.',
  'notifications.group_invite.action_error': 'Ryhmäkutsua ei voitu päivittää.',
  'notifications.group_join_request.eyebrow': 'Ryhmään liittymispyyntö',
  'notifications.group_join_request.title': '{requesterName} pyysi liittymistä ryhmään {groupName}',
  'notifications.group_join_request.accepted': 'Ryhmään liittymispyyntö hyväksyttiin.',
  'notifications.group_join_request.declined': 'Ryhmään liittymispyyntö hylättiin.',
  'notifications.group_join_request.action_error': 'Ryhmään liittymispyyntöä ei voitu päivittää.',
  'groups.accept.working': 'Accepting your invitation…',
  'groups.accept.ok': 'You’ve joined the group.',
  'groups.accept.view': 'Go to group',
  'groups.accept.fail': 'Invite is invalid or expired.',
  'groups.accept.back': 'Back to groups',
  'groups.accept.title': 'Ryhmäkutsu',
  'groups.accept.loading': 'Ladataan kutsua...',
  'groups.accept.auth_required': 'Kirjaudu sisään tai luo tili nähdäksesi ryhmäkutsun.',
  'groups.accept.member_count': '{count, plural, one {# jäsen} other {# jäsentä}}',
  'groups.accept.invite_label': 'Ryhmäkutsu',
  'groups.members.label': 'Mukana olevat: {count}',
  'groups.confirm.delete': 'Delete this group?',
  'groupDetails.loading': 'Loading group…',
  'groupDetails.error': 'Error loading group',
  'groupDetails.edit': 'Muokkaa huonetta',
  'groupDetails.form.name': 'Name',
  'groupDetails.form.description': 'Description',
  'groupDetails.form.category': 'Category',
  'groupDetails.addMember.title': 'Kutsu huoneeseen',
  'groupDetails.addMember.searchLabel': 'Kutsu henkilö (hae nimellä)',
  'groupDetails.addMember.placeholder': 'Search users…',
  'groupDetails.addMember.selected': 'Selected',
  'groupDetails.addMember.selectedId': 'Selected user ID:',
  'groupDetails.addMember.role': 'Role',
  'groupDetails.addMember.status': 'Status',
  'groupDetails.addMember.submit': 'Kutsu',
  'groupDetails.addMember.loadMore': 'Load more',
  'groupDetails.members.title': 'Members',
  'groupDetails.members.empty': 'No members yet.',
  'groupDetails.members.table.id': 'ID',
  'groupDetails.members.table.user': 'User',
  'groupDetails.members.table.role': 'Role',
  'groupDetails.members.table.status': 'Status',
  'groupDetails.members.table.actions': 'Actions',
  'groupDetails.members.remove': 'Remove',
  'groupDetails.confirm.remove': 'Remove member?',
  'groupDetails.categoryPrefix': 'Category: {name}',
  'groupDetails.fallbackTitle': 'Group #{id}',
  create_grave_validation_full_date_required: 'Valitse vuosi, kuukausi ja päivä',
  create_grave_date_help: 'Valitse vuosi, sitten kuukausi ja päivä',
  // Groups UI (new components)
  'groups.banner.members': '{count, number} jäsentä · {posts, number} julkaisua/päivä',
  'groups.composer.helper': 'Jaa huoneessa muutama sana, kuva tai video.',
  'groups.section.about.title': 'Tietoja huoneesta',
  'groups.section.about.text': 'Katso kuvaus, säännöt ja huoneen ylläpitäjä.',
  'groups.section.members.title': 'Huoneen ihmiset',
  'groups.section.members.text': 'Katso jäsenet ja kutsu lisää ihmisiä tarvittaessa.',
  'groups.section.files.title': 'Kuvat, videot ja asiakirjat',
  'groups.section.files.text': 'Kaikki huoneessa jaettu sisältö yhdessä paikassa.',
  'groups.section.requests.title': 'Odottavat pyynnöt',
  'groups.section.requests.text': 'Tarkista jäsen- ja julkaisupyynnöt täällä.',
  'groups.section.settings.title': 'Huoneen asetukset',
  'groups.section.settings.text': 'Muuta näkyvyyttä, sääntöjä ja huoneen toimintaa.',
  'groups.tabs.mobile_nav': 'Huoneen osio',
  phone_number: 'Puhelinnumero',
  'groups.banner.members_only': '{count, number} jäsentä',
  'groups.banner.default_subtitle': 'Huone rauhallisille keskusteluille.',
  'groups.banner.held_by': '{name} pitää tätä tilaa',
  'groups.tabs.about': 'Tietoja',
  'groups.tabs.members': 'Mukana olevat',
  'groups.tabs.files': 'Tiedostot',
  'groups.tabs.requests': 'Pyynnöt',
  'groups.tabs.settings': 'Asetukset',
  'groups.invite.sent': 'Kutsu lähetetty.',
  'groups.composer.placeholder': 'Jaa jotain tilassa…',
  'groups.preview.author': 'Huoneen ylläpitäjä',
  'groups.preview.just_now': 'juuri nyt',
  'groups.invite.title': 'Kutsu jäseniä',
  'groups.invite.subtitle': 'Kutsu ystäviä tähän yhteisöön',
  'groups.cta.invite': 'Kutsu',
  'groups.cta.post': 'Jaa',
  'groups.see_comments': 'Näytä keskustelu',
  'groups.banner.join': 'Liity',
  'groups.banner.request_join': 'Pyydä liittymistä',
  'groups.banner.joined': 'Jäsen',
  'groups.files.empty': 'Ei tiedostoja vielä.',
  'groups.join.unavailable': 'Liittyminen vaatii kutsun tai omistajan hyväksynnän.',
  'groups.join.success': 'Liityit huoneeseen.',
  'groups.join.toPost': 'Liity tilaan jakaaksesi.',
  'groups.leave': 'Poistu tilasta',
  'groups.leave.confirm': 'Poistua tästä ryhmästä?',
  'groups.leave.success': 'Poistuit tilasta.',
  'groups.leave.unavailable': 'Ryhmän jättäminen epäonnistui.',
  'groups.comments.create_error': 'Vastauksen jakaminen epäonnistui.',
  'groups.comments.update_error': 'Vastauksen päivittäminen epäonnistui.',
  'groups.comments.delete_error': 'Vastauksen poistaminen epäonnistui.',
  'groups.comments.delete.confirm': 'Poistetaanko vastaus?',
  'groups.comments.delete.title': 'Poista vastaus',
  'groups.comments.delete.body': 'Vastaus poistetaan keskustelusta. Tätä ei voi kumota.',
  'groups.comments.placeholder': 'Kirjoita vastaus...',
  'groups.comments.empty': 'Ei vastauksia vielä.',
  'groups.comments.post': 'Jaa',
  'groups.hide_comments': 'Piilota keskustelu',
  'groups.post.pending': 'Jaetaan...',
  'groups.post.awaiting_approval': 'Odottaa hyväksyntää',
  'groups.post.create_error': 'Julkaisun lähettäminen epäonnistui. Yritä uudelleen.',
  'groups.post.update_error': 'Julkaisun päivittäminen epäonnistui.',
  'groups.post.delete.confirm': 'Poistetaanko julkaisu?',
  'groups.post.delete_error': 'Julkaisun poistaminen epäonnistui.',
  'groups.post.delete.title': 'Poista julkaisu',
  'groups.post.delete.body': 'Julkaisu ja sen vastaukset poistetaan tilasta. Tätä ei voi kumota.',
  'groups.post.share': 'Jaa',
  'groups.post.share_success': 'Julkaisun linkki kopioitiin.',
  'groups.post.share_error': 'Julkaisun jakaminen epäonnistui.',
  'groups.day.today': 'Tänään',
  'groups.day.yesterday': 'Eilen',
  'groups.day.unknown': 'Aiemmin',
  'nav.sparks': 'Luo Kipinä',
  'nav.my_family': 'Sukupuu',
  'nav.home': 'Etusivu',
  'nav.groups': 'Huoneet',
  'rooms.navigation.unread_label':
    'Huoneet, {count, plural, one {# lukematon viesti} other {# lukematonta viestiä}}',
  'rooms.mine.navigation.unread_label':
    'Omat huoneet, {count, plural, one {# lukematon viesti} other {# lukematonta viestiä}}',
  'rooms.inbox.muted': 'Ilmoitukset mykistetty',
  'rooms.inbox.room_unread_label':
    '{count, plural, one {# lukematon viesti} other {# lukematonta viestiä}}',
  'nav.familyTree': 'Sukupuu',
  'nav.graves': 'Omat haudat',
  'nav.store': 'Läsnäolo',
  'nav.primary': 'Päänavigointi',
  'nav.mobile_graves': 'Haudat',
  'header.openMessages': 'Avaa viestit',
  'messenger.searchPlaceholder': 'Hae keskusteluja',
  'messenger.newConversation': 'Uusi keskustelu',
  'messenger.loading': 'Ladataan keskusteluja…',
  'messenger.error': 'Keskusteluja ei voitu ladata.',
  'messenger.emptyState': 'Ei keskusteluja vielä. Aloita keskustelu pysyäksesi yhteydessä.',
  'messenger.selectThread': 'Valitse keskustelu nähdäksesi viestit.',
  'messenger.emptyMessages': 'Ei viestejä vielä. Sano hei aloittaaksesi keskustelun.',
  'messenger.attach': 'Liitä tiedosto',
  'messenger.emoji': 'Lisää emoji',
  'messenger.send': 'Lähetä',
  'messenger.call': 'Aloita puhelu',
  'messenger.typing': 'Kirjoittaa…',
  'messenger.online': 'Paikalla',
  'messenger.status.online': 'Paikalla',
  'messenger.status.offline': 'Poissa',
  'messenger.status.lastSeen': 'Viimeksi paikalla {time}',
  'messenger.status.group': 'Ryhmäkeskustelu',
  'messenger.status.groupCount': '{online} / {total} paikalla',
  'messenger.loadingContacts': 'Ladataan kontakteja…',
  'messenger.errorContacts': 'Yhteystietoja ei voitu ladata.',
  'messenger.noContacts':
    'Yhtään suhdetta ei vielä löytynyt. Lisää suhteita aloittaaksesi keskustelun.',
  'messenger.conversations': 'Keskustelut',
  'messenger.status.live': 'Live',
  'messenger.status.reconnecting': 'Yhdistetään uudelleen…',
  'messenger.status.connecting': 'Yhdistetään…',
  'messenger.loadOlder': 'Lataa vanhemmat viestit',
  'messenger.decryptionFailed': 'Viestin salauksen purku epäonnistui.',
  'messenger.encryptedPlaceholder': '🔒 Salattu viesti odottaa synkronointia…',
  'messenger.mls.syncingEncryption': 'Synkronoidaan salausta… (yritetään uudelleen)',
  'messenger.mls.pendingSync': 'Synkronoidaan salattuja viestejä…',
  'messenger.mls.notEnabled': 'Tämä keskustelu ei tue MLS:ää. Aloita uusi salattu keskustelu.',
  'messages.title': 'Messages',
  'messages.search': 'Search conversations',
  'messages.new.title': 'Start a conversation',
  'messages.new.recipient': 'Recipient ID',
  'messages.new.subject': 'Subject (optional)',
  'messages.new.start': 'Start',
  'messages.empty': 'No conversations yet',
  'messages.empty.hint': 'Start one from the form on the left.',
  'messages.list.unread': 'Unread',
  'messages.list.open': 'Open',
  'messages.thread.title': 'Conversation',
  'messages.thread.loading': 'Loading messages…',
  'messages.thread.error': 'Could not load messages.',
  'messages.thread.placeholder': 'Write a message…',
  'messages.thread.send': 'Send',
  'pagination.prev': 'Edellinen',
  'pagination.next': 'Seuraava',
  'error.generic': 'Something went wrong.',
  'sparks.weeklyQuestion.title': 'Viikon kysymys',
  'sparks.weeklyQuestion.body':
    'Mikä auttaa sinua tuntemaan olosi lähimmäksi niitä, jotka olet menettänyt?',
  'sparks.weeklyQuestion.answerCta': 'Luo Säde',
  'sparks.composer.open': 'Luo Kipinä',
  'sparks.topics.title': 'Aiheet',
  'sparks.topics.empty': 'Ei aiheita vielä.',
  'sparks.highlights.title': 'Kohokohdat',
  'sparks.highlights.empty': 'Ei kohokohtia vielä.',
  'sparks.feed.empty': 'Ei kipinöitä vielä.',
  'sparks.filters.title': 'Suodattimet',
  'sparks.filters.newest': 'Uusimmat',
  'sparks.filters.mostActive': 'Aktiivisimmat',
  'sparks.filters.stars': 'Tähdet',
  'sparks.filters.open': 'Suodattimet ja aiheet',
  'sparks.quote.title': 'Ajatus tälle päivälle',
  'sparks.quote.loading': 'Etsitään päivän ajatusta…',
  'sparks.quote.empty':
    'Entä jos elämässä on kyse siitä, että tekee maailmasta hieman paremman jollekulle?',
  'sparks.suggestions.title': 'Ehdotukset',
  'sparks.suggestions.empty': 'Ei ehdotuksia vielä.',
  'sparks.rooms.title': 'Huone yhteisille asioille',
  'sparks.rooms.body':
    'Tapaa ihmisiä, jotka tunnistavat sinulle merkitykselliset asiat. Jaa kokemuksia, löydä tukea ja tutki yhdessä teille tärkeitä aiheita.',
  'sparks.rooms.cta': 'Tutustu Huoneisiin',
  spark_submit_error: 'Kipinän julkaiseminen epäonnistui. Yritä uudelleen.',
  media_uploaded: 'Lataus valmis',
  search_set_relation_title: 'Etsi hauta lisätäksesi suhteen',
  filter_graves: 'Suodata hautoja',
  country: 'Maa',
  municipality: 'Kunta',
  search_placeholder: 'Hae nimellä',
  clear: 'Tyhjennä',
  set_relation: 'Valitse suhteesi',
  go_to_grave: 'Siirry haudalle',
  relation_confirmed: 'Suhde vahvistettu',
  relation_waiting_for_approval: 'Suhde odottaa hyväksyntää',
  relation_modal_title: 'Aseta suhde',
  relation_modal_desc: 'Valitse molemmat puolet suhteesta. Tallennamme, kun molemmat on valittu.',
  their_relation_to_you: 'Hänen suhteensa sinuun',
  your_relation_to_them: 'Sinun suhteesi häneen',
  optional_note: 'Valinnainen viesti',
  relation_note_placeholder: 'Lisää lyhyt viesti tai muisto (valinnainen)',
  bond_saved_confirmation: 'Suhde tallennetaan: {a} ja {b}.',
  select_both_relations_hint: 'Valitse molemmat suhteet jatkaaksesi.',
  save_relation: 'Tallenna suhde',
  cancel: 'Peruuta',
  results_count_one: 'Näytetään {count} tulos',
  results_count_other: 'Näytetään {count} tulosta',
  search_grave_results_one: '{count} hauta löytyi',
  search_grave_results_other: '{count} tulosta',
  search_grave_load_more: 'Näytä lisää hautoja',
  spark_feeling_tooltip_reflecting: 'Kulje hiljaisessa pohdinnassa.',
  spark_feeling_tooltip_freedom: 'Seiso vapaudessa, avoimena ja pelottomana.',
  spark_feeling_tooltip_wonder: 'Näe ihmetyksellä, silmät avoimina ja uusina.',
  spark_feeling_tooltip_gratitude: 'Elä kiitollisuudessa, nimeä se mikä on hyvää.',
  spark_feeling_tooltip_peace: 'Lepää rauhassa, lempeä läsnäolo sydämelle.',
  spark_feeling_tooltip_hopeful: 'Liiku toivon kanssa kohti tulevaa.',
  spark_feeling_tooltip_connection: 'Ole toisten kanssa jaetussa yhteydessä.',
  spark_category_question_description: 'Kutsu muut ihmettelemään kanssasi.',
  spark_category_story_description: 'Kerro hetki sellaisena kuin se tapahtui.',
  spark_category_insight_description: 'Jaa huomioimasi totuus.',
  spark_category_feeling_description: 'Nimeä se, mikä elää sinussa nyt.',
  spark_category_intention_description: 'Jotain mitä aiot tai toivot tehdä.',
  'designSystem.timePicker.label.hour': 'Tunti',
  'designSystem.timePicker.label.minute': 'Minuutti',
  'designSystem.timePicker.label.period': 'Vuorokaudenaika',
  'designSystem.timePicker.placeholder.hour': 'Valitse tunti',
  'designSystem.timePicker.placeholder.minute': 'Valitse minuutti',
  'designSystem.timePicker.placeholder.period': 'Valitse vuorokaudenaika',
  'designSystem.timePicker.clear': 'Tyhjennä kellonaika',
  'designSystem.timePicker.period.am': 'AM',
  'designSystem.timePicker.period.pm': 'PM',
  'designSystem.select.noResults': 'Ei tuloksia',
  'designSystem.select.clear': 'Tyhjennä valinta',
  'designSystem.select.searchPlaceholder': 'Kirjoita hakeaksesi',
  aunt_in_law_parent: 'Aviotädin vanhempi',
  aunt_in_law_sibling: 'Aviotädin sisarus',
  aunt_in_law_sibling_daughter: 'Aviotädin sisaruksen tytär',
  aunt_in_law_sibling_daughter_daughter: 'Aviotädin sisaruksen tyttären tytär',
  brother_in_law_parent: 'Lankon vanhempi',
  brother_in_law_sibling: 'Lankon sisarus',
  brother_in_law_sibling_son: 'Lankon sisaruksen poika',
  brother_in_law_sibling_son_son: 'Lankon sisaruksen pojan poika',
  brother_in_law_son: 'Lankon poika',
  father_in_law_parent: 'Apen vanhempi',
  father_in_law_sibling: 'Apen sisarus',
  father_in_law_sibling_parent: 'Apen sisaruksen vanhempi',
  father_in_law_sibling_sibling: 'Apen sisaruksen sisarus',
  father_in_law_sibling_sibling_son: 'Apen sisaruksen sisaruksen poika',
  father_in_law_sibling_son: 'Apen sisaruksen poika',
  father_in_law_sibling_son_son: 'Apen sisaruksen pojan poika',
  father_in_law_son: 'Apen poika',
  father_parent_sibling_sibling: 'Isän vanhemman sisaruksen sisarus',
  father_sibling_sibling: 'Isän sisaruksen sisarus',
  father_sibling_sibling_son: 'Isän sisaruksen sisaruksen poika',
  first_cousin_once_removed_in_law: 'Serkun lapsi (avioliiton kautta)',
  grandfather_in_law: 'Puolison isoisä',
  grandmother_in_law: 'Puolison isoäiti',
  mother_in_law_daughter: 'Anopin tytär',
  mother_in_law_parent: 'Anopin vanhempi',
  mother_in_law_sibling: 'Anopin sisarus',
  mother_in_law_sibling_daughter: 'Anopin sisaruksen tytär',
  mother_in_law_sibling_daughter_daughter: 'Anopin sisaruksen tyttären tytär',
  mother_in_law_sibling_parent: 'Anopin sisaruksen vanhempi',
  mother_in_law_sibling_sibling: 'Anopin sisaruksen sisarus',
  mother_in_law_sibling_sibling_daughter: 'Anopin sisaruksen sisaruksen tytär',
  mother_parent_sibling_sibling: 'Äidin vanhemman sisaruksen sisarus',
  mother_sibling_sibling: 'Äidin sisaruksen sisarus',
  parent_spouse: 'Vanhemman puoliso',
  sister_in_law_daughter: 'Kälyn tytär',
  sister_in_law_parent: 'Kälyn vanhempi',
  sister_in_law_sibling: 'Kälyn sisarus',
  sister_in_law_sibling_daughter: 'Kälyn sisaruksen tytär',
  sister_in_law_sibling_daughter_daughter: 'Kälyn sisaruksen tyttären tytär',
  spouse_daughter: 'Puolison tytär',
  spouse_son: 'Puolison poika',
  uncle_in_law_parent: 'Aviosedän vanhempi',
  uncle_in_law_sibling: 'Aviosedän sisarus',
  uncle_in_law_sibling_son: 'Aviosedän sisaruksen poika',
  uncle_in_law_sibling_son_son: 'Aviosedän sisaruksen pojan poika',
  'home_page.brand_name': 'Verkkohauta',
  'home_page.hero_title': 'Se, mikä yhdistää meitä',
  'home_page.hero_subtitle':
    'Verkkohauta kokoaa yhteen ihmiset, arvot ja tarinat, jotka muovaavat elämää. Täällä voit vaalia merkityksellisiä asioita elämän aikana ja tulevia sukupolvia varten.',
  'home_page.cta_my_light': 'Tutustu Minun valooni',
  'home_page.cta_search_graves': 'Etsi hautoja',
  'home_page.cta_create_grave': 'Luo Verkkohauta',
  'home_page.cta_shop_frames': 'Merkipäivää varten',
  'home_page.chip_invite_family': 'Perhe',
  'home_page.chip_share_memory': 'Usko',
  'home_page.chip_light_candle': 'Toivo',
  'home_page.chip_apply_frame': 'Rakkaus',
  'home_page.hero_pick_grave': 'Valitse hauta',
  'home_page.hero_select_details': 'Valitse nähdäksesi tiedot',
  'home_page.chip_anniversary_tomorrow': 'Vuosipäivä huomenna',
  'home_page.hero_quote':
    'Hän opetti meille, että rakkaus on jotain, mitä tehdään, ei vain mitä tunnetaan.',
  'home_page.life_preview_label': 'Minun valoni',
  'home_page.life_preview_title': 'Tärkeät asiat ansaitsevat paikan',
  'home_page.life_preview_body':
    'Paikka arvoillesi, läheisillesi ja sille, mitä haluat välittää eteenpäin.',
  'home_page.life_preview_values_title': 'Se, minkä puolesta seison',
  'home_page.life_preview_values_body': 'Arvot ja sanat, jotka kertovat sinusta.',
  'home_page.life_preview_compass_title': 'Kompassini',
  'home_page.life_preview_compass_body': 'Suunta, josta haluat pitää kiinni.',
  'home_page.life_preview_people_title': 'Minun ihmiseni',
  'home_page.life_preview_people_body': 'Suhteet, jotka muovaavat elämääsi.',
  'home_page.life_preview_after_title': 'Minun jälkeeni',
  'home_page.life_preview_after_body': 'Se, mitä haluat muiden tietävän jonain päivänä.',
  'home_page.life_preview_cta': 'Katso, miten Minun valoni toimii',
  'home_page.btn_light_candle': 'Katso kynttilät',
  'home_page.btn_add_memory': 'Kirjoita muutama sana',
  'home_page.btn_apply_frame': 'Elämän ympyrät',
  'home_page.btn_invite_family': 'Kutsu perhe',
  'home_page.nearby_btn_light_candle': 'Käy haudalla',
  'home_page.nearby_btn_add_memory': 'Kirjoita muutama sana',
  'home_page.nearby_btn_apply_frame': 'Elämän ympyrät',
  'home_page.nearby_btn_invite_family': 'Lisää kuva',
  'home_page.graves_hub_title': 'Hautapaikka, joka on aina lähellä',
  'home_page.graves_hub_subtitle':
    'Verkkohauta on maksuton kaikille perheille. Vieraile hautapaikalla milloin haluat ja vaali kuvia, tarinoita ja muistoja yhdessä.',
  'home_page.people_care_for': 'Ihmiset, joista välitän',
  'home_page.people_add': '+ Lisää',
  'home_page.placeholder_name': 'Ingeborg Larsen',
  'home_page.tag_new_memory': 'Uusi muisto',
  'home_page.pick_grave': 'Valitse hauta',
  'home_page.select_to_view': 'Valitse nähdäksesi tiedot',
  'home_page.birthday_soon': 'Syntymäpäivä pian',
  'home_page.recent_updates': 'Viimeisimmät päivitykset',
  'home_page.updates_placeholder': 'Päivitykset tai muistutukset näkyvät täällä.',
  'home_page.memorial_title': 'Jokaisella on tarina.',
  'home_page.memorial_subtitle':
    'Muistoseinälle perhe ja ystävät voivat koota kuvia, sanoja ja kokemuksia. Näin useampi voi osallistua haudan edustaman ihmisen tarinaan.',
  'home_page.select_grave': 'Valitse hauta',
  'home_page.add_guardian': 'Lisää huoltaja',
  'home_page.invite_family_contribute': 'Kutsu perhe osallistumaan',
  'home_page.share_memory_prompt':
    'Jaa kuva, kirjoita muutama sana tai näytä, että olet ollut täällä.',
  'home_page.btn_share_memory': 'Kirjoita muistoseinälle',
  'home_page.from_family': 'Perheeltä',
  'home_page.family_quote':
    '”Hän piti aina kynttilät palamassa talvella, jotta talo tuntui lämpimältä tullessamme sisään.”',
  'home_page.added_days_ago': 'Lisätty 3 päivää sitten',
  'home_page.explore_memorial': 'Tutustu: {name}',
  'home_page.this_memorial': 'tähän muistoon',
  'home_page.social_title': 'Rakennettu ihmisten väliselle elämälle',
  'home_page.social_subtitle':
    'Verkkohauta kokoaa keskustelut, yhteisöt ja jakamamme asiat yhteen paikkaan. Suhteille, joita rakennamme eläessämme, ja läheisyydelle, jota vaalimme läpi elämän.',
  'home_page.social_chat_title': 'Keskusteluja, jotka pitävät ihmiset lähellä',
  'home_page.social_chat_body':
    'Kirjoita, soita tai tapaa videolla. Keskustele kahden kesken tai kokoa perhe ja ystävät yhteen ryhmään.',
  'home_page.social_chat_security':
    'Päästä päähän salattu hybridillä kvanttien jälkeisellä suojauksella.',
  'home_page.social_chat_cta': 'Avaa Chat',
  'home_page.social_rooms_title': 'Huone yhteisille asioille',
  'home_page.social_rooms_body':
    'Tapaa ihmisiä, joiden kokemukset, kiinnostuksen kohteet tai kysymykset koskettavat samoja asioita.',
  'home_page.social_rooms_cta': 'Tutustu Huoneisiin',
  'home_page.social_sparks_title': 'Luo Kipinä',
  'home_page.social_sparks_body':
    'Jaa ajatus, kokemus tai kysymys. Sinulle pieni asia voi merkitä paljon toiselle.',
  'home_page.social_sparks_cta': 'Tutustu Kipinöihin',
  'home_page.store_title': 'Jollekulle, jota ajattelet',
  'home_page.store_subtitle':
    'Verkkohaudalla kynttilät ja ympyrät voivat antaa ajatuksellesi henkilökohtaisen ilmeen.',
  'home_page.store_description':
    'Valitse kynttilä merkkipäivää varten tai ympyrä, joka kertoo jotakin ihmisestä.',
  'home_page.store_quote':
    'Verkkohauta sisältää muutakin kuin nimiä ja päivämääriä. Se voi kertoa myös ihmisestä, ihmissuhteista ja siitä, mikä on yhä merkityksellistä.',
  'home_page.store_frames': 'Elämän ympyrät',
  'home_page.store_candles': 'Kynttilät merkkipäiviin',
  'home_page.store_view': 'Näytä',
  'home_page.store_visit': 'Tutustu Läsnäoloon',
  'home_page.reminders_title': 'Merkkipäivät omalla tavallasi',
  'home_page.reminders_subtitle':
    'Verkkohauta kokoaa läheistesi merkkipäivät ja auttaa sinua olemaan läsnä silloin, kun se tuntuu oikealta.',
  'home_page.reminder_label_tomorrow': 'Huomenna',
  'home_page.reminder_title_birthday': 'Ingeborgin syntymäpäivä',
  'home_page.reminder_body_birthday': 'Hetki muistaa, omalla tavallasi.',
  'home_page.reminder_label_next_week': 'Ensi viikolla',
  'home_page.reminder_title_visit': 'Aika vierailulle',
  'home_page.reminder_body_visit': 'Kun tuntuu oikealta olla läsnä.',
  'home_page.reminder_action_visit': 'Säädä ajankohta sinulle sopivaksi',
  'home_page.reminder_label_new': 'Uusi',
  'home_page.reminder_title_memory': 'Uusi kuva Lineltä',
  'home_page.reminder_body_memory':
    'Uusi kuva on jaettu. Kun se lisätään hautaan, siitä tulee osa tarinaa, joka kestää.',
  'home_page.reminder_action_memory': 'Näytä muisto',
  'home_page.family_title': 'Kuulumme yhteen sukupolvien yli',
  'home_page.family_subtitle':
    'Näe ihmisten väliset suhteet, säilytä suvun historia ja anna seuraavalle sukupolvelle paikka löytää se.',
  'home_page.family_grandparents': 'Isovanhemmat',
  'home_page.family_linked_graves': 'Yhteydessä',
  'home_page.family_children': 'Lapset',
  'home_page.family_living': 'Elävät ja muistossa',
  'home_page.family_open': 'Katso perheyhteys',
  'home_page.family_beta': 'Beta',
  'home_page.why_title': 'Ihminen on enemmän kuin nimi haudalla',
  'home_page.why_subtitle':
    'Verkkohauta antaa muistoille, suhteille ja tarinoille paikan elää edelleen. Maksuton kaikille perheille.',
  'home_page.why_secure_title': 'Kaikille perheille',
  'home_page.why_secure_body':
    'Jokaisen tulee voida antaa menettämilleen ihmisille merkityksellinen hautapaikka taloudesta tai asuinpaikasta riippumatta.',
  'home_page.why_secure_item1': '',
  'home_page.why_secure_item2': '',
  'home_page.why_secure_item3': '',
  'home_page.why_connected_title': 'Luotu läheisyyttä varten',
  'home_page.why_connected_body':
    'Vaalikaa muistoja yhdessä, pitäkää yhteyttä ja löytäkää yhteisö silloin, kun sitä tarvitsette.',
  'home_page.why_connected_item1': '',
  'home_page.why_connected_item2': '',
  'home_page.why_connected_item3': '',
  'home_page.why_tools_title': 'Tarina säilyy',
  'home_page.why_tools_body':
    'Se, mitä kokoatte tänään, antaa tuleville sukupolville paikan löytää heitä edeltäneet ihmiset ja tarinat.',
  'home_page.why_tools_item1': '',
  'home_page.why_tools_item2': '',
  'home_page.why_tools_item3': '',
  'home_page.why_footer_quote':
    '“Työskentelemme oman merkityksettömyytemme puolesta — ja se on merkityksellisintä, mitä tiedämme tehdä.”',
  'home_page.why_footer_source':
    'End of Time Center — tutkimusta elämästä, kuolemasta ja siitä, mikä kestää',
  circle_description1:
    'Ympyrät kantavat profiilikuvaa ja antavat hiljaisen ilmaisun henkilön arvoista, persoonallisuudesta ja läsnäolosta.',
  presence_description1: 'Valitset haudan, ja kynttilä sytytetään siellä.',
  presence_description2: 'Monelle kynttilä on hyvä tapa osoittaa toivoa ja kohdata ajatuksia.',
  new_home_page_store_description:
    'Verkkohauta on <link>End of Time Care</link> käytännössä: huolenpitoa, joka ei lopu, vaan jatkuu teoissa, joita teemme toisillemme.',
  Mandag: 'Maanantai',
  Tirsdag: 'Tiistai',
  Onsdag: 'Keskiviikko',
  Torsdag: 'Torstai',
  Fredag: 'Perjantai',
  family_tree_relation_kind_blood: 'Veriside',
  family_tree_relation_kind_spouse: 'Puoliso',
  family_tree_relation_kind_in_law: 'Aviosukulainen',
  family_tree_relation_kind_step: 'Uusperhe',
  family_tree_relation_kind_other: 'Muu',
  family_tree_relation_confidence_explicit: 'Nimenomainen',
  family_tree_spouses_label: 'Puolisot',
  family_tree_sources_label: 'Lähteet',
  family_tree_no_root: 'Valitse henkilö nähdäksesi suhteet.',
  family_tree_error: 'Emme voineet ladata tätä sukupuuta. Yritä uudelleen.',
  family_tree_self_label: 'Kohdehenkilö',
  family_tree_no_self: 'Ei kohdehenkilöä',
  family_tree_group_descendants: 'Jälkeläiset',
  family_tree_group_in_laws: 'Aviosukulaiset',
  family_tree_group_empty: 'Ei vielä mitään näytettävää.',
  family_tree_meta_summary: '{count} henkilöä • säde {radius}',
  invite_coming_soon: 'Kutsut tulossa pian',
  theme_name_familie: 'Perhe',
  theme_name_skole: 'Koulu',
  theme_name_arbeid: 'Työ',
  theme_name_kjaerlighet: 'Rakkaus',
  theme_name_minne: 'Muisto',
  theme_name_natur: 'Luonto',
  theme_name_tro: 'Usko/Toivo',
  theme_name_fellesskap: 'Yhteisö',
  theme_name_annet: 'Muu',
  'groups.sidebar.quick': 'Huoneita sinulle',
  'groups.sidebar.quick.sub': 'Huoneita, jotka ovat avoinna ja käytössä.',
  'groups.categories.sub': 'Selaa kategorioita löytääksesi sopivat huoneet nopeammin.',
  'groups.section.top': 'Tutustu tiloihin',
  'groups.section.top.sub': 'Avoimet tilat, joihin voit mennä nyt.',
  'groups.section.mine.sub': 'Ryhmät, joita omistat tai joissa olet mukana.',
  'groups.section.suggested': 'Sinulle ehdotetut',
  'groups.section.suggested.sub': 'Ryhmät, jotka vastaavat hakuasi ja suodattimiasi.',
  'groups.section.new': 'Uudet ryhmät',
  'groups.section.new.sub': 'Äskettäin luodut ryhmät, joihin voit liittyä.',
  'groups.rules.placeholder': 'Yksi sääntö per rivi',
  'groups.rules.empty': 'Mukautettuja ohjeita ei ole lisätty.',
  'groups.members.creator': 'Tilavastaava',
  'groups.members.co_creators': 'Kanssavastaavat',
  'groups.members.send_message': 'Lähetä viesti',
  'groups.members.message_soon': 'Suoraviestit tiloista tulevat pian End of Time -chattiin.',
  'groups.members.make_creator': 'Tee tilavastaavaksi',
  'groups.members.remove_from_group': 'Poista tilasta',
  'groups.members.turn_on_post_approval': 'Ota julkaisujen hyväksyntä käyttöön',
  'groups.members.turn_off_post_approval': 'Poista julkaisujen hyväksyntä käytöstä',
  'groups.members.change_to_member_only': 'Vaihda vain jäseneksi',
  'groups.members.leave_group': 'Poistu tilasta',
  'groups.members.cancel_at_period_end': 'Päättyy kauden lopussa',
  'groups.members.period_end_info':
    'Kun uusinta pysaytetaan, henkilolla sailyy paasy kuluvan kauden loppuun asti.',
  'groups.members.make_creator.success': 'Tilavastaava päivitetty.',
  'groups.members.action_error': 'Jäsenen päivitys epäonnistui.',
  'groups.files.photos': 'Kuvat',
  'groups.files.videos': 'Videot',
  'groups.files.documents': 'Dokumentit',
  'groups.files.upload_photo': 'Lataa kuva',
  'groups.files.upload_video': 'Lataa video',
  'groups.files.upload_document': 'Lataa dokumentti',
  'groups.files.upload_success': 'Tiedosto ladattu.',
  'groups.files.upload_error': 'Tiedoston lataus epäonnistui.',
  'groups.files.upload_too_large': 'Tiedosto on liian suuri. Enimmäiskoko on {size}.',
  'groups.files.delete_error': 'Tiedoston poistaminen epäonnistui.',
  'groups.files.delete_success': 'Tiedosto poistettu.',
  'groups.files.type_tabs': 'Tiedostotyypit',
  'groups.files.open_photo': 'Avaa {name}',
  'groups.files.play_video': 'Toista {name}',
  'groups.files.load_error.title': 'Tiedostoja ei voitu ladata',
  'groups.files.load_error.text': 'Yritä hetken kuluttua uudelleen.',
  'groups.files.retry': 'Yritä uudelleen',
  'groups.files.delete_confirm.title': 'Poistetaanko tiedosto?',
  'groups.files.delete_confirm.text': '{name} poistetaan pysyvästi huoneesta.',
  'groups.files.loading': 'Ladataan tiedostoja...',
  'groups.files.photos.empty': 'Ei kuvia vielä.',
  'groups.files.videos.empty': 'Ei videoita vielä.',
  'groups.files.documents.empty': 'Ei dokumentteja vielä.',
  'groups.files.sort': 'Lajittele dokumentit',
  'groups.files.sort.newest': 'Uusimmat',
  'groups.files.sort.name': 'Nimi',
  'groups.files.view': 'Näytä',
  'groups.files.download': 'Lataa',
  'groups.files.details': 'Tiedot',
  'groups.files.delete': 'Poista',
  'groups.files.action.view': 'Näyttö tulossa pian.',
  'groups.files.action.download': 'Lataus tulee saataville pian.',
  'groups.files.action.details': '{name} · {size} KB',
  'groups.subscribe.saved_methods': 'Tallennetut maksutavat',
  'groups.subscribe.saved_methods.loading': 'Ladataan tallennettuja maksutapoja...',
  'groups.subscribe.saved_methods.none': 'Tallennettuja maksutapoja ei löytynyt.',
  'groups.subscribe.saved_methods.use_other': 'Käytä toista maksutapaa',
  'groups.subscribe.saved_methods.default': 'Oletus',
  'groups.subscribe.next_step.saved':
    'Seuraavaksi käytämme tallennettua maksutapaa ja jatkamme turvalliseen vahvistukseen.',
  'groups.subscribe.next_step.vipps': 'Seuraavaksi jatkat Vippsissä jäsenyyden vahvistamiseen.',
  'groups.subscribe.next_step.card': 'Seuraavaksi jatkat Stripeen jäsenyyden vahvistamiseen.',
  'groups.banner.subscribe': 'Liity tilaan',
  'groups.banner.support_with_price': 'Tue tilaa - {price} NOK / kk',
  'groups.banner.supported_badge': 'Tuettu tila',
  'groups.banner.supported_subtitle': 'Tätä tilaa kannattelevat ne, jotka päättävät tukea sitä.',
  'groups.subscribe.title': 'Liity tilaan',
  'groups.subscribe.header': 'Liity tilaan',
  'groups.subscribe.cta': 'Liity tilaan',
  'groups.subscribe.success': 'Pääsy on aktiivinen. Olet nyt mukana tilassa.',
  'groups.framework.title': 'Näin Tilat toimivat',
  'groups.framework.subtitle': 'Verkkohauta-kehys koskee kaikkia tiloja.',
  'groups.framework.principle_1.title': 'Arvokkuus',
  'groups.framework.principle_1.body':
    'Kohtaamme toisemme kunnioittavasti. Ei rankkausta. Ei hyökkäyksiä.',
  'groups.framework.principle_2.title': 'Inhimillisyys',
  'groups.framework.principle_2.body': 'Kirjoitamme ihmisinä. Emme rooleina. Emme brändeinä.',
  'groups.framework.principle_3.title': 'Hiljaisuus',
  'groups.framework.principle_3.body': 'Hiljaisuus on sallittua. Vastausta ei odoteta.',
  'groups.framework.principle_4.title': 'Vastuu',
  'groups.framework.principle_4.body':
    'Tilavastaava pitää tilan turvallisena, mutta ei omista sitä vallan välineenä.',
  'groups.suggested_members': 'Ehdotuksia siitä, kenet voit kutsua',
  'groups.paid.why.body':
    'Tilat antavat ihmisille mahdollisuuden käyttää kokemustaan ja osaamistaan muiden tukemiseen ja rakentaa kestävyyttä siihen työhön.',
  'groups.subscribe.saved_method.invalid':
    'Tallennettu maksutapa ei ole enää voimassa. Valitse toinen tapa ja yritä uudelleen.',
  'admin.group_moderation.approve': 'Hyväksyä',
  'admin.group_moderation.category.paid': 'Maksullisen huoneen hyväksyntä',
  'admin.group_moderation.category.report': 'Ilmoitettu huone',
  'admin.group_moderation.empty': '(tyhjä)',
  'admin.group_moderation.filter.all': 'Kaikki',
  'admin.group_moderation.filter.paid': 'Maksetut hyväksynnät',
  'admin.group_moderation.filter.reports': 'Raportit',
  'admin.group_moderation.filter.unread': 'Lukematon',
  'admin.group_moderation.mark_read': 'Merkitse luetuksi',
  'admin.group_moderation.mark_unread': 'Merkitse lukemattomaksi',
  'admin.group_moderation.meta.group': 'Huone',
  'admin.group_moderation.meta.reason': 'järki',
  'admin.group_moderation.meta.reporter': 'Ilmoitukset',
  'admin.group_moderation.note_placeholder':
    'Valinnainen huomautus (pakollinen hylkäyksen sattuessa).',
  'admin.group_moderation.open_group': 'Avoimet huoneet',
  'admin.group_moderation.refresh': 'Päivitä',
  'admin.group_moderation.reject': 'Hylätty',
  'admin.group_moderation.reject_note_required': 'Lisää hylkäysviesti ennen hylkäämistä.',
  'admin.group_moderation.resolution.at': 'Aika',
  'admin.group_moderation.resolution.by': 'Av',
  'admin.group_moderation.resolution.note': 'Huomautus',
  'admin.group_moderation.resolution.placeholder': 'Ratkaisuhuomautus (valinnainen).',
  'admin.group_moderation.search': 'Hae huoneen, syyn tai ilmoitusten perusteella',
  'admin.group_moderation.state.pending': 'Odotin. ',
  'admin.group_moderation.state.resolved': 'Ratkaistu',
  'admin.group_moderation.subtitle': 'Hallitse maksullisten huoneiden raportteja ja hyväksyntöjä.',
  'admin.group_moderation.summary.total': 'Yhteensä',
  'admin.group_moderation.summary.unread': 'Lukematon',
  'admin.group_moderation.summary.visible': 'Näkyvä',
  'admin.group_moderation.nav': 'Huoneen moderointi',
  'admin.group_moderation.title': 'Huoneen moderointi',
  'create_group.intro': 'Avaa tila selkeällä suunnalla.',
  'create_group.audience.label': 'Kenelle tämä tila on?',
  'create_group.audience.placeholder': 'Kuvaile, kenellä tulisi olla tässä tilassa kotoisa olo.',
  'create_group.audience.required': 'Lisää kenelle tila on tarkoitettu.',
  'create_group.safety_intent.label': 'Miten pidät tilan turvallisena?',
  'create_group.safety_intent.placeholder':
    'Kirjoita muutama rivi sävystä, rajoista ja huolenpidosta.',
  'create_group.safety_intent.hint':
    'Omaa selkeyttäsi varten, kun avaat tilan. Tätä ei näytetä julkisesti.',
  'create_group.life_category.grief': 'Suru',
  'create_group.life_category.life_choices': 'Elämänvalinnat',
  'create_group.life_category.relationships': 'Suhteet',
  'create_group.life_category.health': 'Terveys',
  'create_group.life_category.existence': 'Olemassaolo',
  'create_group.life_category.guidance': 'Ohjaus',
  'create_group.life_category.other': 'Muu',
  'create_group.invite.info': 'Kutsu joku huoneeseen',
  'create_group.invite.sent_count': '{count} kutsua lähetetty',
  'create_group.tip.name': 'Anna huoneelle selkeä nimi',
  'create_group.tip.visibility': 'Kuka voi nähdä huoneen?',
  'create_group.visibility': 'Näkyvyys',
  'create_group.visibility.closed': 'Suljettu huone',
  'create_group.visibility.closed_desc':
    'Huone on näkyvissä, mutta liittyminen vaatii kutsun tai hyväksynnän.',
  'create_group.visibility.private': 'Yksityinen huone',
  'create_group.visibility.private_desc':
    'Huone on piilotettu muilta. Vain kutsutut jäsenet voivat nähdä ja osallistua.',
  'create_group.visibility.public': 'Avoin huone',
  'groupDetails.confirm.remove.ok': 'Poista',
  'groupDetails.confirm.remove.title': 'Poista huoneesta',
  'groupDetails.unavailable': 'Ei saatavilla',
  'groups.about.empty': 'Ei kuvausta',
  'groups.aria.invite_name': 'Kutsu {name}',
  'groups.comments.load_more': 'Näytä lisää',
  'groups.edit.name_required': 'Huoneen nimi on pakollinen.',
  'groups.edit.no_changes': 'Ei muutoksia',
  'groups.edit.save_error': 'Huoneen tietojen tallentaminen epäonnistui.',
  'groups.edit.saved': 'Huoneen tiedot tallennettu.',
  'groups.invite': 'Kutsu',
  'groups.join.request_sent': 'Pyyntö lähetetty. Odotetaan hyväksyntää.',
  'groups.joined': 'Liityit huoneeseen.',
  'groups.quiet.cta': 'Aseta tila hiljaiseksi',
  'groups.quiet.active': 'Tila on hiljainen',
  'groups.quiet.confirm': 'Asetetaanko tämä tila hiljaiseksi toistaiseksi?',
  'groups.quiet.enabled': 'Tila on nyt hiljainen toistaiseksi.',
  'groups.quiet.notice': 'Tila on toistaiseksi hiljainen.',
  'groups.members': 'Ne, jotka ovat mukana',
  'groups.members.empty': 'Ei vielä jäseniä.',
  'groups.members.no_results': 'Hakua vastaavia jäseniä ei löytynyt.',
  'groups.members.actions': 'Jäsentoiminnot',
  'groups.members.owner_admin': 'Omistaja/ylläpitäjä',
  'groups.members.see_all': 'Katso kaikki',
  'groups.mine.feed.empty': 'Ei vielä keskusteluja.',
  'groups.mine.feed.sub': 'Uusimmat julkaisut huoneista, joihin kuulut.',
  'groups.mine.feed.title': 'Viimeisin toiminta',
  'groups.paid.approval.approve': 'Hyväksyä',
  'groups.paid.approval.approved': 'Maksettu huone hyväksytty.',
  'groups.paid.approval.note_placeholder':
    'Huomautus (näytetään huoneen ylläpitäjälle/ylläpitäjälle).',
  'groups.paid.approval.reject': 'Hylätty',
  'groups.paid.approval.reject_note': 'Lisää ensin hylkäysviesti.',
  'groups.paid.approval.rejected': 'Maksettu huone hylätty.',
  'groups.paid.approval.request': 'Pyydä arvostelua',
  'groups.paid.approval.requested': 'Maksetun huoneen arviointi on lähetetty.',
  'groups.paid.awaiting_approval': 'Odotetaan hyväksyntää',
  'groups.paid.connect_cta': 'Yhdistä maksuihin',
  'groups.paid.connect_hint': 'Yhdistä maksupalveluun aktivoidaksesi maksullisen tilan.',
  'groups.paid.connect_required': 'Yhdistä maksuihin ennen maksullisen tilan aktivointia.',
  'groups.paid.details.audience': 'Kohderyhmä',
  'groups.paid.details.audience.hint': 'Kenelle tämä huone on tarkoitettu?',
  'groups.paid.details.audience.placeholder':
    'Ihmisille, jotka haluavat strukturoitua tukea ja viikoittaista seurantaa.',
  'groups.paid.details.benefits': 'Edut',
  'groups.paid.details.benefits.hint': 'Mitä jäsenet saavat?',
  'groups.paid.details.benefits.placeholder':
    'Kuukausittaisia ​​live-lähetyksiä, käytännön harjoituksia, suoraa palautetta...',
  'groups.paid.details.refund': 'Palauttaa',
  'groups.paid.details.refund.hint': 'Kuvaile hyvityskäytäntöjä',
  'groups.paid.details.refund.placeholder':
    'Päättyy milloin tahansa. Käyttöoikeus on voimassa maksetun ajanjakson ajan.',
  'groups.paid.details.title': 'Maksullisen huoneen tiedot',
  'groups.paid.details_required':
    'Lisää jäsenyyden edut ja kenelle huone on tarkoitettu ennen maksullisen huoneen luomista.',
  'groups.paid.enabled_hint': 'Aseta kuukausihinnaksi {min} - {max} NOK.',
  'groups.paid.enabled_hint_currency': 'Aseta kuukausihinta välille {min}–{max} {currency}.',
  'groups.paid.onboarding_note': 'Maksetut huoneet tulevat näkyviin hyväksynnän jälkeen.',
  'groups.paid.preview.net': 'Netto til romansvarlig',
  'groups.paid.preview.platform': 'Verkkohaudan osuus',
  'groups.paid.preview.price': 'Pris',
  'groups.paid.preview.stripe': 'Stripe-gebyr',
  'groups.paid.preview.title': 'Prisoversikt',
  'groups.paid.price_range': 'Prisen må være mellom {min} og {max} NOK.',
  'groups.paid.price_range_currency': 'Hinnan tulee olla välillä {min}–{max} {currency}.',
  'groups.paid.why.cta': 'Les mer om betalte rom',
  'groups.paid.why.point_1': 'Sett en månedlig pris som passer målgruppen.',
  'groups.paid.why.point_2': 'Gi medlemmene tydelige fordeler og oppfølging.',
  'groups.paid.why.point_3': 'Få trygg betaling med Vipps eller kort.',
  'groups.paid.why.title': 'Hvorfor betalte rom?',
  'groups.payout_mode': 'Utbetalingsmodus',
  'groups.payout_mode.automatic': 'Automaattinen Stripe-palvelun kautta',
  'groups.payout_mode.automatic.hint':
    'Vaatii Stripe Connectin. Tilitykset menevät automaattisesti tilillesi.',
  'groups.payout_mode.manual': 'Manuaalinen Verkkohaudan kautta',
  'groups.payout_mode.manual.hint':
    'Et tarvitse Stripeä. Verkkohauta kerää maksut ja tilittää kuukausittain.',
  'groups.photos.recent': 'Nylige bilder',
  'groups.photos.see_all': 'Katso kaikki',
  'groups.photos.add': 'Lisää kuva',
  'groups.photos.loading': 'Ladataan kuvia...',
  'groups.photos.load_error': 'Kuvia ei voitu ladata.',
  'groups.photos.empty': 'Kuvia ei ole vielä jaettu.',
  'groups.invite.search_label': 'Etsi henkilöitä',
  'groups.invite.search_hint': 'Kirjoita vähintään kaksi merkkiä hakeaksesi.',
  'groups.invite.searching': 'Haetaan...',
  'groups.invite.no_results': 'Henkilöitä ei löytynyt.',
  'groups.post.upload_error': 'Median lataus epäonnistui. Yritä uudelleen.',
  'groups.posting': 'Julkaisut',
  'groups.report.cta': 'Raportit',
  'groups.report.details': 'Detaljer (valgfritt)',
  'groups.report.details.placeholder': 'Legg til kontekst som hjelper admin å vurdere raskt.',
  'groups.report.reason': 'järki',
  'groups.report.reason.abuse': 'Trakassering eller misbruk',
  'groups.report.reason.illegal': 'Ulovlig innhold',
  'groups.report.reason.other': 'Annet',
  'groups.report.reason.spam': 'Spam eller svindel',
  'groups.report.submit': 'Send rapport',
  'groups.report.success': 'Kiitos. Ilmoituksesi on vastaanotettu.',
  'groups.report.title': 'Rapporter rom',
  'groups.post.report': 'Ilmoita julkaisusta',
  'groups.post.report.title': 'Ilmoita julkaisusta',
  'groups.requests.action_error': 'Pyyntöä ei voitu päivittää.',
  'groups.requests.confirm': 'Hyväksy',
  'groups.requests.decline': 'Hylkää',
  'groups.requests.member_empty': 'Ei jäsenyyspyyntöjä.',
  'groups.requests.member_title': 'Jäsenyyspyynnöt',
  'groups.requests.post_empty': 'Hyväksyntää odottavia julkaisuja ei ole.',
  'groups.requests.post_title': 'Julkaisupyynnöt',
  'groups.requests.load_error.title': 'Pyyntöjä ei voitu ladata',
  'groups.requests.load_error.text': 'Yritä hetken kuluttua uudelleen.',
  'groups.requests.retry': 'Yritä uudelleen',
  'groups.requests.member.requested': 'Pyysi pääsyä {time}',
  'groups.requests.attachment': 'Avaa liite',
  'groups.requests.member.approve_success': 'Jäsenyyspyyntö hyväksyttiin.',
  'groups.requests.member.decline_success': 'Jäsenyyspyyntö hylättiin.',
  'groups.requests.post.approve_success': 'Julkaisu hyväksyttiin.',
  'groups.requests.post.decline_success': 'Julkaisu hylättiin.',
  'groups.requests.member.decline_title': 'Hylätäänkö jäsenyyspyyntö?',
  'groups.requests.post.decline_title': 'Hylätäänkö julkaisu?',
  'groups.requests.member.decline_text': 'Käyttäjän {name} pyyntö hylätään.',
  'groups.requests.post.decline_text': 'Käyttäjän {name} julkaisua ei julkaista.',
  'groups.read_more': 'Lue lisää',
  'groups.show_less': 'Näytä vähemmän',
  'groups.rules': 'Säännöt',
  'groups.settings.chat.admins': 'Vain ylläpitäjä',
  'groups.settings.chat.members': 'Jäsenet ja ylläpitäjät',
  'groups.settings.chat_permissions': 'Huonekeskustelun oikeudet',
  'groups.settings.chat.readonly_note': 'Huonekeskustelun oikeudet ovat tässä versiossa kiinteät.',
  'groups.settings.membership.admins': 'Vain huoneen ylläpitäjä ja apuylläpitäjät',
  'groups.settings.membership.anyone': 'Kaikki huoneessa',
  'groups.settings.membership_approval': 'Jäsenyyden hyväksyntä',
  'groups.settings.membership.readonly_note':
    'Jäsenyyden hyväksyntä seuraa huoneen näkyvyyttä ja kutsuprosessia.',
  'groups.settings.post_approval': 'Julkaisujen hyväksyntä',
  'groups.settings.post_approval.none': 'Ei hyväksyntää',
  'groups.settings.post_approval.require': 'Kaikki julkaisut on hyväksyttävä.',
  'groups.settings.posting.admins': 'Vain ylläpitäjä',
  'groups.settings.posting.anyone': 'Kaikki huoneessa',
  'groups.settings.posting_permissions': 'Julkaisuoikeudet',
  'groups.settings.privacy': 'Tietosuoja',
  'groups.settings.cover': 'Huonekuva',
  'groups.settings.cover.empty': 'Ei huonekuvaa vielä.',
  'groups.settings.cover.upload': 'Lataa huonekuva',
  'groups.settings.cover.remove': 'Poista huonekuva',
  'groups.settings.cover.instant_save': 'Huonekuvan muutokset tallennetaan heti.',
  'groups.settings.cover.upload_success': 'Huonekuva päivitettiin.',
  'groups.settings.cover.upload_error': 'Huonekuvan lataus epäonnistui.',
  'groups.settings.cover.remove_success': 'Huonekuva poistettiin.',
  'groups.settings.cover.remove_error': 'Huonekuvaa ei voitu poistaa.',
  'groups.settings.save_error': 'Asetuksia ei voitu tallentaa.',
  'groups.settings.saved': 'Asetukset tallennettu.',
  'groups.settings.room_status': 'Huoneen tila',
  'groups.settings.room_status.active': 'Huone on aktiivinen.',
  'groups.settings.unsaved.confirm':
    'Sinulla on tallentamattomia muutoksia. Haluatko poistua tallentamatta?',
  'groups.settings.categories.loading': 'Ladataan luokkia...',
  'groups.settings.categories.empty': 'Luokkia ei ole saatavilla.',
  'groups.settings.categories.error': 'Luokkia ei voitu ladata.',
  'groups.settings.categories.retry': 'Yritä uudelleen',
  'groups.settings.current_rules': 'Näin huone toimii',
  'groups.settings.current_rules.hint':
    'Yhteenveto huoneessa tällä hetkellä voimassa olevista säännöistä.',
  'groups.settings.membership.public': 'Kaikki voivat liittyä',
  'groups.settings.membership.closed': 'Huoneen ylläpitäjät hyväksyvät pyynnöt',
  'groups.settings.membership.private': 'Vain kutsusta',
  'groups.quiet.reactivate': 'Aktivoi huone',
  'groups.quiet.reactivate_confirm': 'Haluatko aktivoida huoneen uudelleen?',
  'groups.quiet.disabled': 'Huone on jälleen aktiivinen.',
  'groups.quiet.update_error': 'Huoneen tilaa ei voitu päivittää.',
  'groups.subscribe.benefit_1': 'Eksklusiivinen sisältö ja jatkuva tuki',
  'groups.subscribe.benefit_2': 'Turvallinen yhteisö selkeillä rajoilla',
  'groups.subscribe.benefit_3': 'Suoraa tukea vastuuhenkilöiltä ja ohjaajilta',
  'groups.subscribe.breakdown': 'Yhteenveto',
  'groups.subscribe.card': 'Kortti',
  'groups.subscribe.monthly': 'Kuukausituki',
  'create_group.paid_price_currency': 'Kuukausihinta ({currency})',
  'groups.subscribe.pending': 'Maksua viimeistellään. Päivitä hetken kuluttua.',
  'groups.subscribe.total': 'Yhteensä',
  'groups.subscribe.local_estimate': 'Noin {amount} paikallisessa valuutassa.',
  'groups.subscribe.cancel.cta': 'Lopeta osallistuminen',
  'groups.subscribe.cancel.success': 'Et ole enää mukana tilassa.',
  'groups.subscribe.vipps_info': 'Vahvistat maksun turvallisesti Vippsissä.',
  'groups.subscribe.vipps_currency_note': 'Vipps-maksu veloitetaan NOK-valuutassa.',
  'groups.subscribe.vipps_unavailable_currency':
    'Vipps ei ole käytettävissä tälle valuutalle. Valitse kortti.',
  'groups.time.2h': 'for et øyeblikk siden',
  'admin.group_moderation.approve': 'Hyväksyä',
  'messenger_v2.brand.title': 'End of Time',
  'messenger_v2.brand.beta': 'Beta',
  'messenger_v2.brand.tagline': 'Paikka totuudelle. Aina.',
  'messenger_v2.conversation.title': 'Keskustelut',
  'messenger_v2.encryption.title': 'Päästä päähän salattu',
  'messenger_v2.encryption.copy': 'Sanasi pysyvät välillänne.',
  'messenger_v2.encryption.learn_more': 'Lue lisää',
  'messenger_v2.presence.active_now': 'Aktiivinen nyt',
  'messenger_v2.composer.truth_placeholder': 'Mikä on totta juuri nyt?',
  'messenger_v2.message.reaction_failed': 'Reaktion päivittäminen epäonnistui.',
  'messenger_v2.message.actions': 'Viestitoiminnot',
  'messenger_v2.message.react_with': 'Reagoi emojilla {emoji}',
  'messenger_v2.message.reaction_count': '{emoji}, {count} reaktiota',
  'messenger_v2.message.commands': 'Viestikomennot',
  'messenger_v2.message.reactions': 'Reaktiot',
  'messenger_v2.message.reaction_all': 'Kaikki',
  'messenger_v2.message.reaction_details': 'Reaktion tiedot',
  'messenger_v2.message.reaction_filters': 'Reaktiosuodattimet',
  'messenger_v2.message.reaction_people_unavailable':
    'Tämän viestin reaktiotiedot eivät ole saatavilla.',
  'messenger_v2.message.click_to_remove': 'Poista napsauttamalla',
  'messenger_v2.message.history_loading': 'Ladataan aiempia viestejä.',
  'messenger_v2.attachment.select': 'Valitse {name}',
  'messenger_v2.search.placeholder': 'Hae tai aloita keskustelu',
  'messenger_v2.search.groups_placeholder': 'Hae ryhmiä',
  'messenger_v2.tabs.aria': 'Viestiosiot',
  'messenger_v2.tabs.direct': 'Viestit',
  'messenger_v2.tabs.groups': 'Ryhmät',
  'messenger_v2.groups.add_action': 'Lisää',
  'messenger_v2.groups.add_members': 'Lisää jäseniä',
  'messenger_v2.groups.add_members_short': 'Lisää',
  'messenger_v2.groups.add_members_title': 'Lisää jäseniä',
  'messenger_v2.groups.add_description': 'Lisää ryhmän kuvaus',
  'messenger_v2.groups.contacts_loading': 'Yhteystietoja ladataan.',
  'messenger_v2.groups.create': 'Luo ryhmä',
  'messenger_v2.groups.create_action': 'Luo',
  'messenger_v2.groups.create_category_required': 'Ryhmäkategoria ei ole vielä saatavilla.',
  'messenger_v2.groups.create_name_required': 'Ryhmän nimi vaaditaan.',
  'messenger_v2.groups.create_new_group': 'Luo uusi ryhmä',
  'messenger_v2.groups.create_success': 'Ryhmä luotu.',
  'messenger_v2.groups.create_title': 'Luo ryhmä',
  'messenger_v2.groups.description_label': 'Kuvaus',
  'messenger_v2.groups.description_placeholder': 'Valinnainen',
  'messenger_v2.groups.details_updated': 'Ryhmän tiedot päivitetty.',
  'messenger_v2.groups.edit_description': 'Muokkaa ryhmän kuvausta',
  'messenger_v2.groups.edit_group_picture': 'Muokkaa ryhmäkuvaa',
  'messenger_v2.groups.edit_name': 'Muokkaa ryhmän nimeä',
  'messenger_v2.groups.empty': 'Hakua vastaavia ryhmiä ei löytynyt.',
  'messenger_v2.groups.error': 'Ryhmiä ei voitu ladata.',
  'messenger_v2.groups.fallback': 'Ryhmä',
  'messenger_v2.groups.choose_photo': 'Valitse kuva',
  'messenger_v2.groups.delete_photo': 'Poista kuva',
  'messenger_v2.groups.deleting_photo': 'Poistetaan kuvaa...',
  'messenger_v2.groups.uploading_photo': 'Ladataan...',
  'messenger_v2.groups.avatar_crop_failed': 'Kuvaa ei voitu rajata.',
  'messenger_v2.groups.avatar_read_failed': 'Kuvaa ei voitu avata.',
  'messenger_v2.groups.avatar_owner_only': 'Vain ryhmän luoja voi päivittää ryhmäkuvan.',
  'messenger_v2.groups.avatar_updated': 'Ryhmäkuva päivitetty.',
  'messenger_v2.groups.avatar_update_failed': 'Ryhmäkuvaa ei voitu päivittää.',
  'messenger_v2.groups.avatar_deleted': 'Ryhmäkuva poistettu.',
  'messenger_v2.groups.avatar_delete_failed': 'Ryhmäkuvaa ei voitu poistaa.',
  'messenger_v2.groups.loading': 'Ryhmiä ladataan.',
  'messenger_v2.groups.members_added': 'Jäsenet lisätty.',
  'messenger_v2.groups.members_count': '{count} jäsentä',
  'messenger_v2.groups.update_failed': 'Ryhmän tietoja ei voitu päivittää.',
  'messenger_v2.groups.members_label': 'Jäsenet',
  'messenger_v2.groups.leave_group': 'Poistu',
  'messenger_v2.groups.exit_group': 'Poistu ryhmästä',
  'messenger_v2.groups.exit_group_title': 'Poistu ryhmästä: "{name}"?',
  'messenger_v2.groups.exit_group_notice': 'Vain ylläpitäjille ilmoitetaan, kun poistut ryhmästä.',
  'messenger_v2.groups.exit_and_delete_for_me': 'Poistu ja poista minulta',
  'messenger_v2.groups.delete_group': 'Poista ryhmä',
  'messenger_v2.groups.deleting_group': 'Poistetaan ryhmää...',
  'messenger_v2.groups.delete_group_title': 'Poista ryhmä "{name}"?',
  'messenger_v2.groups.delete_group_warning_body':
    'Tämä ryhmä poistetaan chat-listaltasi ja paikallinen historiasi tyhjennetään.',
  'messenger_v2.groups.group_deleted': 'Ryhmä poistettiin chat-listaltasi.',
  'messenger_v2.groups.delete_group_failed': 'Ryhmää ei voitu poistaa.',
  'messenger_v2.groups.exiting_group': 'Poistutaan ryhmästä...',
  'messenger_v2.groups.left_group': 'Poistuit ryhmästä.',
  'messenger_v2.groups.left_group_notice':
    'Poistuit tästä ryhmästä. Voit nähdä aiemmat viestit, mutta et voi lähettää uusia viestejä.',
  'messenger_v2.groups.member_removed': '{name} poistettiin ryhmästä.',
  'messenger_v2.groups.member_remove_failed': 'Jäsentä ei voitu poistaa.',
  'messenger_v2.groups.remove_member': 'Poista',
  'messenger_v2.groups.removed_notice':
    '{actor} poisti sinut tästä ryhmästä. Voit nähdä aiemmat viestit, mutta et voi lähettää uusia viestejä.',
  'messenger_v2.groups.access_removed_notice':
    'Et ole enää tämän ryhmän jäsen. Voit nähdä aiemmat viestit, mutta et voi lähettää uusia viestejä.',
  'messenger_v2.groups.removing_member': 'Poistetaan...',
  'messenger_v2.groups.name_label': 'Nimi',
  'messenger_v2.groups.name_placeholder': 'Perhepäivitykset',
  'messenger_v2.groups.no_contacts': 'Yhteystietoja ei ole saatavilla.',
  'messenger_v2.groups.no_contacts_to_add': 'Lisättäviä yhteystietoja ei ole.',
  'messenger_v2.groups.no_messages': 'Ei viestejä vielä',
  'messenger_v2.groups.save_failed': 'Ryhmää ei voitu tallentaa.',
  'messenger_v2.groups.saving': 'Tallennetaan...',
  'messenger_v2.groups.select_member_required': 'Valitse vähintään yksi jäsen.',
  'messenger_v2.groups.selected_count': '{count} valittu',
  'messenger_v2.groups.selected_fraction': '{selected}/{total}',
  'messenger_v2.groups.search_name_or_number': 'Hae nimellä tai numerolla',
  'messenger_v2.groups.members_can_add': 'Kaikki jäsenet voivat lisätä muita tähän ryhmään.',
  'messenger_v2.groups.edit_group_permissions': 'Muokkaa ryhmän oikeuksia.',
  'messenger_v2.groups.group_permissions': 'Ryhmän oikeudet',
  'messenger_v2.groups.invite_via_link': 'Kutsu linkillä',
  'messenger_v2.groups.invite_via_link_qr': 'Kutsu linkillä tai QR-koodilla',
  'messenger_v2.groups.frequently_contacted': 'Usein yhteydessä',
  'messenger_v2.groups.scroll_more_contacts': 'Vieritä ladataksesi lisää',
  'messenger_v2.groups.remove_selected_member': 'Poista {name}',
  'messenger_v2.groups.group_link': 'Ryhmän linkki',
  'messenger_v2.groups.group_chat_invite': 'Ryhmäkeskustelukutsu',
  'messenger_v2.groups.open_invite_link': 'Avaa tämä linkki liittyäksesi ryhmään {name}.',
  'messenger_v2.groups.join_group': 'Liity ryhmään',
  'messenger_v2.groups.invite_link_checking': 'Tarkistetaan linkkiä...',
  'messenger_v2.groups.invite_link_expired': 'Linkki on vanhentunut',
  'messenger_v2.groups.invite_link_unavailable': 'Ryhmä ei ole käytettävissä',
  'messenger_v2.groups.invite_link_full': 'Ryhmä on täynnä',
  'messenger_v2.groups.invite_link_status_expired': 'Tämä kutsulinkki on vanhentunut.',
  'messenger_v2.groups.invite_link_status_unavailable':
    'Tämä ryhmäkutsu ei ole enää käytettävissä.',
  'messenger_v2.groups.invite_link_status_full': 'Tämä ryhmä on täynnä.',
  'messenger_v2.groups.view_group': 'Näytä ryhmä',
  'messenger_v2.groups.invite_link_loading': 'Ladataan linkkiä...',
  'messenger_v2.groups.invite_link_copied': 'Kutsulinkki kopioitu.',
  'messenger_v2.groups.invite_link_copy_failed': 'Kutsulinkkiä ei voitu kopioida.',
  'messenger_v2.groups.invite_link_failed': 'Kutsulinkkiä ei voitu ladata.',
  'messenger_v2.groups.invite_share_text': 'Liity ryhmään {name}',
  'messenger_v2.groups.invite_share_text_with_link': 'Liity ryhmään {name}: {url}',
  'messenger_v2.groups.share_via_chat': 'Jaa chatissa',
  'messenger_v2.groups.send_to': 'Lähetä',
  'messenger_v2.groups.send_action': 'Lähetä',
  'messenger_v2.groups.select_chat_recipients': 'Valitse chatit',
  'messenger_v2.groups.invite_link_sent': 'Kutsulinkki lähetetty.',
  'messenger_v2.groups.invite_link_send_failed': 'Kutsulinkkiä ei voitu lähettää.',
  'messenger_v2.groups.share_link': 'Jaa linkki',
  'messenger_v2.groups.share_link_short': 'Jaa',
  'messenger_v2.groups.copy_link': 'Kopioi linkki',
  'messenger_v2.groups.qr_code': 'QR-koodi',
  'messenger_v2.groups.manage_permissions': 'Hallinnoi oikeuksia',
  'messenger_v2.groups.invite_approval_not_required':
    'Ylläpitäjän hyväksyntää ei tarvita liittymiseen. Jäsenillä on pääsy tähän linkkiin.',
  'messenger_v2.groups.permissions_members_can': 'Jäsenet voivat',
  'messenger_v2.groups.permission_edit_settings': 'Muokata ryhmän asetuksia',
  'messenger_v2.groups.permission_edit_settings_desc':
    'Tämä sisältää ryhmän nimen, kuvakkeen, kuvauksen ja edistyneet yksityisyysasetukset.',
  'messenger_v2.groups.permission_send_messages': 'Lähettää uusia viestejä',
  'messenger_v2.groups.permission_add_members': 'Lisätä muita jäseniä',
  'messenger_v2.groups.permission_send_history': 'Lähettää viestihistoriaa',
  'messenger_v2.groups.permission_send_history_desc':
    'Salli jäsenten lähettää aiempia viestejä uusille jäsenille.',
  'messenger_v2.groups.permission_invite_link': 'Kutsua linkillä',
  'messenger_v2.groups.permissions_turning_off_hint':
    'Kun nämä asetukset poistetaan käytöstä, vain ryhmän ylläpitäjät voivat tehdä tämän toiminnon.',
  'messenger_v2.groups.permissions_admins_can': 'Ylläpitäjät voivat',
  'messenger_v2.groups.permission_approve_new_members': 'Hyväksyä uusia jäseniä',
  'messenger_v2.groups.permission_approve_new_members_desc':
    'Kun tämä on käytössä, ylläpitäjien täytyy hyväksyä kaikki, jotka haluavat liittyä ryhmään.',
  'messenger_v2.groups.group_admins': 'Ryhmän ylläpitäjät',
  'messenger_v2.groups.edit_admins': 'Muokkaa ylläpitäjiä',
  'messenger_v2.groups.admin': 'Ylläpitäjä',
  'messenger_v2.groups.available_member': 'Saatavilla oleva jäsen',
  'messenger_v2.groups.make_group_admin': 'Tee ryhmän ylläpitäjäksi',
  'messenger_v2.groups.dismiss_as_admin': 'Poista ylläpitäjänä',
  'messenger_v2.groups.remove_from_group': 'Poista ryhmästä',
  'messenger_v2.groups.no_members_to_manage': 'Ei hallittavia jäseniä.',
  'messenger_v2.groups.admins_updated': 'Ryhmän ylläpitäjät päivitetty.',
  'messenger_v2.groups.admin_update_failed': 'Ylläpitäjäroolia ei voitu päivittää.',
  'messenger_v2.groups.member_made_admin': '{name} on nyt ryhmän ylläpitäjä.',
  'messenger_v2.groups.member_dismissed_admin': '{name} ei ole enää ryhmän ylläpitäjä.',
  'messenger_v2.groups.permissions_updated': 'Ryhmän oikeudet päivitetty.',
  'messenger_v2.groups.permissions_update_failed': 'Ryhmän oikeuksia ei voitu päivittää.',
  'messenger_v2.groups.no_longer_member_status': 'Ei enää jäsen',
  'messenger_v2.info.member_options': 'Jäsenasetukset',
  'messenger_v2.common.search': 'Hae',
  'messenger_v2.conversation.group_fallback': 'Ryhmäkeskustelu',
  'messenger_v2.conversation.direct_fallback': 'Yksityinen keskustelu',
  'messenger_v2.conversation.new_message': 'Uusi viesti',
  'messenger_v2.conversation.no_content': 'Ei sisältöä',
  'messenger_v2.conversation.connection': 'Yhteys',
  'messenger_v2.conversation.connections': 'Yhteydet',
  'messenger_v2.conversation.open': 'Avaa',
  'messenger_v2.conversation.open_failed': 'Keskustelua ei voitu avata.',
  'messenger_v2.conversation.opening': 'Avataan...',
  'messenger_v2.conversation.contacts_loading': 'Yhteystietoja ladataan.',
  'messenger_v2.conversation.no_contacts_matched': 'Haulla ei löytynyt yhteystietoja.',
  'messenger_v2.conversation.bootstrap_loading': 'Messenger käynnistyy.',
  'messenger_v2.conversation.none_yet':
    'Ei keskusteluja vielä. Aloita yksi yhteystietoluettelosta.',
  'messenger_v2.conversation.select_title': 'Valitse keskustelu',
  'messenger_v2.conversation.select_copy':
    'Avaa ketju vasemmalta tai aloita uusi keskustelu plus-painikkeella.',
  'messenger_v2.conversation.show_contacts': 'Näytä yhteystiedot',
  'messenger_v2.conversation.show_conversations': 'Näytä keskustelut',
  'messenger_v2.presence.offline': 'Poissa verkosta',
  'messenger_v2.presence.online': 'Verkossa',
  'messenger_v2.presence.ready': 'Valmis',
  'messenger_v2.presence.not_ready_yet': 'Ei vielä valmis',
  'messenger_v2.presence.group_online': '{onlineCount}/{totalCount} verkossa',
  'messenger_v2.presence.last_seen_today_at': 'Nähty viimeksi tänään klo {time}',
  'messenger_v2.presence.last_seen_yesterday_at': 'Nähty viimeksi eilen klo {time}',
  'messenger_v2.presence.last_seen_date_at': 'Nähty viimeksi {date} klo {time}',
  'messenger_v2.timeline.today': 'Tänään',
  'messenger_v2.timeline.yesterday': 'Eilen',
  'messenger_v2.message.edited': 'Muokattu',
  'messenger_v2.message.edited_time': 'Muokattu {time}',
  'messenger_v2.message.read_more': 'Lue lisää',
  'messenger_v2.message.show_less': 'Näytä vähemmän',
  'messenger_v2.message.upload_failed': 'Lähetys epäonnistui',
  'messenger_v2.message.preparing_upload': 'Valmistellaan…',
  'messenger_v2.message.upload_progress': 'Lähetetään {progress} %',
  'messenger_v2.message.upload_paused_progress': 'Lähetys keskeytetty kohdassa {progress} %',
  'messenger_v2.message.retry_upload': 'Yritä lähetystä uudelleen',
  'messenger_v2.message.retry_send': 'Yritä lähettää viesti uudelleen',
  'messenger_v2.message.retry_reaction': 'Yritä lähettää reaktio uudelleen',
  'messenger_v2.message.retry_failed': 'Viestiä ei voitu lähettää. Yritä uudelleen.',
  'messenger_v2.message.reaction_retry_failed': 'Reaktiota ei voitu lähettää. Yritä uudelleen.',
  'messenger_v2.message.pause_upload': 'Keskeytä lähetys',
  'messenger_v2.message.pause': 'Keskeytä',
  'messenger_v2.message.resume_upload': 'Jatka lähetystä',
  'messenger_v2.message.resume': 'Jatka',
  'messenger_v2.attachment.upload_paused': 'Lähetys keskeytetty: {name}',
  'messenger_v2.message.failed': 'Epäonnistui',
  'messenger_v2.message.read': 'Luettu',
  'messenger_v2.message.delivered': 'Toimitettu',
  'messenger_v2.message.sent': 'Lähetetty',
  'messenger_v2.message.delete': 'Poista viesti',
  'messenger_v2.message.delete_title': 'Poistetaanko viesti?',
  'messenger_v2.message.delete_from': 'Poistetaanko viesti henkilöltä {name}?',
  'messenger_v2.message.delete_everyone': 'Poista kaikilta',
  'messenger_v2.message.delete_me': 'Poista minulta',
  'messenger_v2.message.copy': 'Kopioi viesti',
  'messenger_v2.attachment.copy': 'Kopioi liite',
  'messenger_v2.clipboard.copied': 'Kopioitu',
  'messenger_v2.clipboard.retry': 'Yritä uudelleen',
  'messenger_v2.message.edit': 'Muokkaa viestiä',
  'messenger_v2.message.clear_selection': 'Tyhjennä valinta',
  'messenger_v2.message.open_menu': 'Avaa viestivalikko',
  'messenger_v2.message.scroll_latest': 'Siirry uusimpaan viestiin',
  'messenger_v2.message.thread_loading': 'Keskusteluhistoriaa ladataan.',
  'messenger_v2.conversation.unavailable_title': 'Keskustelu ei ole käytettävissä',
  'messenger_v2.conversation.unavailable_copy': 'Sinulla ei ole enää pääsyä tähän keskusteluun.',
  'messenger_v2.message.thread_empty': 'Tähän keskusteluun ei ole vielä ladattu viestejä.',
  'messenger_v2.message.thread': 'Keskusteluketju',
  'messenger_v2.message.timeline': 'Keskustelun viestit',
  'messenger_v2.message.encrypted_pending':
    'Salattu MLS-viesti odottaa ajonaikaisen ympäristön valmiutta.',
  'messenger_v2.message.edit_resolve_error':
    'Muokattavaa viestiä ei voitu ratkaista. Avaa muokkaustila uudelleen ja yritä taas.',
  'messenger_v2.message.reply': 'Vastaa',
  'messenger_v2.message.forward': 'Välitä',
  'messenger_v2.message.forwarded': 'Välitetty',
  'messenger_v2.forward.title': 'Välitä vastaanottajille',
  'messenger_v2.forward.preview_label': 'Välitetään',
  'messenger_v2.forward.message_preview': 'Viesti',
  'messenger_v2.forward.search': 'Hae keskusteluja ja yhteyksiä',
  'messenger_v2.forward.add_message': 'Lisää viesti',
  'messenger_v2.forward.add_message_placeholder': 'Lisää viesti...',
  'messenger_v2.forward.selected': 'Valittu',
  'messenger_v2.forward.not_selected': 'Ei valittu',
  'messenger_v2.forward.loading': 'Ladataan keskusteluja ja yhteyksiä...',
  'messenger_v2.forward.chats': 'Keskustelut',
  'messenger_v2.forward.connections': 'Yhteydet',
  'messenger_v2.forward.no_targets': 'Keskusteluja tai yhteyksiä ei löytynyt.',
  'messenger_v2.forward.loading_message': 'Ladataan viestiä...',
  'messenger_v2.forward.message_unavailable': 'Tämä viesti ei ole saatavilla.',
  'messenger_v2.forward.send_failed': 'Viestiä ei voitu välittää.',
  'messenger_v2.forward.unavailable': 'Tätä viestiä ei voi vielä välittää.',
  'messenger_v2.forward.sending_progress': 'Lähetetään {completed}/{total}',
  'messenger_v2.forward.failed_count': '{count} epäonnistui',
  'messenger_v2.forward.selected_count': '{count} valittu',
  'messenger_v2.forward.retry_failed': 'Yritä epäonnistuneita uudelleen',
  'messenger_v2.forward.sent_count': 'Välitetty {count} keskusteluun.',
  'messenger_v2.message.react': 'Reagoi',
  'messenger_v2.message.cancel_reply': 'Peruuta vastaus',
  'messenger_v2.message.open_replied_message': 'Avaa vastattu viesti',
  'messenger_v2.reply.photo': 'Kuva',
  'messenger_v2.reply.photos_count': '{count} kuvaa',
  'messenger_v2.reply.video': 'Video',
  'messenger_v2.reply.videos_count': '{count} videota',
  'messenger_v2.reply.audio': 'Ääni',
  'messenger_v2.reply.media_count': '{count} mediaa',
  'messenger_v2.reply.pages_count': '{count} sivua',
  'messenger_v2.common.cancel': 'Peruuta',
  'messenger_v2.common.back': 'Takaisin',
  'messenger_v2.common.close': 'Sulje',
  'messenger_v2.common.done': 'Valmis',
  'messenger_v2.common.save': 'Tallenna',
  'messenger_v2.common.someone': 'Joku',
  'messenger_v2.common.you': 'Sinä',
  'messenger_v2.common.messenger': 'Messenger',
  'messenger_v2.chat.back': 'Takaisin keskusteluihin',
  'messenger_v2.chat.more': 'Lisää',
  'messenger_v2.chat.more_actions': 'Lisää toimintoja',
  'messenger_v2.notifications.enabled': 'Työpöytäilmoitukset käytössä',
  'messenger_v2.notifications.enabled_message': 'Työpöytäilmoitukset ovat käytössä.',
  'messenger_v2.notifications.reaction_body': 'Reagoi emojilla {emoji} viestiisi.',
  'messenger_v2.conversation.reaction_preview': 'Reagoi {emoji} viestiin ”{message}”',
  'messenger_v2.conversation.reaction_preview_unknown': 'Reagoi {emoji} viestiin',
  'messenger_v2.notifications.reaction_body_with_preview':
    'Reagoi emojilla {emoji} viestiisi: “{message}”',
  'messenger_v2.notifications.blocked': 'Työpöytäilmoitukset estetty',
  'messenger_v2.notifications.blocked_message':
    'Työpöytäilmoitukset on estetty selaimen asetuksissa.',
  'messenger_v2.notifications.unsupported': 'Tämä selain ei tue työpöytäilmoituksia.',
  'messenger_v2.notifications.enable': 'Ota työpöytäilmoitukset käyttöön',
  'messenger_v2.typing.preview': 'Kirjoittaa...',
  'messenger_v2.typing.preview_named': '{name} kirjoittaa...',
  'messenger_v2.typing.aria': '{name} kirjoittaa',
  'messenger_v2.info.open': 'Avaa keskustelun tiedot',
  'messenger_v2.info.title': 'Keskustelun tiedot',
  'messenger_v2.info.close': 'Sulje keskustelun tiedot',
  'messenger_v2.info.contact': 'Yhteystieto',
  'messenger_v2.info.creator': 'Luoja',
  'messenger_v2.info.direct_chat': 'Suora keskustelu',
  'messenger_v2.info.message_action': 'Viesti',
  'messenger_v2.info.block': 'Estä',
  'messenger_v2.info.block_failed': 'Käyttäjää ei voitu estää.',
  'messenger_v2.info.block_user': 'Estä {name}',
  'messenger_v2.info.block_user_confirm':
    'Tämä käyttäjä ei näe avatariasi tai tilaasi, eivätkä uudet viestit tai puhelut häneltä tule sinulle.',
  'messenger_v2.info.block_user_title': 'Estetäänkö "{name}"?',
  'messenger_v2.info.blocking_user': 'Estetään...',
  'messenger_v2.info.chat_cleared': 'Keskustelu tyhjennetty.',
  'messenger_v2.info.clear_all_messages': 'Tyhjennä kaikki viestit',
  'messenger_v2.info.clear_chat': 'Tyhjennä keskustelu',
  'messenger_v2.info.clear_chat_confirm': 'Vanhat viestit poistetaan vain sinulta.',
  'messenger_v2.info.clear_chat_failed': 'Keskustelua ei voitu tyhjentää.',
  'messenger_v2.info.clear_chat_title': 'Tyhjennetäänkö keskustelu?',
  'messenger_v2.info.clear_chat_warning_body':
    'Tämä keskustelu tyhjenee, mutta säilyy keskustelulistallasi.',
  'messenger_v2.info.clear_chat_warning_title':
    'Tyhjennetäänkö kaikki viestit käyttäjältä "{name}"?',
  'messenger_v2.info.chat_deleted': 'Keskustelu poistettu.',
  'messenger_v2.info.delete_chat': 'Poista keskustelu',
  'messenger_v2.info.delete_chat_failed': 'Keskustelua ei voitu poistaa.',
  'messenger_v2.info.delete_chat_warning_body':
    'Tämä keskustelu poistetaan keskustelulistaltasi. Jos aloitat keskustelun uudelleen, vanhoja viestejä ei näytetä.',
  'messenger_v2.info.delete_chat_warning_title':
    'Poistetaanko keskustelu käyttäjän "{name}" kanssa?',
  'messenger_v2.info.clearing_chat': 'Tyhjennetään keskustelua...',
  'messenger_v2.info.info': 'Tiedot',
  'messenger_v2.info.media': 'Media',
  'messenger_v2.info.links': 'Linkit',
  'messenger_v2.info.docs': 'Dokumentit',
  'messenger_v2.info.media_links_docs': 'Media, linkit ja dokumentit',
  'messenger_v2.info.starred': 'Tähdellä merkityt',
  'messenger_v2.info.encryption': 'Salaus',
  'messenger_v2.info.members': 'Jäsenet',
  'messenger_v2.info.groups_in_common': 'Yhteiset ryhmät',
  'messenger_v2.info.no_media': 'Tässä keskustelussa ei ole vielä jaettua mediaa.',
  'messenger_v2.info.no_links': 'Tässä keskustelussa ei ole vielä jaettuja linkkejä.',
  'messenger_v2.info.no_docs': 'Tässä keskustelussa ei ole vielä jaettuja dokumentteja.',
  'messenger_v2.info.no_common_groups': 'Ei vielä yhteisiä ryhmiä.',
  'messenger_v2.info.unblock': 'Poista esto',
  'messenger_v2.info.unblock_failed': 'Estoa ei voitu poistaa.',
  'messenger_v2.info.unblock_user': 'Poista esto: {name}',
  'messenger_v2.info.unblock_user_confirm': 'Tämä käyttäjä voi ottaa sinuun taas yhteyttä.',
  'messenger_v2.info.unblock_user_title': 'Poistetaanko esto käyttäjältä "{name}"?',
  'messenger_v2.info.unblocking_user': 'Poistetaan estoa...',
  'messenger_v2.info.user_blocked': '{name} estetty.',
  'messenger_v2.info.user_unblocked': '{name} ei ole enää estetty.',
  'messenger_v2.info.no_members': 'Ei vielä näytettäviä jäseniä.',
  'messenger_v2.info.pending_invitations': 'Kutsutut - odottaa vastausta',
  'messenger_v2.info.invitation_pending': 'Kutsu odottaa vastausta',
  'messenger_v2.info.document_fallback': 'Dokumentti',
  'messenger_v2.info.encryption_detail': 'Viestit on suojattu tässä keskustelussa.',
  'messenger_v2.info.starred_empty': 'Ei tähdellä merkittyjä viestejä vielä.',
  'messenger_v2.info.member': 'Jäsen',
  'messenger_v2.info.you_label': '{name} (Sinä)',
  'messenger_v2.info.last_week': 'Viime viikko',
  'messenger_v2.info.this_month': 'Tämä kuukausi',
  'messenger_v2.info.date_unknown': 'Aiemmin',
  'messenger_v2.composer.add_note': 'Lisää muistiinpano',
  'messenger_v2.composer.add_more_attachments': 'Lisää liitteitä',
  'messenger_v2.composer.open_attachments': 'Avaa liitteet',
  'messenger_v2.composer.send': 'Lähetä',
  'messenger_v2.composer.sending': 'Lähetetään',
  'messenger_v2.composer.draft': 'Luonnos',
  'messenger_v2.voice.record': 'Nauhoita ääniviesti',
  'messenger_v2.voice.recording': 'Nauhoitetaan ääniviestiä',
  'messenger_v2.voice.recording_preview': 'Nauhoitetaan ääniviestiä...',
  'messenger_v2.voice.paused': 'Äänitallennus on keskeytetty',
  'messenger_v2.voice.ready': 'Ääniviesti on valmis',
  'messenger_v2.voice.sending': 'Lähetetään ääniviestiä',
  'messenger_v2.voice.pause': 'Keskeytä tallennus',
  'messenger_v2.voice.pause_short': 'Tauko',
  'messenger_v2.voice.resume': 'Jatka tallennusta',
  'messenger_v2.voice.resume_short': 'Jatka',
  'messenger_v2.voice.cancel': 'Poista äänitallennus',
  'messenger_v2.voice.send': 'Lähetä ääniviesti',
  'messenger_v2.voice.unsupported': 'Selain ei tue äänitallennusta.',
  'messenger_v2.voice.permission_denied':
    'Mikrofonin käyttö estettiin. Salli mikrofoni ja yritä uudelleen.',
  'messenger_v2.voice.microphone_unavailable': 'Käytettävissä olevaa mikrofonia ei löytynyt.',
  'messenger_v2.voice.too_short': 'Ääniviesti on liian lyhyt. Nauhoita uudelleen.',
  'messenger_v2.voice.send_failed':
    'Ääniviestiä ei voitu asettaa jonoon. Yritä uudelleen painamalla lähetä.',
  'messenger_v2.voice.recording_failed': 'Ääniviestiä ei voitu tallentaa.',
  'messenger_v2.voice.retry_playback': 'Yritä toistaa ääniviesti uudelleen',
  'messenger_v2.voice.pause_playback': 'Keskeytä ääniviesti',
  'messenger_v2.voice.play': 'Toista ääniviesti',
  'messenger_v2.voice.seek': 'Siirry ääniviestissä',
  'messenger_v2.voice.uploading': 'Ladataan {progress} %',
  'messenger_v2.voice.speed': 'Toistonopeus {rate}x',
  'messenger_v2.composer.send_attachments': 'Lähetä liitteet',
  'messenger_v2.composer.sending_attachments': 'Lähetetään liitteitä',
  'messenger_v2.composer.file': 'Tiedosto',
  'messenger_v2.composer.image_or_video': 'Kuva tai video',
  'messenger_v2.composer.document': 'Asiakirja',
  'messenger_v2.composer.preview_unavailable':
    'Esikatselu ei ole saatavilla. Voit silti lähettää pelkän linkin.',
  'messenger_v2.link_preview.error': 'Linkin esikatselu ei ole saatavilla.',
  'messenger_v2.link_preview.remove': 'Poista linkin esikatselu',
  'messenger_v2.attachment.image': 'Kuva',
  'messenger_v2.attachment.video': 'Video',
  'messenger_v2.attachment.audio': 'Ääni',
  'messenger_v2.attachment.document': 'Asiakirja',
  'messenger_v2.attachment.file': 'Tiedosto',
  'messenger_v2.attachment.file_upper': 'TIEDOSTO',
  'messenger_v2.attachment.attachment': 'Liite',
  'messenger_v2.attachment.fallback_name': 'Liite {index}',
  'messenger_v2.attachment.attachments_selected': '{count} liitettä valittu',
  'messenger_v2.attachment.add_attachments': 'Lisää liitteitä',
  'messenger_v2.attachment.edit_image': 'Muokkaa kuvaa',
  'messenger_v2.attachment.prepare_failed':
    'Muokattua liitettä ei voitu valmistella. Muutoksesi ovat yhä tallessa – yritä uudelleen.',
  'messenger_v2.attachment.edit_render_failed':
    'Muokattua kuvaa ei voitu muodostaa. Muutoksesi ovat yhä tallessa – yritä uudelleen.',
  'messenger_v2.attachment.encryption_failed':
    'Liitettä ei voitu salata tällä laitteella. Yritä uudelleen.',
  'messenger_v2.attachment.storage_warning':
    'Laitteen tallennustila on täynnä. Pidä sovellus auki liitteiden lähetyksen ajan.',
  'messenger_v2.attachment.upload_failed':
    'Suojattu lähetys keskeytyi. Tarkista yhteys ja yritä uudelleen.',
  'messenger_v2.attachment.send_failed':
    'Liitteitä ei voitu lisätä jonoon. Muutoksesi ovat yhä tallessa – yritä uudelleen.',
  'messenger_v2.attachment.preparing_progress': 'Valmistellaan liitteitä ({completed}/{total})',
  'messenger_v2.image_editor.close': 'Takaisin',
  'messenger_v2.image_editor.crop': 'Rajaa',
  'messenger_v2.image_editor.done': 'Valmis',
  'messenger_v2.image_editor.draw': 'Piirrä',
  'messenger_v2.image_editor.emoji': 'Emoji',
  'messenger_v2.image_editor.redo': 'Tee uudelleen',
  'messenger_v2.image_editor.text': 'Teksti',
  'messenger_v2.image_editor.title': 'Muokkaa kuvaa',
  'messenger_v2.image_editor.undo': 'Kumoa',
  'messenger_v2.attachment.drop_files_here': 'Pudota tiedostot tähän',
  'messenger_v2.attachment.drop_files_hint': 'Ne lisätään liiteluonnokseesi.',
  'messenger_v2.attachment.no_attachments_selected_title': 'Liitteitä ei ole vielä valittu',
  'messenger_v2.attachment.no_attachments_selected_text':
    'Valitse tiedostoja liitevalikosta aloittaaksesi luonnoksen.',
  'messenger_v2.attachment.no_files_selected_title': 'Tiedostoja ei ole vielä valittu',
  'messenger_v2.attachment.no_files_selected_text':
    'Valitse kuvia, videoita, asiakirjoja tai muita tiedostoja viestiluonnokseen.',
  'messenger_v2.attachment.preview_unavailable': 'Esikatselu ei ole saatavilla',
  'messenger_v2.attachment.unable_open': 'Tätä liitettä ei voitu avata. Yritä uudelleen.',
  'messenger_v2.attachment.unable_download': 'Tätä liitettä ei voitu ladata. Yritä uudelleen.',
  'messenger_v2.attachment.no_selected': 'Liitettä ei ole valittu',
  'messenger_v2.attachment.play_video_preview': 'Toista videon esikatselu',
  'messenger_v2.attachment.close_composer': 'Sulje liitteiden luonti',
  'messenger_v2.attachment.close_preview': 'Sulje liitteen esikatselu',
  'messenger_v2.attachment.previous': 'Edellinen liite',
  'messenger_v2.attachment.next': 'Seuraava liite',
  'messenger_v2.attachment.previous_selected': 'Näytä edellinen valittu liite',
  'messenger_v2.attachment.next_selected': 'Näytä seuraava valittu liite',
  'messenger_v2.attachment.scroll_left': 'Vieritä liitteitä vasemmalle',
  'messenger_v2.attachment.scroll_right': 'Vieritä liitteitä oikealle',
  'messenger_v2.attachment.scroll_selected_left': 'Vieritä valittuja liitteitä vasemmalle',
  'messenger_v2.attachment.scroll_selected_right': 'Vieritä valittuja liitteitä oikealle',
  'messenger_v2.attachment.remove': 'Poista {name}',
  'messenger_v2.attachment.open': 'Avaa {name}',
  'messenger_v2.attachment.view': 'Näytä {name}',
  'messenger_v2.attachment.download': 'Lataa {name}',
  'messenger_v2.attachment.download_action': 'Lataa',
  'messenger_v2.attachment.zoom_in': 'Lähennä kuvaa',
  'messenger_v2.attachment.reset_zoom': 'Palauta kuvan zoomaus',
  'messenger_v2.attachment.uploading': 'Ladataan {name}',
  'messenger_v2.call.audio': 'Ääni',
  'messenger_v2.call.remote_audio': 'Puhelun ääni',
  'messenger_v2.call.video': 'Video',
  'messenger_v2.call.start_voice': 'Aloita äänipuhelu',
  'messenger_v2.call.start_video': 'Aloita videopuhelu',
  'messenger_v2.call.direct_only': 'Puhelut ovat käytettävissä suorissa salatuissa keskusteluissa.',
  'messenger_v2.call.group_needs_members': 'Lisää toinen jäsen aloittaaksesi ryhmäpuhelun.',
  'messenger_v2.call.unavailable': 'Puhelut eivät ole käytettävissä tässä chatissa.',
  'messenger_v2.call.blocked_unavailable': 'Puhelut eivät ole käytettävissä tässä chatissa.',
  'messenger_v2.call.start_failed': 'Äänipuhelua ei voitu aloittaa.',
  'messenger_v2.call.start_video_failed': 'Videopuhelua ei voitu aloittaa.',
  'messenger_v2.call.recipient_device_unavailable':
    'Vastaanottajan täytyy avata Verkkohauta Chat laitteellaan ennen salattua puhelua.',
  'messenger_v2.call.accept_failed': 'Äänipuheluun ei voitu vastata.',
  'messenger_v2.call.incoming': 'Saapuva äänipuhelu',
  'messenger_v2.call.incoming_video': 'Saapuva videopuhelu',
  'messenger_v2.call.calling': 'Soitetaan...',
  'messenger_v2.call.ringing': 'Soi...',
  'messenger_v2.call.connecting': 'Yhdistetään...',
  'messenger_v2.call.reconnecting': 'Yhdistetään uudelleen...',
  'messenger_v2.call.active': 'Äänipuhelu',
  'messenger_v2.call.active_video': 'Videopuhelu',
  'messenger_v2.call.accept': 'Vastaa puheluun',
  'messenger_v2.call.decline': 'Hylkää puhelu',
  'messenger_v2.call.open': 'Avaa',
  'messenger_v2.call.join': 'Liity',
  'messenger_v2.call.ignore': 'Ohita',
  'messenger_v2.call.minimize': 'Pienennä puhelu',
  'messenger_v2.call.encrypted': 'Päästä päähän salattu',
  'messenger_v2.call.open_chat': 'Avaa keskustelu',
  'messenger_v2.call.change_audio_output': 'Vaihda äänilähtö',
  'messenger_v2.call.mute': 'Mykistä',
  'messenger_v2.call.unmute': 'Poista mykistys',
  'messenger_v2.call.camera_on': 'Ota kamera käyttöön',
  'messenger_v2.call.camera_off': 'Poista kamera käytöstä',
  'messenger_v2.call.background_blur_on': 'Sumenna tausta',
  'messenger_v2.call.background_blur_off': 'Poista taustan sumennus',
  'messenger_v2.call.background_blur_failed': 'Taustan sumennusta ei voitu muuttaa.',
  'messenger_v2.call.enter_fullscreen': 'Näytä koko näytössä',
  'messenger_v2.call.exit_fullscreen': 'Poistu koko näytöstä',
  'messenger_v2.call.end': 'Lopeta puhelu',
  'messenger_v2.call.participant': 'Osallistuja',
  'messenger_v2.call.you_label': '{name} (sinä)',
  'messenger_v2.call.pin_participant': 'Kiinnitä {name}',
  'messenger_v2.call.unpin_participant': 'Poista käyttäjän {name} kiinnitys',
  'messenger_v2.call.screen_sharing': 'Näytön jakaminen',
  'messenger_v2.call.peer_muted': '{name} mykisti tämän puhelun',
  'messenger_v2.call.you_muted': 'Mykistit tämän puhelun',
  'messenger_v2.call.history_call': 'Äänipuhelu',
  'messenger_v2.call.history_video_call': 'Videopuhelu',
  'messenger_v2.call.history_group_call': 'Ryhmäpuhelu',
  'messenger_v2.call.history_group_video_call': 'Ryhmävideopuhelu',
  'messenger_v2.call.history_participants': '{count} jäsentä',
  'messenger_v2.call.members_title': 'Puhelun jäsenet',
  'messenger_v2.call.history_missed': 'Vastaamaton äänipuhelu',
  'messenger_v2.call.history_video_missed': 'Vastaamaton videopuhelu',
  'messenger_v2.call.history_declined': 'Äänipuhelu hylätty',
  'messenger_v2.call.history_video_declined': 'Videopuhelu hylätty',
  'messenger_v2.call.history_cancelled': 'Äänipuhelu peruutettu',
  'messenger_v2.call.history_video_cancelled': 'Videopuhelu peruutettu',
  'messenger_v2.call.history_failed': 'Äänipuhelu epäonnistui',
  'messenger_v2.call.history_video_failed': 'Videopuhelu epäonnistui',
  'messenger_v2.call.duration_seconds': '{seconds} s',
  'messenger_v2.call.duration_minutes': '{minutes} min',
  'messenger_v2.call.duration_minutes_seconds': '{minutes} min {seconds} s',
  'messenger_v2.call.duration_hours': '{hours} h',
  'messenger_v2.call.duration_hours_minutes': '{hours} h {minutes} min',
  'messenger_v2.discard.title': 'Hylätäänkö muutokset?',
  'messenger_v2.discard.content': 'Haluatko varmasti hylätä muutoksesi?',
  'messenger_v2.discard.confirm': 'Hylkää',
  'messenger_v2.discard.cancel': 'Jatka muokkaamista',
  'emojiPicker.emojiPicker': 'Emojivalitsin',
  'emojiPicker.reactionPicker': 'Reaktiovalitsin',
  'emojiPicker.searchEmoji': 'Etsi emojia',
  'emojiPicker.searchReactions': 'Etsi reaktioita',
  'emojiPicker.findEmoji': 'Löydä täydellinen emoji',
  'emojiPicker.findReaction': 'Löydä täydellinen reaktio',
  'emojiPicker.categories': 'Emojiluokat',
  'emojiPicker.category.frequent': 'Usein käytetyt',
  'emojiPicker.category.smileys': 'Hymiöt ja tunteet',
  'emojiPicker.category.people': 'Ihmiset ja keho',
  'emojiPicker.category.animals': 'Eläimet ja luonto',
  'emojiPicker.category.food': 'Ruoka ja juoma',
  'emojiPicker.category.travel': 'Matkailu ja paikat',
  'emojiPicker.category.activities': 'Aktiviteetit',
  'emojiPicker.category.objects': 'Esineet',
  'emojiPicker.category.symbols': 'Symbolit',
  'emojiPicker.category.flags': 'Liput',
  'emojiPicker.searchResults': 'Hakutulokset',
  'emojiPicker.noResults': 'Hakua vastaavia emojeja ei löytynyt.',
  'emojiPicker.noFrequentlyUsed': 'Usein käyttämäsi emojit näkyvät täällä.',
  'emojiPicker.skinTone': 'Ihonsävy',
  'emojiPicker.skinTone.default': 'Oletusihonsävy',
  'emojiPicker.skinTone.light': 'Vaalea ihonsävy',
  'emojiPicker.skinTone.mediumLight': 'Keskivaalea ihonsävy',
  'emojiPicker.skinTone.medium': 'Keskisävyinen ihonsävy',
  'emojiPicker.skinTone.mediumDark': 'Keskitumma ihonsävy',
  'emojiPicker.skinTone.dark': 'Tumma ihonsävy',
  'messenger_v2.composer.choose_emoji': 'Valitse emoji',
  'messenger_v2.message.add_reaction': 'Lisää reaktio',
  'pwa.onboarding.install_title': 'Asenna Nettgrav',
  'pwa.onboarding.install_body':
    'Pidä Nettgrav yhden napautuksen päässä ja saat luotettavamman sovelluskokemuksen tällä laitteella.',
  'pwa.onboarding.install_action': 'Asenna Nettgrav',
  'pwa.onboarding.install_manual_action': 'Ymmärrän',
  'pwa.onboarding.not_now': 'Ei nyt',
  'pwa.onboarding.benefit_messages': 'Viestien taustailmoitukset',
  'pwa.onboarding.benefit_calls': 'Saapuvien puhelujen ilmoitukset',
  'pwa.onboarding.benefit_badge': 'Lukemattomien määrä sovelluskuvakkeessa',
  'pwa.onboarding.ios_steps':
    'Napauta selaimen Jaa-painiketta, valitse Lisää Koti-valikkoon ja avaa Nettgrav uudesta kuvakkeesta.',
  'pwa.onboarding.mac_steps':
    'Valitse Safarissa Arkisto → Lisää Dockiin ja avaa sitten Nettgrav Dockista tai Ohjelmat-kansiosta.',
  'pwa.onboarding.notifications_title': 'Älä koskaan menetä viestiä tai puhelua',
  'pwa.onboarding.notifications_body':
    'Salli Nettgravin ilmoittaa uusista salatuista viesteistä ja saapuvista puheluista, vaikka sovellus olisi suljettu.',
  'pwa.onboarding.notifications_action': 'Salli ilmoitukset',
  'pwa.onboarding.notifications_denied':
    'Ilmoitukset on estetty. Ota ne käyttöön Nettgraville selaimen tai laitteen ilmoitusasetuksissa ja yritä uudelleen.',
  'rooms.invite.auth_required': 'Kirjaudu sisään tai luo tili nähdäksesi huonekutsun.',
  'rooms.invite.back': 'Takaisin huoneisiin',
  'rooms.invite.fail': 'Kutsu on virheellinen tai vanhentunut.',
  'rooms.invite.join': 'Liity huoneeseen',
  'rooms.invite.label': 'Huonekutsu',
  'rooms.invite.loading': 'Ladataan kutsua...',
  'rooms.invite.member_count': '{count, plural, one {# jäsen} other {# jäsentä}}',
  'rooms.invite.title': 'Huonekutsu',
  'rooms.invite.view': 'Näytä huone',
  'rooms.navigation.label': 'Huoneen osiot',
  'rooms.state.archived': 'Tämä huone on arkistoitu.',
  'rooms.state.error': 'Huonetta ei voitu ladata.',
  'rooms.state.loading': 'Ladataan huonetta…',
  'rooms.state.removed': 'Tämä huone on poistettu.',
  'rooms.state.retry': 'Yritä uudelleen',
  'rooms.tabs.members_chat': 'Jäsenchat',
  'rooms.members_chat.title': 'Salattu jäsenchat',
  'rooms.members_chat.description':
    'Yksityinen, päästä päähän salattu keskustelu huoneen aktiivisille jäsenille.',
  'rooms.members_chat.loading': 'Valmistellaan huonechattia…',
  'rooms.members_chat.locked_title': 'Vain jäsenille tarkoitettu keskustelu',
  'rooms.members_chat.locked':
    'Liity huoneeseen avataksesi salatun jäsenchatin. Viestit ja esikatselut pysyvät piilossa, kunnes jäsenyytesi on aktiivinen.',
  'rooms.members_chat.error': 'Jäsenchattia ei voitu ladata.',
  'rooms.state.unavailable': 'Huonetta ei löydy tai sinulla ei ole käyttöoikeutta.',
  'rooms.provisioning.action_required': 'Huonekeskustelu vaatii toimia ennen käyttöä.',
  'rooms.provisioning.pending': 'Huonekeskustelua valmistellaan.',
  'groups.reactions.error': 'Reaktiotasi ei voitu päivittää.',
  'groups.media.uploading': 'Ladataan mediaa…',
  'groups.post.published': 'Julkaistu.',
  retry: 'Yritä uudelleen',
};

export default FIN;
